export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Built-in java.math.BigDecimal */
  BigDecimal: any;
  /** A type representing a Locale such as en_US or fr_FR */
  Locale: any;
  /** A type representing a full protocol, host and path */
  URL: any;
  /** A type representing a formatted java.util.UUID */
  UUID: any;
}




/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  /** Action to pop auth window */
  AUTHWINDOW = 'AUTHWINDOW',
  /** Action to close a dropdown option */
  CLOSE = 'CLOSE',
  /** Action to copy contents to clipboard */
  COPY = 'COPY',
  /** Action to open the date picker */
  DATEPICKER = 'DATEPICKER',
  /** Action to open an external link off */
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  /** Action to display free lx message */
  FREE_LX = 'FREE_LX',
  /** Action to open a link off */
  OPEN = 'OPEN',
  /** Action to display term and conditions */
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}

/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED'
}













export enum ActivityAvailabilityPriceTextTheme {
  POSITIVE = 'POSITIVE'
}


export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}


/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}




export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION'
}













export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES'
}


export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION'
}






export interface ActivityDateRangeInput {
  endDate: DateInput;
  startDate: DateInput;
}


/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: Maybe<CoordinatesInput>;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: Maybe<Scalars['String']>;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: Maybe<Scalars['String']>;
  /** Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** Name of the region, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: Maybe<Scalars['String']>;
}

/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS'
}






export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT'
}













export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS'
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT'
}


















export enum ActivityMapGroupType {
  POI = 'POI'
}



/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: Maybe<Scalars['Int']>;
  /** field which identifies sem channel */
  sem?: Maybe<Scalars['String']>;
  /** field which identifies semdtl value */
  semdtl?: Maybe<Scalars['String']>;
}








/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY'
}







/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: Scalars['String'];
  productToken: Scalars['String'];
}






export interface ActivityOfferFilterInput {
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
  tickets?: Maybe<Array<ActivityTicketInput>>;
}






/** Data used to retrieve details about an activity product */
export interface ActivityOfferNaturalKeyInput {
  /** Offer Product Natural Key for offer entity which uniquely determines bookable offer of activity. This includes, site id, Offer id, Offer dates, offer locale, total travelers selected to uniquely identify an offer */
  offerProductNaturalKey: Scalars['String'];
}













export enum ActivityOfferUdsToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}







/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY'
}


/** Activity Page Type - infosite */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO'
}















/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED'
}






export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS'
}







export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST'
}





/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: Maybe<Scalars['String']>;
  /** Filter results by activity category, supported with legacy categories */
  categories?: Maybe<Array<ActivityCategory>>;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: Maybe<Array<Scalars['String']>>;
  /** Filter results by user provided free text search keyword */
  keyword?: Maybe<Scalars['String']>;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: Maybe<Scalars['String']>;
  /**
   * Value selected by the user
   *     E.g.
   *     1. 'sort':'RECOMMENDED'
   *     2. 'slimSearchKeyword':'<KEYWORD ENTERED BY USER>'
   *     4. 'categories': 'ToursSightseeing'
   */
  selections?: Maybe<Array<ActivitySelectedValueInput>>;
}


/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER'
}




/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  THIRD_PARTY_REVIEWS = 'THIRD_PARTY_REVIEWS',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL'
}





export interface ActivitySelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}





/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}











export enum ActivityTextAlignment {
  CENTRE = 'CENTRE',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}


export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}


export interface ActivityTicketInput {
  code: Scalars['String'];
  count: Scalars['Int'];
}






/** Details of traveler with a specific age. Age will be used to derive the traveler type in package bookings */
export interface ActivityTravelerDetailsInput {
  /** Age of the traveler. Traveler type(adult/infant/youth) can be derived from age */
  age: Scalars['Int'];
  /** Number of travelers with specified age */
  count: Scalars['Int'];
}



export enum ActivityUdsToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT'
}

/** Input to update the activity in the session */
export interface ActivityUpdateInput {
  newActivity: ActivityNaturalKeyInput;
  oldActivity: ActivityNaturalKeyInput;
}


export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: Maybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** RegionCode from residency selection of user */
  regionCode?: Maybe<Scalars['String']>;
  /** The user selection for the Insurance product(s) */
  removeInsuranceProductIds?: Maybe<Array<Scalars['String']>>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId: Scalars['Int'];
}











export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}








export interface AgentQuoteNaturalKeyInput {
  packageRates?: Maybe<Scalars['Boolean']>;
  propertyDestination: Scalars['String'];
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}









/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  /** Localization messages will be replaced with their namespace and loc key. */
  DEBUG = 'DEBUG',
  /** None of the ALTER experiments will be used when resolving localization messages. */
  NONE = 'NONE',
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  PREVIEW = 'PREVIEW',
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  RELEASED = 'RELEASED'
}






export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BARBECUE = 'BARBECUE',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_INCLUDED = 'BREAKFAST_INCLUDED',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FIRE_PLACE = 'FIRE_PLACE',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WASHER = 'WASHER',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE'
}




/** Possible aspect ratios of EGDS images */
export enum AspectRatio {
  /** Aspect ratio 4:3 */
  FOUR_THREE = 'FOUR_THREE',
  /** Aspect ratio 1:1 */
  ONE_ONE = 'ONE_ONE',
  /** Aspect ratio 16:9 */
  SIXTEEN_NINE = 'SIXTEEN_NINE',
  /** Aspect ratio 3:4 */
  THREE_FOUR = 'THREE_FOUR',
  /** Aspect ratio 3:2 */
  THREE_TWO = 'THREE_TWO',
  /** Aspect ratio 21:9 */
  TWENTY_ONE_NINE = 'TWENTY_ONE_NINE'
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}





export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  LOCAL_OFFER = 'LOCAL_OFFER',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE'
}











export enum BooleanEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE'
}


/** Type used during a product search to specify a given boolean value like the fact customer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: Scalars['String'];
  value: Scalars['Boolean'];
}










/** Represents the base product price */
export interface BrandedDealProductPriceInput {
  base: MoneyInput;
  taxesAndFees: MoneyInput;
}

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export interface CdfFeedbackInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}











export enum CdfPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}











export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT'
}


export interface CampaignParametersInput {
  campaignId: Scalars['String'];
  contentPagination?: Maybe<ContentPaginationInput>;
  propertyParameters?: Maybe<CampaignPropertyParametersInput>;
}

export enum CampaignProductType {
  ACTIVITY = 'ACTIVITY',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE'
}

export interface CampaignPropertyParametersInput {
  guestRating?: Maybe<Scalars['Float']>;
  propertyId: Scalars['String'];
  starRating?: Maybe<Scalars['Float']>;
  type?: Maybe<PropertyDetailsPropertyType>;
}



export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED'
}


export enum CarActionType {
  /** Apply loyalty points to offer */
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  /** Click map marker */
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  /** Change Search */
  CHANGE_SEARCH = 'CHANGE_SEARCH',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Click to filter car sales */
  FILTER_SALE_OFFER = 'FILTER_SALE_OFFER',
  /** Submit content to server */
  FORM_SUBMISSION = 'FORM_SUBMISSION',
  /** Go back to search page to see all cars */
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  /** Open cancellation policy link */
  GO_TO_CANCELLATION_POLICY = 'GO_TO_CANCELLATION_POLICY',
  /** Continues to the standalone details page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Open dialog to see cleaning and safety practices */
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Open recommended sort FAQ page */
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  /** Continues to the user sign in page */
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  /** Continues to the user sign up page */
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  /** Load more results to search page */
  LOAD_MORE = 'LOAD_MORE',
  /** Opens a dialog */
  OPEN_DIALOG = 'OPEN_DIALOG',
  /** Open merchant rules in iframe */
  OPEN_DOC = 'OPEN_DOC',
  /** Opens the inline time wizard */
  OPEN_INLINE_TIME_WIZARD = 'OPEN_INLINE_TIME_WIZARD',
  /** Opens the inline search wizard */
  OPEN_INLINE_WIZARD = 'OPEN_INLINE_WIZARD',
  /** Opens a new tab */
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  /** Opens on current tab */
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  /** Open vendor rules from domain rules */
  OPEN_RULE = 'OPEN_RULE',
  /** Used to open Telephone Link */
  OPEN_TEL = 'OPEN_TEL',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Remove loyalty points to offer */
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  /** Click see cars on map marker item card */
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  /** Open share feedback form */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Show offers with AARP Exclusive benefits */
  SHOW_AARP_EXCLUSIVE_OFFERS = 'SHOW_AARP_EXCLUSIVE_OFFERS',
  /** Show offers with free cancellations */
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  /** Click to unlock car sales */
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES',
  /** Click to unlock car sales by clicking on unlock offer */
  UNLOCK_SALE_OFFER = 'UNLOCK_SALE_OFFER'
}











export interface CarDetailContextInput {
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars['String']>;
  principalToken?: Maybe<Scalars['String']>;
  rewardPointsSelection?: Maybe<RewardsPointSelectionEnum>;
  selectedAccessories?: Maybe<Array<Scalars['String']>>;
}








export enum CarFormatStyle {
  IFRAME = 'IFRAME',
  LIST = 'LIST'
}







export enum CarLabelTheme {
  CLICKABLE = 'CLICKABLE'
}








export enum CarMapMarkerType {
  CARMARKER = 'CarMarker',
  PLACEMARKER = 'PlaceMarker'
}






/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: Scalars['String'];
  specialEquipments?: Maybe<Array<SpecialEquipment>>;
}




























/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: Maybe<Scalars['String']>;
  coordinates?: Maybe<CoordinatesInput>;
  regionId?: Maybe<Scalars['String']>;
  searchTerm?: Maybe<Scalars['String']>;
}





export enum CarRouteType {
  ONEWAY = 'ONEWAY',
  ROUNDTRIP = 'ROUNDTRIP'
}


export interface CarRulesAndRestrictionsCriteriaInput {
  carOfferToken: Scalars['String'];
}




/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}





























/** Enum class to represent the type of carry on bag */
export enum CarryOnBagType {
  CARRY_ON_BAG = 'CARRY_ON_BAG'
}




export enum CarsDialogType {
  LIMITED_RESULTS = 'LIMITED_RESULTS'
}

export interface CarsDomainRequestContextInput {
  partnerContext: PartnerContextInput;
  principalJWT: Scalars['String'];
}



export enum CarsRichTextStyle {
  BOLD = 'BOLD',
  BULLET = 'BULLET',
  ITALICIZE = 'ITALICIZE'
}






/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}


export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: Scalars['String'];
  /** The list of rooms that user searched for */
  rooms: Array<PropertyRoomInput>;
}


export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS'
}







/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING'
}

/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT'
}

/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION'
}


/** Supported capabilities of chatbot VAC. */
export enum ChatbotCapabilities {
  CLICKSTREAM = 'CLICKSTREAM',
  GLASSBOX = 'GLASSBOX'
}




/** Key-Value pair of intent attributes for chatbot initialization example itineraryNumber, orderLineId */
export interface ChatbotIntentValueInput {
  /** Key to define intent attributes for chatbot initialization example itineraryNumber, orderLineId */
  id: Scalars['String'];
  /** Value for intent attributes for chatbot initialization example of attributes itineraryNumber, orderLineId */
  value: Scalars['String'];
}


/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2'
}



export interface CheckoutDomainInfoInput {
  name: Scalars['String'];
  refId: Scalars['String'];
}




/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;
  value: Scalars['String'];
}

/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  HOTEL_BUSINESS_MODEL = 'HOTEL_BUSINESS_MODEL',
  HOTEL_MARKETING_CHANNEL = 'HOTEL_MARKETING_CHANNEL',
  META_DEEPLINK = 'META_DEEPLINK',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}




export interface CheckoutSessionInfoInput {
  sessionId: Scalars['UUID'];
  sessionToken: Scalars['UUID'];
}



/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: Scalars['Int'];
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING'
}






/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: Scalars['String'];
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: Maybe<Scalars['String']>;
}


/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: Array<HttpHeaderInput>;
  /** Remote address of HTTP Request */
  remoteAddress: Scalars['String'];
  /** URL of HTTP Request */
  url: Scalars['String'];
}
















export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS'
}


/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA'
}

/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export enum ContainerTheme {
  DEFAULT = 'DEFAULT',
  IMPORTANT = 'IMPORTANT'
}


export interface ContentPaginationInput {
  pageNumber: Scalars['Int'];
  pageSize?: Maybe<Scalars['Int']>;
}


/** The input BEX context used for identifying users, sites and other platform functions. See the platform-expsite docs for more info: https://docweb.prod.expedia.com/expsite */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: Maybe<ClientInfoInput>;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: Maybe<Scalars['String']>;
  /** Debugging context, such as Abacus overrides */
  debugContext?: Maybe<DebugContextInput>;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: Maybe<Scalars['Int']>;
  /**
   * DEPRECATED: Optional Client/user information. Used for input only. Please send the DUIAD header instead.
   * We no longer rely on identity for user determination.
   * User determination is now based upon passed headers. Soon this will be made nullable and later removed.
   * Will be replaced by JWTs when available.
   */
  identity?: Maybe<IdentityInput>;
  /** The context locale, e.g. en_US */
  locale: Scalars['Locale'];
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: Scalars['Int'];
  /** The legacy TravelProductID */
  tpid?: Maybe<Scalars['Int']>;
}





/** A latitude/longitude pair */
export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: Scalars['Float'];
  /** The longitude of the point in degrees */
  longitude: Scalars['Float'];
}
























/** Enum class to represent the type of credit eligible filter */
export enum CreditEligibleFilterType {
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE'
}






export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}



/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: Scalars['String'];
  /** The continent code of User's current location. ex: NA */
  continent: Scalars['String'];
  /** The country code of User's current location. ex: US */
  country: Scalars['String'];
  /** The region or state code of User's current location. ex: CA */
  region: Scalars['String'];
}



export enum CruiseBadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}





export enum CruiseFeature {
  MEMBER_DEALS = 'MEMBER_DEALS'
}

export enum CruiseFilterType {
  /** cabin experience - eg. Suite  */
  CABIN = 'CABIN',
  /** departure port */
  DEPARTURE = 'DEPARTURE',
  /** use for filtering by the destination */
  DESTINATION = 'DESTINATION',
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  LENGTH = 'LENGTH',
  /** use for filtering by the cruise line name */
  NAME = 'NAME',
  /** default not set value */
  NOT_SET = 'NOT_SET',
  /** ship type */
  SHIP = 'SHIP',
  /** use for ocean cruise */
  THEME_OCEAN = 'THEME_OCEAN',
  /** use for river cruise */
  THEME_RIVER = 'THEME_RIVER'
}
















export interface CruiseRequestContextInput {
  /** Cruise features enum to be passed down to cruise supply services as a header value */
  cruiseFeatures?: Maybe<Array<CruiseFeature>>;
  /** Default current to be used. If not set, cruise api will fall back to USD */
  defaultCurrency?: Maybe<Scalars['String']>;
  /** Inventory is striped by an optional franchise model key. More info here: https://confluence.expedia.biz/display/EWECruise/Design%3A+Franchise+Model+Key+Management */
  franchiseModelKey?: Maybe<Scalars['String']>;
  /** Flag that is set when the user is shopping as an agent from Partner Central */
  isAgent?: Maybe<Scalars['Boolean']>;
}



export interface CruiseSearchFiltersInput {
  /** 1 or more cruise line codes separated by '|' delimiter  */
  cruiseLines?: Maybe<Scalars['String']>;
  /** 1 or more port codes separated by '|' delimiter  */
  departureLocations?: Maybe<Scalars['String']>;
  /** 1 or more deeplink destination names separated by '|' delimiter  */
  destinationNames?: Maybe<Scalars['String']>;
  /** CruiseFilterType enum name to describe the primary function of the SearchFilter */
  filterType: CruiseFilterType;
  /** 1 or more promotion codes separated by '|' delimiter  */
  promotionCode?: Maybe<Scalars['String']>;
  /** ocean or river */
  sailingVarieties?: Maybe<Scalars['String']>;
  /** 1 or more ship codes separated by '|' delimiter  */
  ships?: Maybe<Scalars['String']>;
}


export interface CruiseSearchOptionsInput {
  /** Number of adults - Default is 2 */
  adultCount: Scalars['Int'];
  /** Number of children - Default is 0 */
  childCount: Scalars['Int'];
  /** Limit of how many results will be returned. - Default is 20 */
  limit: Scalars['Int'];
  /**
   * Values : popularity - sorts by Popularity
   * price - sorts by the offer price within all sailings returned
   * length - sorts by the sailing itinerary length, in days
   * departureDate - sorts by sailing departure/embarkation date
   * cruiseLine - sorts by cruise line name
   */
  sortBy?: Maybe<Scalars['String']>;
}













/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}











/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}




/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}



/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum CustomerNotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}


/** Represents the attributes on a notification that could be changed after an interaction */
export interface CustomerNotificationModifiableAttributesInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars['Boolean']>;
  /** Notification id */
  id?: Maybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is starred */
  star?: Maybe<Scalars['Boolean']>;
}

/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<CustomerNotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars['URL']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
  /** list of GAIA regionIds */
  regionIds?: Maybe<Array<Scalars['String']>>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: Maybe<CustomerNotificationOptionalContextJourneyCriteriaLocationInput>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars['String']>;
  /** property id */
  propertyId?: Maybe<Scalars['String']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
}



/** The style to apply to phrase links */
export enum CustomerNotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}


/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}








export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  GDPR = 'GDPR',
  GENERIC = 'GENERIC',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  OSANO = 'OSANO',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}

/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<CustomerNotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}





export enum DamageLiability {
  COF = 'COF',
  RDD = 'RDD'
}

export enum DashboardType {
  DEFERRED_PAYMENT = 'DEFERRED_PAYMENT',
  PERFORMANCE = 'PERFORMANCE'
}



/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: Scalars['Int'];
  /** The numeric month, e.g. `1` for January */
  month: Scalars['Int'];
  /** The four-digit year e.g. `1999` */
  year: Scalars['Int'];
}



export enum DatePickerMode {
  DOUBLE_DATE_SELECT_MODE = 'DOUBLE_DATE_SELECT_MODE',
  SINGLE_DATE_SELECT_MODE = 'SINGLE_DATE_SELECT_MODE'
}

export enum DatePickerOption {
  BUTTON_SUBTEXT_SHOW_NIGHTS = 'BUTTON_SUBTEXT_SHOW_NIGHTS'
}


/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}


/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: Scalars['Int'];
  /** The hour of the datetime */
  hour: Scalars['Int'];
  /** The minute of the hour */
  minute: Scalars['Int'];
  /** The numeric month of the date */
  month: Scalars['Int'];
  /** The second of the minute */
  second: Scalars['Int'];
  /** The four-digit year of the date */
  year: Scalars['Int'];
}




/** Type used during a product search to specify a given date. Usually this date would not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: Scalars['String'];
  value: DateInput;
}

export enum DealType {
  AARP = 'AARP',
  POINTS_PROMOTION = 'POINTS_PROMOTION'
}


/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: Array<ExposureInput>;
  /** ALTER mode */
  alterMode?: Maybe<AlterMode>;
}

















export interface DestinationImageDimensionsInput {
  height: Scalars['Int'];
  width: Scalars['Int'];
}

/** Contains detailed geographic information like the Gaia region id as well as the property ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: Maybe<CoordinatesInput>;
  /** List of coordinates of the map's bounding box. */
  mapBounds?: Maybe<Array<CoordinatesInput>>;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: Maybe<Scalars['String']>;
  /** List of property IDs to return search information for. */
  propertyIds?: Maybe<Array<Scalars['String']>>;
  /** The Gaia region ID of the search */
  regionId?: Maybe<Scalars['String']>;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: Maybe<Scalars['String']>;
}






/** Device information */
export interface DeviceInput {
  type: DeviceType;
}

/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}




/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: Scalars['Float'];
  height: Scalars['Float'];
  width: Scalars['Float'];
}











export enum DirectFeedbackPageDisplayConditionType {
  BOOL = 'BOOL',
  NONE = 'NONE',
  PATTERN = 'PATTERN',
  TEXT = 'TEXT'
}






export interface DirectFeedbackValuesInput {
  context: Array<GraphQlPairInput>;
  formValues: Array<GraphQlPairInput>;
}





/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE'
}





















/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export enum EgdsButtonStyle {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}



/** Defines how checkbox state should be displayed on client. */
export enum EgdsCheckBoxState {
  CHECKED = 'CHECKED',
  INDETERMINATE = 'INDETERMINATE',
  UNCHECKED = 'UNCHECKED'
}









/** Represents short day name. */
export enum EgdsDayName {
  FRI = 'FRI',
  MON = 'MON',
  SAT = 'SAT',
  SUN = 'SUN',
  THU = 'THU',
  TUE = 'TUE',
  WED = 'WED'
}

















/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsHeadingStyle {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  H7 = 'H7',
  H8 = 'H8'
}

/** Represents where the icon should be places in a EGDS Standard Link */
export enum EgdsIconPosition {
  LEADING = 'LEADING',
  TRAILING = 'TRAILING'
}




/** Option for selecting an infant seat on a plane. */
export enum EgdsInfantSeat {
  IN_SEAT = 'IN_SEAT',
  ON_LAP = 'ON_LAP'
}








/** Represents the size of the text in a EGDS Standard Link */
export enum EgdsLinkSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}






/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export enum EgdsMapPositionMode {
  FIT_BOUNDS = 'FIT_BOUNDS',
  ZOOM_AND_CENTER = 'ZOOM_AND_CENTER'
}

/** type of maps that can be used */
export enum EgdsMapProvider {
  GOOGLE = 'GOOGLE',
  MAPBOX = 'MAPBOX'
}










/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export enum EgdsParagraphStyle {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}


















































export enum EgdsTextListItemStyle {
  DEFAULT = 'DEFAULT',
  EMPHASIS = 'EMPHASIS',
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}


/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export enum EgdsTextListSize {
  LIST_1 = 'LIST_1',
  LIST_2 = 'LIST_2',
  LIST_3 = 'LIST_3'
}














/** Represents different type of travelers validation. */
export enum EgdsTravelersValidationType {
  /** Used to validate child age required. */
  CHILD_AGE_REQUIRED = 'CHILD_AGE_REQUIRED',
  /** Used to validate maximum number of allowed infants in seat. */
  MANY_INFANT_IN_SEAT = 'MANY_INFANT_IN_SEAT',
  /** Used to validate maximum number of allowed infants on lap. */
  MANY_INFANT_ON_LAP = 'MANY_INFANT_ON_LAP',
  /** Used to validate maximum allowed travelers for search. */
  MAX_TRAVELERS = 'MAX_TRAVELERS'
}


/** Defines how typeahead results should be displayed on client. */
export enum EgdsTypeaheadRenderType {
  ADAPTIVE = 'ADAPTIVE',
  DIALOG = 'DIALOG',
  MENU = 'MENU'
}









/** Type of content UI needs to render */
export enum EnumContentType {
  EGDSPLAINTEXT = 'EGDSPlainText'
}


export enum EventType {
  ITINACTIVECAR = 'ItinActiveCar',
  ITINACTIVECRUISE = 'ItinActiveCruise',
  ITINACTIVEFLIGHT = 'ItinActiveFlight',
  ITINACTIVEGT = 'ItinActiveGT',
  ITINACTIVEHOTEL = 'ItinActiveHotel',
  ITINACTIVELX = 'ItinActiveLX',
  ITINACTIVEPACKAGEFH = 'ItinActivePackageFH',
  ITINACTIVERAIL = 'ItinActiveRail',
  ITINCANCELLATION = 'ItinCancellation',
  TRIPSFLIGHTSCHEDULECHANGEBANNERDISPLAYED = 'TripsFlightScheduleChangeBannerDisplayed',
  TRIPSHEROMODULECURRENTTRIP = 'TripsHeroModuleCurrentTrip',
  TRIPSHEROMODULEPOTENTIALTRIP = 'TripsHeroModulePotentialTrip',
  TRIPSHEROMODULEUPCOMINGTRIP = 'TripsHeroModuleUpcomingTrip',
  TRIPSITEMDETAILVIEWED = 'TripsItemDetailViewed',
  TRIPSLISTVIEWED = 'TripsListViewed',
  TRIPSMODULEDESTINATIONGUIDE = 'TripsModuleDestinationGuide',
  TRIPSOVERVIEWVIEWED = 'TripsOverviewViewed',
  TRIPSTRAVELPLANNERITINNUMBERPRESENT = 'TripsTravelPlannerItinNumberPresent',
  UNKNOWN = 'Unknown'
}



export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}



/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: Scalars['Int'];
  /** The numeric Abacus ID for an experiment */
  id: Scalars['String'];
}
















export enum FeeType {
  CARD_ON_FILE_DAMAGE_LIABILITY = 'CARD_ON_FILE_DAMAGE_LIABILITY',
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT'
}







/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}

/** Enum class to represent the type of travel and baggage */
export enum FilterTravelAndBaggageType {
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  FIRST_CHECKED_BAG = 'FIRST_CHECKED_BAG',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}









export enum FlightCabinClassInfo {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}


/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL'
}






/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: Scalars['String'];
  productTokens: Array<Scalars['String']>;
  travelers: Array<TravelerDetailsInput>;
}




/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}















/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  PRIMARY = 'PRIMARY',
  /** Radio Button. Example: To choose seats for a particular traveler */
  RADIO_BUTTON = 'RADIO_BUTTON',
  /** Secondary action. */
  SECONDARY = 'SECONDARY',
  /** Switch toggle action. Example: price alerts subscription toggle */
  SWITCH = 'SWITCH',
  /** Tertiary action. Example: 'No Thanks' */
  TERTIARY = 'TERTIARY',
  /** Toggle action. Example: seat button in seat map */
  TOGGLE = 'TOGGLE'
}

/** Available action types an actionable element */
export enum FlightsActionType {
  /** User has selected seat(s) for all passengers in that leg */
  ALL_SEATS_SELECTED_FOR_A_LEG = 'ALL_SEATS_SELECTED_FOR_A_LEG',
  /** Selects the chosen fare and reloads dynamic elements */
  APPLY_FARE = 'APPLY_FARE',
  /** Highlights the fare chosen by the user */
  CHOOSE_FARE = 'CHOOSE_FARE',
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG = 'CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG',
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG = 'CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Go to coupon credit page */
  COUPON_CREDIT = 'COUPON_CREDIT',
  /** Dismisses a dialog */
  DISMISS = 'DISMISS',
  /** Activates the suggested filter */
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  /** Fetch more search listings */
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  GO_TO_AUTH = 'GO_TO_AUTH',
  /** Go to Checkout page */
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  /** Continues to the standalone details page */
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  /** Continues to the next set of journey results */
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  /** Continues to the packages path */
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  /** Redirects to flights search page */
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  /** Redirects back to storefront */
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  /** Opens a dialog for to display cross sell information */
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  /** open amenities tray and upsell options for standard offer flight listings */
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  /** Opens a dialog to display tax breakdown information */
  LOAD_TAX_BREAKDOWN_DIALOG = 'LOAD_TAX_BREAKDOWN_DIALOG',
  /** User has not selected seat(s) for any passengers in that leg */
  NO_SEATS_SELECTED_FOR_A_LEG = 'NO_SEATS_SELECTED_FOR_A_LEG',
  /** Opens a dialog to to go to Airlines Site for Booking */
  OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG = 'OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG',
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  OPEN_CREDIT_DIALOG = 'OPEN_CREDIT_DIALOG',
  /** Open Fare Seat information when clicked on required seat button */
  OPEN_FARE_SEAT_MAP_SEAT_SHEET = 'OPEN_FARE_SEAT_MAP_SEAT_SHEET',
  /** Open Fare Seat view to preview the seat map */
  OPEN_FARE_SEAT_MAP_VIEW = 'OPEN_FARE_SEAT_MAP_VIEW',
  /** Open Fare Seat view to select the seat */
  OPEN_FARE_SEAT_SELECT_VIEW = 'OPEN_FARE_SEAT_SELECT_VIEW',
  /** Open Flight leg drop down in seat map view */
  OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG = 'OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG',
  /** Open Legend info sheet in bottom in case of mobile */
  OPEN_LEGEND_INFO_SHEET_MOBILE = 'OPEN_LEGEND_INFO_SHEET_MOBILE',
  /** Open price summary */
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  /** Redirects to Airlines Site for Booking */
  REDIRECT_TO_AIRLINES_FOR_BOOKING = 'REDIRECT_TO_AIRLINES_FOR_BOOKING',
  /** Refreshes the current page */
  REFRESH = 'REFRESH',
  /** Actionable item to add a journey */
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  /** Closes the expanded Search Form */
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  /** Actionable item to remove a journey */
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG = 'SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG',
  /** Continues to flight details page after selecting seats for all flights */
  SEAT_MAP_CONTINUE_BOOKING = 'SEAT_MAP_CONTINUE_BOOKING',
  /** Closes the current flight seat selection page and continues for next flight */
  SEAT_MAP_GO_TO_NEXT_FLIGHT = 'SEAT_MAP_GO_TO_NEXT_FLIGHT',
  /** Go to next flight section for selecting seats */
  SEAT_MAP_NEXT_FLIGHT = 'SEAT_MAP_NEXT_FLIGHT',
  /** Saves user's seat preferences and redirects to FIS */
  SEAT_MAP_SAVE_AND_EXIT = 'SEAT_MAP_SAVE_AND_EXIT',
  /** Stays at Page displaying Seat Map when selected by user */
  SEAT_MAP_STAY_HERE = 'SEAT_MAP_STAY_HERE',
  /** Continues to stay on the current flight seat selection page */
  SEAT_MAP_STAY_ON_THIS_PAGE = 'SEAT_MAP_STAY_ON_THIS_PAGE',
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  SEAT_SELECT_DIALOG_CONTINUE_BOOKING = 'SEAT_SELECT_DIALOG_CONTINUE_BOOKING',
  /** Displays seat map preview corresponding to each traveler */
  SEAT_SELECT_PREVIEW_FOR_TRAVELER = 'SEAT_SELECT_PREVIEW_FOR_TRAVELER',
  /** Select Flight leg in seat map drop down menu */
  SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG = 'SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG',
  /** Select the seat */
  SELECT_SEAT = 'SELECT_SEAT',
  /** Open Opinion Lab Share Feedback dialogue */
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  /** Open a modal showing details of Price Match Promise product */
  SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS = 'SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS',
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  SOME_SEATS_SELECTED_FOR_A_LEG = 'SOME_SEATS_SELECTED_FOR_A_LEG',
  /** Subscribe to emails */
  SUBSCRIBE_TO_EMAILS = 'SUBSCRIBE_TO_EMAILS',
  /** Subscribe/Unsubscribes from price alerts */
  TOGGLE_PRICE_ALERTS = 'TOGGLE_PRICE_ALERTS',
  /** Unselect the selected seat */
  UNSELECT_SEAT = 'UNSELECT_SEAT',
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  UPGRADE_TO_NEXT_FARE = 'UPGRADE_TO_NEXT_FARE'
}




/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE'
}

/** Represents details of air ancillary selection request */
export interface FlightsAirAncillarySelectionDetailInput {
  /** Represents index of each traveler. Example: '1' */
  travelerIndex: Scalars['Int'];
  /** Represents details of flight, ancillaries in encoded form mapped to each traveler. */
  unselectedAirAncillaryProductToken: Scalars['String'];
}




/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: Scalars['String'];
}








/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP'
}








/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}




/** Represents the value associated with travel and baggage filter - carry on bag */
export interface FlightsCarryOnBagBasedFilterValueInput {
  carryOnBag: CarryOnBagType;
}




/** Represents the value associated with travel and baggage filter - checked bag */
export interface FlightsCheckedBagBasedFilterValueInput {
  numOfCheckedBags: Scalars['Int'];
}







/** Represents the value credit eligible filter */
export interface FlightsCreditEligibleFilterValueInput {
  creditEligible: CreditEligibleFilterType;
}









/** Represents an individual cross sort parameter */
export interface FlightsCrossSortOptionInput {
  /** Enumeration of the parameter type for the accompanying weight */
  type: FlightsCrossSortType;
  /** The current weight of the individual cross sort parameter */
  weight: Scalars['Int'];
}


/** User specified parameters for cross sort */
export interface FlightsCrossSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOption: Array<FlightsCrossSortOptionInput>;
}



export enum FlightsCrossSortType {
  CABIN_CLASS = 'CABIN_CLASS',
  CANCELLATION = 'CANCELLATION',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHANGE_ALLOWED = 'CHANGE_ALLOWED',
  CHECKED_BAG = 'CHECKED_BAG',
  DURATION = 'DURATION',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PRICE = 'PRICE',
  SEAT_CHOICE = 'SEAT_CHOICE'
}


/** Represents criteria for continue booking for selecting ancillaries on flight information page */
export interface FlightsDetailAncillaryUpdateCriteriaInput {
  /** Represents details of air ancillary selection request */
  airAncillaryDetails: Array<FlightsAirAncillarySelectionDetailInput>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
}

/** Represents criteria for flights information page. */
export interface FlightsDetailComponentsCriteriaInput {
  /** Represents FlightsSearchContext of the selected flight */
  flightsSearchContext: FlightsSearchContextInput;
  /** Represents FlightsJourneyCriteria of the selected flight */
  journeyCriteria: Array<FlightsJourneyCriteriaInput>;
  /** Represents Air Offer Token of the selected flight */
  journeyIdentifier: Scalars['String'];
  /** Represents Price of the selected flight */
  originalPrice?: Maybe<MoneyInput>;
  /** Represents QueryParams of the selected flight */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
  /** Represents FlightsSearchPreferences of the selected flight */
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  /** Represents FlightsTravelerDetails of the selected flight */
  travelerDetails: Array<FlightsTravelerDetailsInput>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}


/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** Encoded representation of ancillaries that was selected on FIS. */
  ancillaryId?: Maybe<Scalars['String']>;
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: Scalars['String'];
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents upsell offer token of the selected flight */
  upsellOfferToken?: Maybe<Scalars['String']>;
}


/** Represents the information of the user device */
export interface FlightsDevicePermissionsInput {
  /** Represents the array of all the notifications enabled for the user device */
  pushNotificationsEnabled: Array<NotificationsType>;
}

/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE'
}











/** Represents flights component */
export enum FlightsDisplayComponent {
  SMART_NFF_ALTERNATE_SUGGESTION = 'SMART_NFF_ALTERNATE_SUGGESTION'
}


/** Represents display count of a component within a session e.g How many time NFF shows consecutively   */
export interface FlightsDisplayComponentCountingValueInput {
  /** Represents display count of a flights component */
  displayCount: Scalars['Int'];
  flightsDisplayComponent: FlightsDisplayComponent;
}


/** Represents flights component display values */
export interface FlightsDisplayComponentValuesInput {
  /** Represents counting values of flights display component */
  displayCountingValues?: Maybe<Array<FlightsDisplayComponentCountingValueInput>>;
}


/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: Scalars['Int'];
}








/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED'
}




/** Represent the fares needs to be present in listing results */
export enum FlightsFaresSeparationType {
  BASE_AND_UPSELL = 'BASE_AND_UPSELL',
  ONLY_BASE = 'ONLY_BASE',
  ONLY_UPSELL = 'ONLY_UPSELL'
}









export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  CARRY_ON_BAG = 'CARRY_ON_BAG',
  CHECKED_BAG = 'CHECKED_BAG',
  CREDIT_ELIGIBLE = 'CREDIT_ELIGIBLE',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  NO_CANCEL_FEE = 'NO_CANCEL_FEE',
  NO_CHANGE_FEE = 'NO_CHANGE_FEE',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE',
  SEAT_CHOICE = 'SEAT_CHOICE',
  TRAVEL_AND_BAGGAGE = 'TRAVEL_AND_BAGGAGE'
}




/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}

export enum FlightsFlexibleGridType {
  /** Flex Search type shown for OW */
  FLEX_SEARCH = 'FLEX_SEARCH',
  /** Flex Search Grid type shown for RT Outbound */
  FLEX_SEARCH_GRID = 'FLEX_SEARCH_GRID',
  /** No Flex Search variant shown */
  FLEX_SEARCH_NOT_APPLICABLE = 'FLEX_SEARCH_NOT_APPLICABLE'
}







export enum FlightsFlexibleSearchHeaderCellTheme {
  /** Theme to represent an outbound or inbound departureDate header */
  DEFAULT = 'DEFAULT',
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER'
}


export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT'
}






export enum FlightsFlexibleSearchResultCellTheme {
  /** Default theme */
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  /** Theme to represent highest priced cells in the matrix */
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  /** Theme to represent the lowest price displayed in the matrix */
  LOWEST_PRICE = 'LOWEST_PRICE',
  /** Theme to represent when no price is available, 'Search' */
  NO_PRICE = 'NO_PRICE',
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  SEARCHED_DATE = 'SEARCHED_DATE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS'
}
























/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Arrival date of the flight */
  arrivalDate?: Maybe<DateInput>;
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: Scalars['String'];
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: Maybe<FlightsCabinClass>;
  /** Three letter code of the origin airport */
  origin: Scalars['String'];
}


































/** Metrics names */
export enum FlightsMetricName {
  LISTINGS_SUPPLY_RESPONSE_TIME = 'LISTINGS_SUPPLY_RESPONSE_TIME'
}






/** Represents the value associated with travel and baggage filter - no cancel fee */
export interface FlightsNoCancelFeeBasedFilterValueInput {
  noCancelFee: NoCancelFeeType;
}


/** Represents the value associated with travel and baggage filter - no change name */
export interface FlightsNoChangeFeeBasedFilterValueInput {
  noChangeFee: NoChangeFeeType;
}





















/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}



/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export enum FlightsPlacardDisplayType {
  /** Represents the placard type to be shown immediately */
  IMMEDIATE = 'IMMEDIATE',
  /** Represents the placard type to be shown during server error of sort and filter action */
  SORT_FILTERS_SERVER_ERROR = 'SORT_FILTERS_SERVER_ERROR'
}


/** Represents a type of placards the client can request for */
export enum FlightsPlacardType {
  /** Represents the placard of type free cancellation */
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  /** Represents the placard of type loyalty reward */
  LOYALTY_REWARD = 'LOYALTY_REWARD',
  /** Represents the placard of type no change fees */
  NO_CHANGE_FEES = 'NO_CHANGE_FEES',
  /** Represents the placard of type passport */
  PASSPORT = 'PASSPORT',
  /** Represents the placard of type price change */
  PRICE_CHANGE = 'PRICE_CHANGE',
  /** Represents the placard of type split ticket */
  SPLIT_TICKET = 'SPLIT_TICKET'
}


/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: Scalars['String'];
}




/** Represents the sections available in the price range indicator */
export enum FlightsPriceRangeIndicatorPinPlacement {
  LOWER = 'LOWER',
  MID = 'MID',
  UPPER = 'UPPER'
}












/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}










/** Enum class to represent the id associated with the rewards option */
export enum FlightsRewardsOptionId {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}


export interface FlightsSearchComponentCriteriaInput {
  /** Represents Unresolved list of params for meta. Like MDPCID, etc. */
  queryParams?: Maybe<Array<GraphQlPairInput>>;
}


/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeys have been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: Maybe<Scalars['String']>;
  /** Represents the identifier for the spinner to deduce which all credits have been selected by the user */
  originalBookingId?: Maybe<Scalars['String']>;
  /** Represents the flights user selected for each segment when the user proceeded to FIS.This node will be populated on the search response only if customer is returning to FSR from FIS. */
  previousFlightSelections?: Maybe<Array<JourneyFlightSelectionInput>>;
  /** Trip type in search */
  tripType: FlightsTripType;
}



/** Represents an element of the list which the client needs to send back to the server as part of the request. This will be part of each FilterItem so client need not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - carry on bag. */
  carryOnBagBasedFilterValue?: Maybe<FlightsCarryOnBagBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - checked bag. */
  checkedBagBasedFilterValue?: Maybe<FlightsCheckedBagBasedFilterValueInput>;
  /** Represents the value associated with credit eligible filter */
  creditEligibleFilterValue?: Maybe<FlightsCreditEligibleFilterValueInput>;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: Maybe<FlightsAirportCodeFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: Maybe<FlightsTimeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: Maybe<FlightsDurationBasedFilterValueInput>;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: Maybe<FlightsFlexibleChangePolicyBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no cancel fee. */
  noCancelFeeBasedFilterValue?: Maybe<FlightsNoCancelFeeBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - no change fee. */
  noChangeFeeBasedFilterValue?: Maybe<FlightsNoChangeFeeBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: Maybe<FlightsStopBasedFilterValueInput>;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: Maybe<FlightsPreferredAirlineFilterValueInput>;
  /** Represents the value associated with travel and baggage filter - seat choice. */
  seatChoiceBasedFilterValue?: Maybe<FlightsSeatChoiceBasedFilterValueInput>;
  /** Represents the value associated with travel and baggage filter. */
  travelAndBaggageBasedFilterValue?: Maybe<FlightsTravelAndBaggageBasedFilterValueInput>;
}








export enum FlightsSearchFormErrorType {
  /** Age of child is missing */
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  /** Date before previous date - Multi-dest */
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  /** Date must be between a range */
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  /** Dates must be greater than or equal to default date/checkin date. */
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  /** Age of infant is missing */
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  /** Date must be in the correct format */
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  /** Total traveler count must be equal or lower than max */
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  /** At least 1 traveler required in a booking */
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  /** Location must not be blank */
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  /** Origin and destination location must not be the same */
  LOCATION_SAME = 'LOCATION_SAME',
  /** Dates must be no more than 26 days apart */
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  /** Origin and Destination city cannot be same */
  SAME_CITY = 'SAME_CITY',
  /** Special characters are not allowed */
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  /** Enter at least 3 characters of the airport name */
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  /** Number of infant in lap must be equal or lower than number of adults */
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT'
}


















/** Primary flights criteria part of the search wizard that have an impact on the first results set.It's different from the side filter part of the secondary search criteria that are filtering on top of it. The side filter should be using a server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>;
  airline?: Maybe<Scalars['String']>;
  cabinClass: FlightsCabinClass;
}





/** Represents the value associated with travel and baggage filter - seat choice */
export interface FlightsSeatChoiceBasedFilterValueInput {
  seatChoice: SeatChoiceType;
}


/** Represents criteria for flights seat map. */
export interface FlightsSeatMapCriteriaInput {
  /** Represents which offer seat map to be shown. This will be decoded and used to create seat map service request */
  offerIdentifier: Scalars['String'];
  /** Represents pricing construct containing price related information. Ex: '[AA.QNNF00S7:SEADEL][AA.QNNF00S7CH:SEADEL][AA.QNNF00S7CH:SEADEL]{BFSDiag}{FC}11JUL21SEA AA X/LON BA DEL M318.00NUC318.00END ROE1.000000{/FC}{DollarAfc}{/DollarAfc}{/BFSDiag}{Published}' */
  pricingConstruct?: Maybe<Scalars['String']>;
  /** Represents list of segments for which seat map for selection is to be shown. */
  seatSegments?: Maybe<Array<SeatSegmentInput>>;
  /** Represents list of segments for which seat map is to be shown. This will identify the segments from the decoded offer identifier and request seat map downstream. */
  segmentIdentifiers: Array<Scalars['String']>;
}












/** Enum class to represent the seat type variant. */
export enum FlightsSeatMapSeatVariant {
  ACCESSIBLE = 'ACCESSIBLE',
  AISLE = 'AISLE',
  AVAILABLE = 'AVAILABLE',
  COLUMN = 'COLUMN',
  EXIT = 'EXIT',
  GALLEY = 'GALLEY',
  PREFERRED = 'PREFERRED',
  RESTROOM = 'RESTROOM',
  ROW = 'ROW',
  SELECTED = 'SELECTED',
  UNAVAILABLE = 'UNAVAILABLE'
}






/** Error types which can occur during seat selection */
export enum FlightsSeatSelectionErrorType {
  /** Seat Selection Failed */
  SELECTION_FAILED = 'SELECTION_FAILED',
  /** Seat Selection Unavailable */
  SELECTION_UNAVAILABLE = 'SELECTION_UNAVAILABLE'
}






















/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  /** The array of all cross-sort parameters selected by the user */
  crossSortOptionList?: Maybe<Array<FlightsCrossSortOptionInput>>;
  crossSortOptionType?: Maybe<FlightsCrossSortOptionTypeInput>;
  sortOrder: FlightsSortOrder;
  sortType: FlightsSortType;
}

/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING'
}


/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  CROSS_SORT = 'CROSS_SORT',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED'
}





/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}

/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL'
}


/** Represents the stop related info for each number of stops based filter value. Combination of the number of stops and an operation.Ex. 2+ would be represented by {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: Scalars['Int'];
  stopFilterOperation: FlightsStopFilterOperation;
}











/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}

/** Enum representing the various time slots in a day  */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}



/** Represents the value associated with travel and baggage filter */
export interface FlightsTravelAndBaggageBasedFilterValueInput {
  travelAndBaggageName: FilterTravelAndBaggageType;
}



/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: Maybe<Array<Scalars['Int']>>;
  /** Traveler count */
  count: Scalars['Int'];
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}




/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}





export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}










export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}







/** Represents all the common information in the journey review block on FIS  */
export enum FreeCancellationApplicability {
  ALL_JOURNEYS = 'ALL_JOURNEYS',
  CURRENT_JOUNRNEY = 'CURRENT_JOUNRNEY',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}




export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}


/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY'
}




/** Line of business that is querying the global navigation elements. */
export enum GlobalNavigationLineOfBusiness {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN'
}


/**
 * An object with simple key/value combination. This can be used to represent generic input where you do not know all the values that can be provided.
 *
 * It should be avoided in favor of a strict type with set fields, but can be useful in specific situations.
 */
export interface GraphQlPairInput {
  key: Scalars['String'];
  value: Scalars['String'];
}





export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}








/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT'
}






export enum GroundTransfersGroupViewType {
  CARDS_LIST = 'CARDS_LIST'
}


/** Provides the ground transfers criteria for each part of the journey. For instance, round-trip journey will comprise 2 parts, airport(origin) to hotel(destination) and hotel(origin) to airport(destination). */
export interface GroundTransfersJourneyCriteriaInput {
  dateTime: DateTimeInput;
  destination: GroundTransfersLocationInput;
  origin: GroundTransfersLocationInput;
}



/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: Maybe<CoordinatesInput>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type: GeoType;
}




export enum GroundTransfersMapTransitOption {
  BUS = 'BUS',
  NONE = 'NONE',
  TRAIN = 'TRAIN'
}

export enum GroundTransfersMapTravelMode {
  DRIVING = 'DRIVING',
  TRANSIT = 'TRANSIT'
}






/** The ground transfers natural key that contains an offer token */
export interface GroundTransfersNaturalKeyInput {
  offerToken: Scalars['String'];
}









export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}




export enum GroundTransfersSectionStyle {
  BULLETED = 'BULLETED',
  STANDARD = 'STANDARD'
}




/** Text style to apply to text */
export enum GroundTransfersStyle {
  /** Bold styling */
  EMPHASISED = 'EMPHASISED',
  /** Green text styling */
  POSITIVE = 'POSITIVE',
  /** Regular text with no styling, default Value */
  STANDARD = 'STANDARD'
}





/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: Scalars['Int'];
  type: GroundTransfersTravelerDetailsType;
}

/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}





/** Header section alignment of elements to either the start or end of the section container. */
export enum HeaderAlignment {
  END = 'END',
  START = 'START'
}



/** Determines the type of button to display.  Primary or tertiary. */
export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}

/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

/** Header layout. */
export enum HeaderLayout {
  DEFAULT = 'DEFAULT',
  MINIMAL = 'MINIMAL',
  SIMPLIFIED = 'SIMPLIFIED'
}

















/** Inserts a separator in header menus. */
export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}






/** Type of text.  Heading or subheading. */
export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING'
}

/** Different viewport sizes to display the header. */
export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}







/** Hero inputs */
export interface HeroInput {
  /** Tag, used to retrieve the content. */
  tag?: Maybe<Scalars['String']>;
}

















export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH'
}







export interface HttpHeaderInput {
  name: Scalars['String'];
  values: Array<Scalars['String']>;
}

export enum HttpStatus {
  ACCEPTED = 'ACCEPTED',
  ALREADY_REPORTED = 'ALREADY_REPORTED',
  BAD_GATEWAY = 'BAD_GATEWAY',
  BAD_REQUEST = 'BAD_REQUEST',
  BANDWIDTH_LIMIT_EXCEEDED = 'BANDWIDTH_LIMIT_EXCEEDED',
  CHECKPOINT = 'CHECKPOINT',
  CONFLICT = 'CONFLICT',
  CONTINUE = 'CONTINUE',
  CREATED = 'CREATED',
  DESTINATION_LOCKED = 'DESTINATION_LOCKED',
  EXPECTATION_FAILED = 'EXPECTATION_FAILED',
  FAILED_DEPENDENCY = 'FAILED_DEPENDENCY',
  FORBIDDEN = 'FORBIDDEN',
  FOUND = 'FOUND',
  GATEWAY_TIMEOUT = 'GATEWAY_TIMEOUT',
  GONE = 'GONE',
  HTTP_VERSION_NOT_SUPPORTED = 'HTTP_VERSION_NOT_SUPPORTED',
  IM_USED = 'IM_USED',
  INSUFFICIENT_SPACE_ON_RESOURCE = 'INSUFFICIENT_SPACE_ON_RESOURCE',
  INSUFFICIENT_STORAGE = 'INSUFFICIENT_STORAGE',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  I_AM_A_TEAPOT = 'I_AM_A_TEAPOT',
  LENGTH_REQUIRED = 'LENGTH_REQUIRED',
  LOCKED = 'LOCKED',
  LOOP_DETECTED = 'LOOP_DETECTED',
  METHOD_FAILURE = 'METHOD_FAILURE',
  METHOD_NOT_ALLOWED = 'METHOD_NOT_ALLOWED',
  MOVED_PERMANENTLY = 'MOVED_PERMANENTLY',
  MOVED_TEMPORARILY = 'MOVED_TEMPORARILY',
  MULTIPLE_CHOICES = 'MULTIPLE_CHOICES',
  MULTI_STATUS = 'MULTI_STATUS',
  NETWORK_AUTHENTICATION_REQUIRED = 'NETWORK_AUTHENTICATION_REQUIRED',
  NON_AUTHORITATIVE_INFORMATION = 'NON_AUTHORITATIVE_INFORMATION',
  NOT_ACCEPTABLE = 'NOT_ACCEPTABLE',
  NOT_EXTENDED = 'NOT_EXTENDED',
  NOT_FOUND = 'NOT_FOUND',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  NOT_MODIFIED = 'NOT_MODIFIED',
  NO_CONTENT = 'NO_CONTENT',
  OK = 'OK',
  PARTIAL_CONTENT = 'PARTIAL_CONTENT',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PERMANENT_REDIRECT = 'PERMANENT_REDIRECT',
  PRECONDITION_FAILED = 'PRECONDITION_FAILED',
  PRECONDITION_REQUIRED = 'PRECONDITION_REQUIRED',
  PROCESSING = 'PROCESSING',
  PROXY_AUTHENTICATION_REQUIRED = 'PROXY_AUTHENTICATION_REQUIRED',
  REQUESTED_RANGE_NOT_SATISFIABLE = 'REQUESTED_RANGE_NOT_SATISFIABLE',
  REQUEST_ENTITY_TOO_LARGE = 'REQUEST_ENTITY_TOO_LARGE',
  REQUEST_HEADER_FIELDS_TOO_LARGE = 'REQUEST_HEADER_FIELDS_TOO_LARGE',
  REQUEST_TIMEOUT = 'REQUEST_TIMEOUT',
  REQUEST_URI_TOO_LONG = 'REQUEST_URI_TOO_LONG',
  RESET_CONTENT = 'RESET_CONTENT',
  SEE_OTHER = 'SEE_OTHER',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  SWITCHING_PROTOCOLS = 'SWITCHING_PROTOCOLS',
  TEMPORARY_REDIRECT = 'TEMPORARY_REDIRECT',
  TOO_EARLY = 'TOO_EARLY',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAVAILABLE_FOR_LEGAL_REASONS = 'UNAVAILABLE_FOR_LEGAL_REASONS',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  UNSUPPORTED_MEDIA_TYPE = 'UNSUPPORTED_MEDIA_TYPE',
  UPGRADE_REQUIRED = 'UPGRADE_REQUIRED',
  URI_TOO_LONG = 'URI_TOO_LONG',
  USE_PROXY = 'USE_PROXY',
  VARIANT_ALSO_NEGOTIATES = 'VARIANT_ALSO_NEGOTIATES'
}



/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL',
  XLARGE = 'XLARGE'
}

/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export enum IconTheme {
  DEFAULT = 'default',
  EMPHASIS = 'emphasis',
  NEGATIVE = 'negative',
  POSITIVE = 'positive'
}


/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: Maybe<AuthenticationState>;
  /** The device ID (DUAID) */
  duaid: Scalars['UUID'];
  /** The Expedia User ID */
  expUserId?: Maybe<Scalars['String']>;
  /** The user TUID */
  tuid?: Maybe<Scalars['String']>;
}



















/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: Maybe<Scalars['String']>;
  /** Gaia region id of the location */
  regionId?: Maybe<Scalars['String']>;
}







/** GraphQL request for benefit details */
export interface InsuranceBenefitDetailsQueryRequestInput {
  /** Benefit Id for which the details are requested */
  benefitId: Scalars['String'];
  /** Order Id of the booking */
  orderNumber?: Maybe<Scalars['String']>;
  /** Trip Id of the booking */
  tripId?: Maybe<Scalars['String']>;
}



export interface InsuranceBookingOverviewRequestInput {
  orderNumber?: Maybe<Scalars['String']>;
  tripId?: Maybe<Scalars['String']>;
}



/** Represents criteria for insurance. */
export interface InsuranceCriteriaInput {
  /** Represents free price match promise marketing placement */
  freePmpCustomerPlacement?: Maybe<Scalars['String']>;
}


export interface InsuranceDetailPrimingForCarInput {
  /** Identifier token for car inventory */
  carOfferToken: Scalars['String'];
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: Maybe<Scalars['String']>;
  /** Drop-off location for car */
  dropOffLocation?: Maybe<InsuranceLocationInput>;
  /** Pick-up location for car */
  pickUpLocation: InsuranceLocationInput;
  /** Reward point selection on  Car offer */
  rewardPointsSelection?: Maybe<InsuranceRewardsPointSelectionEnum>;
  /** List of accessories added with Car */
  selectedAccessories?: Maybe<Array<Scalars['String']>>;
}

export interface InsuranceDetailPrimingRequestInput {
  /** Car request for insurance priming */
  carRequest: InsuranceDetailPrimingForCarInput;
}




export interface InsuranceFileAClaimRequestInput {
  benefitId: Scalars['String'];
  orderNumber?: Maybe<Scalars['String']>;
  tripId?: Maybe<Scalars['String']>;
}









export enum InsuranceListLayout {
  SINGLE_COLUMN = 'SINGLE_COLUMN'
}

export enum InsuranceListType {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED'
}

export enum InsuranceListTypeOld {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED'
}


export interface InsuranceLocationInput {
  /** Region id */
  regionId: Scalars['String'];
  /** Search term */
  searchTerm: Scalars['String'];
}


export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}


export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE'
}










export enum InsurancePhrasePartStyle {
  /** Green */
  COLOR_GREEN = 'COLOR_GREEN',
  /** Red */
  COLOR_RED = 'COLOR_RED',
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}







export enum InsuranceRewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}


export interface InsuranceSelectionDetailsInput {
  /** Insurance id of already added insurance */
  existingInsuranceProductIds?: Maybe<Array<Scalars['String']>>;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: Maybe<Scalars['String']>;
  /** Details of already added insurance */
  insuranceSelectionDetails?: Maybe<InsuranceSelectionDetailsInput>;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: Maybe<Scalars['String']>;
  /** TripId */
  tripId: Scalars['UUID'];
  /** In order to ignore the caching at client level and make an actual shopping call version hash is changed in subsequent requests */
  versionHash?: Maybe<Scalars['String']>;
}












export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;
  insuranceSearchId?: Maybe<Scalars['String']>;
  offerTypeId?: Maybe<Scalars['Int']>;
}




/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: Maybe<Scalars['String']>;
  /** Name of interest */
  name?: Maybe<Scalars['String']>;
}

/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  THOMASCOOK_EUR = 'THOMASCOOK_EUR',
  THOMASCOOK_UK = 'THOMASCOOK_UK',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA'
}





/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: Scalars['Int'];
  /** Represents the flight combination the customer previously selected for the indexed segment. This will be used to highlight the previously selected offer for pinned listing. */
  offerIdentifier: Scalars['String'];
}







export enum KeyPhrasesClientType {
  DEFAULT = 'DEFAULT',
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET'
}




/** PWA ONLY: Input that is sent directly from the URL value. These inputs can not be parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: Maybe<Array<Scalars['String']>>;
  /** Maps to ReviewScoreRange */
  guestRating?: Maybe<Scalars['String']>;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: Maybe<Array<Scalars['String']>>;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: Maybe<Array<Scalars['Int']>>;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: Maybe<PrivacyTrackingState>;
  /** Maps to PropertySort */
  sort?: Maybe<Scalars['String']>;
  /** Maps to starList */
  stars?: Maybe<Scalars['String']>;
  /** Maps to StructureType */
  structureTypes?: Maybe<Array<Scalars['String']>>;
}




/** Line of business */
export enum LineOfBusinessDomain {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  LODGING = 'LODGING',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

/** ADs related property search options  */
export enum Listings {
  /** Only return travelAds */
  ADS_ONLY = 'ADS_ONLY'
}




export enum LiveAnnouncePoliteness {
  ASSERTIVE = 'ASSERTIVE',
  OFF = 'OFF',
  POLITE = 'POLITE'
}








































/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR'
}


















export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST'
}







export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL'
}










/** Theme information for a message. */
export enum LodgingMessageTheme {
  /** To be used for warnings/errors; typically red. */
  AGGRESSIVE = 'AGGRESSIVE',
  /** To be used for success/perks; typically green. */
  HIGHLIGHT = 'HIGHLIGHT',
  /** To be used for emphasis; typically bold. */
  STRONG = 'STRONG'
}





















































/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN'
}



/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI'
}




/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  /** Hypertext markup language */
  HTML = 'HTML'
}


export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD'
}




export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO'
}



export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER'
}

















/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS'
}








/** Product natural keys required for session recovery */
export interface MishopRecoveryNaturalKeysInput {
  flightNaturalKeys: Array<FlightNaturalKeyInput>;
  propertyNaturalKeys: Array<PropertyNaturalKeyInput>;
}














/** Change Package Search Form Primer */
export interface MishopUiChangePackageFormPrimerInput {
  multiItemSessionId: Scalars['String'];
}













/** The type of button to display */
export enum MishopUiDialogButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}





































/** Contains the necessary data for calling packageSummaryContent query */
export interface MishopUiPackageSummaryContentPrimerInput {
  naturalKey: PackageNaturalKeyInput;
}






/** Contains the necessary data for rendering to the customer a placard describing announcements relevant to their trip */
export interface MishopUiPlacardNotificationInput {
  multiItemPriceToken?: Maybe<Scalars['String']>;
  placardType: MishopUiPlacardType;
  priceDetailsOptions?: Maybe<PriceDetailsOptionsInput>;
  shoppedProducts: Array<ShoppedProductInput>;
}

export enum MishopUiPlacardType {
  PRICE_CHANGE = 'PRICE_CHANGE'
}















/** Contains the necessary data to render banner for a changed product */
export interface MishopUiProductChangedBannerPrimerInput {
  currentPackageOfferId: PackageNaturalKeyInput;
  previousOffer: MultiItemProductsInput;
  previousPackageOfferId: PackageNaturalKeyInput;
}






/** Contains the data required to fetch the product header */
export interface MishopUiProductHeaderPrimerInput {
  productType: MishopUiProductType;
}


export enum MishopUiProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  GROUND_TRANSFER = 'GROUND_TRANSFER',
  PROPERTY = 'PROPERTY'
}






/** Contains necessary data for fetching property content */
export interface MishopUiPropertyContentPrimerInput {
  changePropertyAction: PropertySearchMultiItemShoppingActionInput;
  changeRoomAction: PropertyDetailsMultiItemShoppingActionInput;
  naturalKey: PropertyNaturalKeyInput;
  propertyChangeLink?: Maybe<Scalars['String']>;
  relativeChangePropertyLink: Scalars['String'];
  relativeChangeRoomLink: Scalars['String'];
}





















export enum MobilitySearchDialogsId {
  /** This represents a dialog to display price summary details */
  PRICE_SUMMARY_DETAILS = 'PRICE_SUMMARY_DETAILS'
}




/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: Scalars['Float'];
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: Maybe<Scalars['String']>;
}


/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}





/** The multi-item context used for package searches, contains information needed for package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: Scalars['String'];
  /** The package type for this search */
  packageType: PackageType;
}























/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities?: Maybe<Array<ActivityNaturalKeyInput>>;
  cars?: Maybe<Array<CarNaturalKeyInput>>;
  flights?: Maybe<Array<FlightNaturalKeyInput>>;
  groundTransfers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  packages?: Maybe<Array<PackageNaturalKeyInput>>;
  properties?: Maybe<Array<PropertyNaturalKeyInput>>;
}






/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: Maybe<Array<CarSearchCriteriaInput>>;
  flights?: Maybe<Array<FlightSearchCriteriaInput>>;
  properties?: Maybe<Array<PropertySearchCriteriaInput>>;
}














/** Enum class to represent the type of no cancel fee */
export enum NoCancelFeeType {
  NO_CANCEL_FEE = 'NO_CANCEL_FEE'
}

/** Enum class to represent the type of no change fee */
export enum NoChangeFeeType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}
























/** The button type of the Customer notification submit button */
export enum NotificationFormButtonType {
  /** Type of floating action button */
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  /** Type of primary button */
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  /** Type of secondary button */
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  /** Type of tertiary button */
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}





/** Represents the target of the link */
export enum NotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}

/** Represents the link type */
export enum NotificationLinkType {
  ANCHOR = 'ANCHOR',
  APP_DOWNLOAD_LINK = 'APP_DOWNLOAD_LINK',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}

export enum NotificationLocationOnPage {
  AFTER_HEADER = 'AFTER_HEADER',
  AFTER_WIZARD = 'AFTER_WIZARD',
  ERROR = 'ERROR',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  LEGAL = 'LEGAL',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}



/** The display type of the Customer notification message */
export enum NotificationMessageDisplayType {
  /** Display the message for the form */
  FORM = 'FORM',
  /** Dislay message on the page level, eg: fly-in message on the page */
  PAGE = 'PAGE'
}

/** The level type of the Customer notification message */
export enum NotificationMessageLevel {
  /** Type of error for the message */
  ERROR = 'ERROR',
  /** Type of info for the message */
  INFO = 'INFO',
  /** Type of success for the message */
  SUCCESS = 'SUCCESS',
  /** Type of warning for the message */
  WARNING = 'WARNING'
}

export enum NotificationMessageType {
  /** INVALID_INPUT message */
  INVALID_INPUT = 'INVALID_INPUT',
  /** SERVICE_ERROR message */
  SERVICE_ERROR = 'SERVICE_ERROR',
  /** SUCCESS message */
  SUCCESS = 'SUCCESS'
}

/** Optional information to get a better contextual customer notification */
export interface NotificationOptionalContextInput {
  /** the optional field containing an error token, triggering the retrieval of an error message */
  errorToken?: Maybe<Scalars['String']>;
  /** itinerary number */
  itineraryNumber?: Maybe<Scalars['String']>;
  /** list of journey criteria items */
  journeyCriterias?: Maybe<Array<NotificationOptionalContextJourneyCriteriaInput>>;
  /** the optional URL input field to retrieve extra url information, such as deep linking url for the mobile app download notification */
  referer?: Maybe<Scalars['URL']>;
  /** trip folder id */
  tripFolderId?: Maybe<Scalars['String']>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: Maybe<DateRangeInput>;
  /** destination information */
  destination?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** origin information */
  origin?: Maybe<NotificationOptionalContextJourneyCriteriaLocationInput>;
  /** trip type */
  tripType?: Maybe<FlightsTripType>;
}

/** Journey criteria such as location gaia id and travel date ranges */
export interface NotificationOptionalContextJourneyCriteriaLocationInput {
  /** airport code */
  airportTLA?: Maybe<Scalars['String']>;
  /** property id */
  propertyId?: Maybe<Scalars['String']>;
  /** regionId number */
  regionId?: Maybe<Scalars['String']>;
}



/** The style to apply to phrase links */
export enum NotificationPhraseLinkStyle {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}


/** The text style to apply to strings */
export enum NotificationPhrasePartStyle {
  /** Italic styling */
  EMPHASIS = 'EMPHASIS',
  /** Bold styling */
  IMPORTANT = 'IMPORTANT',
  /** Represents no style or regular text */
  STANDARD = 'STANDARD'
}







/** Represents the attributes on a notification that could be changed after an interaction */
export interface NotificationSpecificationsInput {
  /** Set to true when notification is dismissed */
  dismiss?: Maybe<Scalars['Boolean']>;
  /** Notification id */
  id?: Maybe<Scalars['String']>;
  /** Set to true when notification is read */
  read?: Maybe<Scalars['Boolean']>;
  /** Set to true when notification is seen */
  seen?: Maybe<Scalars['Boolean']>;
}

export enum NotificationState {
  READ = 'READ',
  SEEN = 'SEEN',
  UNKNOWN = 'UNKNOWN',
  UNSEEN = 'UNSEEN'
}

export enum NotificationSubType {
  COUPON_CAMPAIGN = 'COUPON_CAMPAIGN',
  DEFAULT = 'DEFAULT'
}




export enum NotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  CITI_COBRAND_VERTICAL = 'CITI_COBRAND_VERTICAL',
  ERROR = 'ERROR',
  GDPR = 'GDPR',
  GENERIC = 'GENERIC',
  HEADER = 'HEADER',
  INBOX = 'INBOX',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  OSANO = 'OSANO',
  TAKEOVER = 'TAKEOVER',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}


export enum NotificationUserActionType {
  DELETE = 'DELETE',
  MARK_AS_READ = 'MARK_AS_READ',
  MARK_AS_UNREAD = 'MARK_AS_UNREAD',
  UNKNOWN = 'UNKNOWN'
}

/** Represents the the user input for customer notification mutation */
export interface NotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: Array<NotificationUserInputElementInput>;
}

/** Represents customer notification user input */
export interface NotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: Scalars['String'];
  /** Represents the value of customer notification user input */
  value: Scalars['String'];
}

export enum NotificationsType {
  ALL = 'ALL'
}


/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: Scalars['String'];
  value: Scalars['Int'];
}




export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP'
}












export enum OperationStatus {
  FAILURE = 'FAILURE',
  INVALID_INPUT = 'INVALID_INPUT',
  SUCCESS = 'SUCCESS'
}




/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: Maybe<DateTimeInput>;
  /** Optional starting date & time in this range */
  start?: Maybe<DateTimeInput>;
}








export interface PackageLocationInput {
  airportCode: Scalars['String'];
}


/** Minimum set of data used to retrieve content about a package */
export interface PackageNaturalKeyInput {
  offerToken: Scalars['String'];
}



/** Checkout option and its value to apply on the checkoutUrl */
export interface PackageSearchCriteriaInput {
  primary: PrimaryPackageSearchCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}

export enum PackageSort {
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR'
}

































export interface PageContextInput {
  propertySearch?: Maybe<PropertySearchCriteriaInput>;
}


/** Page identity */
export enum PageLocation {
  /** All checkout related pages */
  CHECKOUT = 'CHECKOUT',
  /** Checkout error pages for all LOBs */
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  /** Order confirmation pages for all LOBs */
  CONFIRMATION = 'CONFIRMATION',
  /** All product detail pages are identified as DETAILS */
  DETAILS = 'DETAILS',
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  ENTRY = 'ENTRY',
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  FEATURES = 'FEATURES',
  /** Payment error pages for all LOBs */
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  POST_BOOKING = 'POST_BOOKING',
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  SYSTEM = 'SYSTEM',
  /** User pages including sign-in, my account and rewards */
  USER = 'USER'
}

export enum PageState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}


/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: Maybe<Scalars['Int']>;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: Maybe<Scalars['Int']>;
}

export interface PartnerContextInput {
  detailsSiteConfiguration?: Maybe<TravelStoreV1CarDetailsInput>;
  partnerAccountId: Scalars['String'];
  searchSiteConfiguration?: Maybe<TravelStoreV1CarSearchInput>;
}









































export enum PaymentInputMode {
  NUMERIC = 'NUMERIC'
}













export enum PaymentOptionType {
  CLICK_TO_PAY = 'CLICK_TO_PAY',
  CREDIT_CARD = 'CREDIT_CARD',
  IBP = 'IBP',
  PAYPAL = 'PAYPAL',
  POINTS = 'POINTS',
  STORED_CARD = 'STORED_CARD'
}





export enum PaymentTextSize {
  LARGE = 'LARGE',
  REGULAR = 'REGULAR',
  SMALL = 'SMALL'
}




export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD'
}



export enum PaymentTypeLogoSize {
  LARGE = 'LARGE',
  SMALL = 'SMALL'
}




export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK'
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK'
}




/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export enum PluralCategory {
  FEW = 'FEW',
  MANY = 'MANY',
  ONE = 'ONE',
  OTHER = 'OTHER',
  TWO = 'TWO',
  ZERO = 'ZERO'
}



/** Points related property search options  */
export enum Points {
  /** Don't use loyalty points to calculate the strikeout price. */
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}














/** Options that alter behavior of mutation - for backward compatibility */
export enum PrepareCheckoutResponseOption {
  ALTERNATIVE_ACTION_ON_FAILURE = 'ALTERNATIVE_ACTION_ON_FAILURE'
}





export interface PriceDetailsOptionsInput {
  metaDeeplink: Scalars['Boolean'];
}







export enum PriceMatchPromiseChartType {
  BAR = 'BAR',
  LINE = 'LINE'
}













export enum PriceMatchPromiseScaleType {
  DATE = 'DATE',
  LABEL = 'LABEL',
  TIME = 'TIME'
}















/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: Maybe<Scalars['Float']>;
  /** The minimum price, e.g. 50.00 */
  min?: Maybe<Scalars['Float']>;
}














export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE'
}



/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;
  dropOffLocation?: Maybe<CarRentalLocationInput>;
  pickUpDateTime: DateTimeInput;
  pickUpLocation: CarRentalLocationInput;
}


/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: Array<FlightsJourneyCriteriaInput>;
  searchPreferences?: Maybe<FlightsSearchPreferencesInput>;
  travelers: Array<TravelerDetailsInput>;
  tripType: FlightsTripType;
}


/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;
  direction: GroundTransfersDirection;
  journeyCriteria?: Maybe<Array<GroundTransfersJourneyCriteriaInput>>;
  locations: Array<GroundTransfersLocationInput>;
  pinnedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  pinnedProductIds?: Maybe<Array<Scalars['String']>>;
  selectedOffers?: Maybe<Array<GroundTransfersNaturalKeyInput>>;
  shoppingPath?: Maybe<ShoppingPathType>;
  travelerDetails: Array<GroundTransfersTravelerDetailsInput>;
}


export interface PrimaryPackageSearchCriteriaInput {
  /** If not provided, packages returned will be for differrent duration and popular advance purchase window based on the themes */
  dateRange?: Maybe<DateRangeInput>;
  /** If not provided, packages returned will be for differrent destination popular based on the themes */
  destination?: Maybe<PackageLocationInput>;
  /** If not provided, it will be resolved using user profile or ip sniffing */
  origin?: Maybe<PackageLocationInput>;
  /** If not provided, it will be defaulted to 1 occupancy unit for 2 adults */
  travelerOccupancyGroups?: Maybe<Array<TravelerOccupancyGroupInput>>;
}


/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: Maybe<PropertyDateRangeInput>;
  destination: DestinationInput;
  rooms: Array<RoomInput>;
}

/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}














/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: Maybe<Scalars['String']>;
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL'
}






export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS'
}





























/** Specifies whether to open the link in the same user interface context or in a different context */
export enum ProfileLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}

















/** Represents where a wizard will be displayed */
export interface ProfileWizardContextInput {
  lineOfBusiness: LineOfBusinessDomain;
  pageLocation: PageLocation;
}









/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE'
}


export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO'
}





export enum PropertyCalendarPriceTrend {
  /** Negative price trend */
  NEGATIVE = 'NEGATIVE',
  /** Positive price trend */
  POSITIVE = 'POSITIVE'
}




export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY'
}

















export interface PropertyDateRangeInput {
  checkInDate: DateInput;
  checkOutDate: DateInput;
}






export interface PropertyDetailsMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

export enum PropertyDetailsPropertyType {
  HOTEL = 'HOTEL',
  VACATION_RENTAL = 'VACATION_RENTAL'
}







export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  ELEVATOR = 'ELEVATOR',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER',
  SERVICE_ANIMAL = 'SERVICE_ANIMAL',
  SIGN_LANGUAGE_INTERPRETER = 'SIGN_LANGUAGE_INTERPRETER',
  STAIR_FREE_PATH = 'STAIR_FREE_PATH'
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BEACH = 'BEACH',
  CASINO = 'CASINO',
  ELECTRIC_CAR = 'ELECTRIC_CAR',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  GOLF = 'GOLF',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PETS = 'PETS',
  POOL = 'POOL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI'
}


















/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}







/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: Maybe<Scalars['String']>;
  /** Meta afflid channel code */
  afflid?: Maybe<Scalars['String']>;
  /** Meta afmcid channel code */
  afmcid?: Maybe<Scalars['String']>;
  /** Meta brandcid channel code */
  brandcid?: Maybe<Scalars['String']>;
  /** Meta emlcid channel code */
  emlcid?: Maybe<Scalars['String']>;
  /** Meta emldtl channel code */
  emldtl?: Maybe<Scalars['String']>;
  /** Meta gclid channel code */
  gclid?: Maybe<Scalars['String']>;
  /** Meta icmcid channel code */
  icmcid?: Maybe<Scalars['String']>;
  /** Meta icmdtl channel code */
  icmdtl?: Maybe<Scalars['String']>;
  /** Meta k_user_id channel code */
  k_user_id?: Maybe<Scalars['String']>;
  /** Meta kword channel code */
  kword?: Maybe<Scalars['String']>;
  /** Meta lnkloc channel code */
  lnkloc?: Maybe<Scalars['String']>;
  /**
   * A consolidated list of marketing channels in key/value pairs.
   * Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}]
   */
  marketingChannels?: Maybe<Array<PropertyMarketingTagInput>>;
  /**
   * A consolidated list of marketing prices in key/value pairs.
   * Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}]
   */
  marketingPrices?: Maybe<Array<PropertyMarketingTagInput>>;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: Maybe<Scalars['Int']>;
  /** Meta mdpcid channel code */
  mdpcid?: Maybe<Scalars['String']>;
  /** Meta mdpdtl channel code */
  mdpdtl?: Maybe<Scalars['String']>;
  /** Meta olacid channel code */
  olacid?: Maybe<Scalars['String']>;
  /** Meta oladtl channel code */
  oladtl?: Maybe<Scalars['String']>;
  /** Meta semcid channel code */
  semcid?: Maybe<Scalars['String']>;
  /** Meta semdtl channel code */
  semdtl?: Maybe<Scalars['String']>;
  /** Meta seocid channel code */
  seocid?: Maybe<Scalars['String']>;
}


/**
 * An object with simple key/value combination for a marketing channel or price.
 * Example: {"key": "mctc", "value": "3"}
 */
export interface PropertyMarketingTagInput {
  key: Scalars['String'];
  value: Scalars['String'];
}


/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;
  checkOut: DateInput;
  id: Scalars['String'];
  inventoryType: InventoryType;
  noCreditCard?: Maybe<Scalars['Boolean']>;
  ratePlanId: Scalars['String'];
  ratePlanType?: Maybe<Scalars['String']>;
  roomTypeId: Scalars['String'];
  rooms: Array<PropertyRoomInput>;
  shoppingPath?: Maybe<ShoppingPathType>;
}



/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  /** Sometimes, 1 room's offer needs to be represented by more than 1 Property Natural Key, e.g: Mixed Rate Plan */
  naturalKeys: Array<PropertyNaturalKeyInput>;
  /** The index of the room user is adding */
  offerIndex: Scalars['Int'];
}




export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD'
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}



/** Indicate what are the payment options for a given offer */
export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}










/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS'
}



/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: Maybe<PropertyReviewCategory>;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: Maybe<Scalars['Boolean']>;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: Maybe<Scalars['Boolean']>;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: Maybe<Scalars['String']>;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Maybe<Scalars['Locale']>;
  /** Filter review results by a list of review ratings */
  ratings?: Maybe<Array<Scalars['Float']>>;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: Maybe<PropertyReviewType>;
  /** Filter review results by room type */
  roomTypeId?: Maybe<Scalars['Int']>;
  /** Filter review results by user provided keyword */
  searchTerm?: Maybe<Scalars['String']>;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: Maybe<Array<Scalars['String']>>;
  /** Filter review results by travel companions */
  travelCompanion?: Maybe<Array<Scalars['String']>>;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: Maybe<Array<Scalars['String']>>;
  /** Filter review results by trip reasons */
  tripReason?: Maybe<Array<Scalars['String']>>;
}





/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE'
}




/** [Optional] Review filter type */
export enum PropertyReviewType {
  /** filter reviews by rating <= 2 */
  CRITICAL = 'CRITICAL',
  /** filter reviews by rating >= 3 */
  POSITIVE = 'POSITIVE',
  /** filter reviews by latest date */
  RECENT = 'RECENT'
}





/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}


/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;
  secondary?: Maybe<ShoppingSearchCriteriaInput>;
}



/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER] will return properties with a roll in shower */
  accessibility?: Maybe<Array<PropertyFilterAccessibility>>;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: Maybe<Array<AgencyBusinessModel>>;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: Maybe<Array<PropertyFilterAmenity>>;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: Maybe<Array<Scalars['Int']>>;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: Maybe<Scalars['String']>;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: Maybe<Array<CleaningAndSafetyPractice>>;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: Maybe<Array<CommissionTier>>;
  /** Filter results by Deals */
  deals?: Maybe<Array<DealType>>;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: Maybe<Array<MealPlanFilterAmenity>>;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: Maybe<Scalars['String']>;
  /** Filter results by the payment type. */
  paymentType?: Maybe<Array<PaymentType>>;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: Maybe<Scalars['String']>;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: Maybe<PriceRangeInput>;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: Maybe<Array<Scalars['Int']>>;
  /** Filter results by user provided string */
  propertyName?: Maybe<Scalars['String']>;
  /** Property syle filters */
  propertyStyles?: Maybe<Array<PropertyStyle>>;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: Maybe<ReviewScoreRangeInput>;
  /** Rewards Type filters */
  rewards?: Maybe<Array<Scalars['String']>>;
  /** Filter results by availability */
  showAvailableOnly?: Maybe<Scalars['Boolean']>;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: Maybe<Array<Scalars['Float']>>;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: Maybe<StarRangeInput>;
  /** Filter results by Stay Type. Example: Hotels and Resorts, Vacation Rentals */
  stayTypes?: Maybe<Array<StayType>>;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: Maybe<Array<StructureType>>;
  /** An SEM theme that needs to be passed through to other services */
  theme?: Maybe<Scalars['String']>;
  /** Filter results by the type of traveler. */
  travelerType?: Maybe<Array<TravelerType>>;
  /** Filter results by VIP only properties */
  vipOnly?: Maybe<Scalars['Boolean']>;
}







export interface PropertySearchMultiItemShoppingActionInput {
  shoppingContext: ShoppingContextInput;
}

/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  ADS_ONLY = 'ADS_ONLY',
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}


export enum PropertySectionRef {
  PRICE_DISPLAY_SERVICE_RESPONSE = 'PRICE_DISPLAY_SERVICE_RESPONSE',
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES'
}



/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Maybe<Listings>;
  /** Paandi redirection to white label */
  paandiRedirection?: Maybe<Scalars['String']>;
  /** Points related property search option */
  points?: Maybe<Points>;
}

/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PACKAGE_SAVINGS = 'PACKAGE_SAVINGS',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  VACATION_RENTAL = 'VACATION_RENTAL'
}


export enum PropertyStyle {
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE'
}






/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: Maybe<Scalars['String']>;
  candidateHmGuid?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  slots?: Maybe<Scalars['String']>;
  testVersionOverride?: Maybe<Scalars['String']>;
  trackingData: Scalars['String'];
}









export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST'
}





/** Type used during a product search to specify a given numeric range like the price of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
}



export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY'
}












export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS'
}



/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN'
}


export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: Array<Scalars['String']>;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: Scalars['String'];
  /** The identifier to get the decoded value of params received in shopping response */
  updateRequestId: Scalars['String'];
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: Scalars['String'];
  offerTypeId?: Maybe<Scalars['Int']>;
}









/** Tags Associated with the response */
export enum ResponseTagType {
  CACHE_SOURCE_AIRBLAZE = 'CACHE_SOURCE_AIRBLAZE',
  CACHE_SOURCE_BYOT_AIRBLAZE = 'CACHE_SOURCE_BYOT_AIRBLAZE',
  LISTINGS_PAGINATED_SLICED = 'LISTINGS_PAGINATED_SLICED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  RESPONSE_SUMMARY_CACHED_CONFIG = 'RESPONSE_SUMMARY_CACHED_CONFIG',
  RESPONSE_SUMMARY_CACHED_ML = 'RESPONSE_SUMMARY_CACHED_ML',
  RESPONSE_SUMMARY_HYBRID = 'RESPONSE_SUMMARY_HYBRID',
  RESPONSE_SUMMARY_LIVE = 'RESPONSE_SUMMARY_LIVE',
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}








/** Enum of types of review interactions */
export enum ReviewInteractionType {
  HELPFUL_REVIEW = 'HELPFUL_REVIEW',
  REVIEW_REPORT_FLAG = 'REVIEW_REPORT_FLAG'
}


/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: Maybe<Scalars['Float']>;
  /** The minimum review score, e.g. 1.0 */
  min?: Maybe<Scalars['Float']>;
}



export enum RewardsOption {
  ALTAIR = 'ALTAIR',
  AVION = 'AVION',
  NONAVION = 'NONAVION'
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}


/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: Scalars['Int'];
  /** The number of children in the room */
  children?: Maybe<Array<ChildInput>>;
}




export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}




















/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  /** Grouping using searches made 7 days from most recent search in same region */
  SEVEN_DAYS = 'SEVEN_DAYS',
  /** Grouping using searches made 3 days from most recent search in same region */
  THREE_DAYS = 'THREE_DAYS'
}

/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  /** Grouping using multi_city_vicinity destination type for searches. */
  METRO_CITY = 'METRO_CITY'
}



/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: Scalars['String'];
  /** Search item regionId. */
  regionId: Scalars['String'];
  /** Search item region type. */
  regionType?: Maybe<Scalars['String']>;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: Scalars['String'];
}

/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: Maybe<SearchHistoryDayRange>;
  /** Search history grouping based on specified destination type. */
  destinationType?: Maybe<SearchHistoryDestinationType>;
}


/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: Maybe<Array<InterestInput>>;
  /** SEM param, fetch from URL */
  semDtl?: Maybe<Scalars['String']>;
  /** SEM param, fetch from URL */
  semdtl?: Maybe<Scalars['String']>;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: Maybe<Scalars['String']>;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: Maybe<Scalars['String']>;
}

/** The offer details from the search results page */
export interface SearchOfferInput {
  /** The price of the search results offer */
  offerPrice?: Maybe<SearchOfferPriceInput>;
  ratePlanId?: Maybe<Scalars['String']>;
  roomTypeId?: Maybe<Scalars['String']>;
}

/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: Maybe<Scalars['String']>;
  /** The timestamp of when the SRP offer price was generated */
  offerTimestamp?: Maybe<Scalars['String']>;
  /** The total price of the search offer */
  price?: Maybe<MoneyInput>;
}

/** Enum class to represent the type of seat choice */
export enum SeatChoiceType {
  SEAT_CHOICE = 'SEAT_CHOICE'
}


/** Represents seat segment for which seat map is to be shown. */
export interface SeatSegmentInput {
  /** Fare Basis Code required for traveler */
  fareBasisCode: Scalars['String'];
  /** This will be used for unique identification of segment */
  identifier: Scalars['String'];
  /** Operating Carrier Code for each segment */
  operatingCarrierCode: Scalars['String'];
}


















/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: Scalars['String'];
  value: Scalars['String'];
}





export interface ShoppedProductInput {
  products: MultiItemProductsInput;
  shoppingPath: ShoppingPathType;
}


/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: Maybe<MultiItemContextInput>;
}










/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE'
}






/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: Maybe<Array<BooleanValueInput>>;
  counts?: Maybe<Array<NumberValueInput>>;
  dates?: Maybe<Array<DateValueInput>>;
  ranges?: Maybe<Array<RangeValueInput>>;
  selections?: Maybe<Array<SelectedValueInput>>;
}





/** Valid actions on Sort and Filter Modal */
export enum ShoppingSortAndFilterActionType {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  CLEAR_DATA = 'CLEAR_DATA',
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  CLOSE_AND_APPLY = 'CLOSE_AND_APPLY',
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  CLOSE_AND_DO_NOT_APPLY = 'CLOSE_AND_DO_NOT_APPLY',
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  OPEN_MODAL = 'OPEN_MODAL'
}











export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not have to match region type, but will be used to find the relevant destination type based on region type provided */
  regionId: Scalars['String'];
}





/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: Scalars['String'];
  value: Scalars['String'];
}
















/** Input argument for Sites configurations request */
export interface SiteConfigurationsRequestInput {
  /** List of Site IDs to retrieve site information for */
  siteIds: Array<Scalars['Int']>;
}









export interface SmartFormDataInput {
  /** Timestamp at which this mutation was sent by the client. */
  timestamp: Scalars['String'];
  userInput: SmartFormUserInput;
}
















/** To define which type of keystrokes will be considered by this input. */
export enum SmartFormTextInputVariant {
  EMAIL = 'EMAIL',
  NUMERIC = 'NUMERIC',
  TEL = 'TEL',
  TEXT = 'TEXT'
}

/** Value collected corresponding to a field represented by inputId */
export interface SmartFormUserFieldInput {
  inputId: Scalars['String'];
  value: Array<Scalars['String']>;
}

/** Collection of the values collected corresponding to fields */
export interface SmartFormUserInput {
  userFieldInputs: Array<SmartFormUserFieldInput>;
}









export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS'
}


export enum SpaceSize {
  S0X = 'S0X',
  S0XH = 'S0XH',
  S1X = 'S1X',
  S2X = 'S2X',
  S3X = 'S3X',
  S4X = 'S4X',
  S5X = 'S5X',
  S6X = 'S6X',
  S8X = 'S8X',
  S10X = 'S10X',
  S11X = 'S11X',
  S12X = 'S12X',
  S14X = 'S14X',
  S16X = 'S16X',
  UNSPECIFIED = 'UNSPECIFIED'
}


/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE'
}



/** Element types - button, link etc. */
export enum SponsoredContentElementType {
  /** Button element */
  BUTTON = 'BUTTON',
  /** Hyperlink element */
  LINK = 'LINK'
}



/** Location by type */
export enum SponsoredContentLocationResolver {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  GAIA = 'GAIA',
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  TLA = 'TLA'
}






/** Input model to hold input params for queries.This includes target params which are not a part of ContextInput, and uuid. */
export interface SponsoredContentTargetInput {
  /** Domain of the page requesting the ad, required for v2 targeting */
  domain?: Maybe<Scalars['String']>;
  /** Page name Eg. page.Hotels.Infosite.Information */
  pageName: Scalars['String'];
  /** Optional as siteId in context is usually in most cases for BEX. However, it serves asan override for sites where the siteId is not numeric. Eg. HCOM, HCOM_UK etc. */
  siteId?: Maybe<Scalars['String']>;
  /** Target variant. Eg. pwa */
  variant?: Maybe<Scalars['String']>;
}

/** Input model to hold targeting params for queries. */
export interface SponsoredContentTargetingInput {
  /** number of adults included in the search */
  adults?: Maybe<Scalars['Int']>;
  /** End date of trip. Optional for dateless searches */
  dateEnd?: Maybe<DateInput>;
  /** Start date of trip. Optional for dateless searches */
  dateStart?: Maybe<DateInput>;
  /** Destination for the trip. */
  destination?: Maybe<Scalars['String']>;
  /** number of kids included in the search */
  kids?: Maybe<Scalars['Int']>;
  /** Type of location for origin and dest. */
  locationResolver?: Maybe<SponsoredContentLocationResolver>;
  /** Unique user id that represents a logged in user */
  memberId?: Maybe<Scalars['String']>;
  /** Origin for the trip. */
  origin?: Maybe<Scalars['String']>;
}



export interface StarRangeInput {
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
}






/** Property search filtering options */
export enum StayType {
  CONVENTIONAL = 'CONVENTIONAL',
  VACATION_RENTALS = 'VACATION_RENTALS'
}





export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE'
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP'
}










/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL'
}

/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export enum TextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR'
}


export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS'
}






















/** URI context to get flex content. */
export interface TravelContentUriContextInput {
  /** The attribute categorises groups of similar URIs */
  attributes: UriContextAttributesInput;
  /** Identifiers are the subcomponents that uniquely identify a URI */
  identifiers: UriContextIdentifiersInput;
}




export interface TravelStoreV1CarDetailsInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
}

export interface TravelStoreV1CarSearchInput {
  cleaningSafetyInformation: Scalars['Boolean'];
  filterOptions: Array<Scalars['String']>;
  messagingOptions: Array<Scalars['String']>;
  periodPricing: Scalars['Boolean'];
  showAds: Scalars['Boolean'];
  sortOptions: Array<Scalars['String']>;
}



/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: Maybe<Scalars['Int']>;
  type: TravelerDetailsType;
}

/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}


export interface TravelerOccupancyGroupInput {
  travelers: Array<TravelerDetailsInput>;
}


export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  LGBT = 'LGBT',
  ROMANTIC = 'ROMANTIC'
}





export enum TripCareButtonAction {
  BACK = 'BACK',
  CANCEL_POLICY = 'CANCEL_POLICY',
  DISMISS_POPUP = 'DISMISS_POPUP',
  POPUP = 'POPUP',
  RELOAD = 'RELOAD'
}

export enum TripCareButtonState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}














export enum TripCareLayoutStyle {
  CARD_BORDER_TOP = 'CARD_BORDER_TOP'
}



export enum TripCareListType {
  BULLET = 'BULLET',
  NO_BULLET = 'NO_BULLET',
  NUMBERED = 'NUMBERED'
}




export enum TripCarePhraseStyle {
  BOLD = 'BOLD',
  HR_DIVIDER_BOTTOM = 'HR_DIVIDER_BOTTOM',
  HR_DIVIDER_TOP = 'HR_DIVIDER_TOP',
  SIZE_100 = 'SIZE_100',
  SIZE_200 = 'SIZE_200',
  SIZE_300 = 'SIZE_300',
  SIZE_400 = 'SIZE_400',
  SIZE_500 = 'SIZE_500',
  SIZE_600 = 'SIZE_600',
  SIZE_700 = 'SIZE_700',
  SIZE_800 = 'SIZE_800',
  SIZE_900 = 'SIZE_900',
  SMALL = 'SMALL',
  SPACING_FOUR = 'SPACING_FOUR',
  SPACING_HALF = 'SPACING_HALF',
  SPACING_ONE = 'SPACING_ONE',
  SPACING_SIX = 'SPACING_SIX',
  SPACING_THREE = 'SPACING_THREE',
  SPACING_TWO = 'SPACING_TWO',
  THEME_EMPHASIS = 'THEME_EMPHASIS',
  THEME_NEGATIVE = 'THEME_NEGATIVE',
  THEME_POSITIVE = 'THEME_POSITIVE',
  WEIGHT_BOLD = 'WEIGHT_BOLD',
  WEIGHT_MEDIUM = 'WEIGHT_MEDIUM',
  WEIGHT_REGULAR = 'WEIGHT_REGULAR'
}

export enum TripCarePhraseType {
  BUTTON = 'BUTTON',
  LINK = 'LINK',
  TEXT = 'TEXT'
}





/** The `TripCreationEntryPoint` defines a list of supported trip creation entry points. */
export enum TripCreationEntryPoint {
  HOTEL_SEARCH_RESULTS = 'HOTEL_SEARCH_RESULTS',
  TRIPS_LIST = 'TRIPS_LIST',
  TRIP_OVERVIEW = 'TRIP_OVERVIEW'
}






export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}







/**
 * "The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain, plus an optional filter known to the Trips Graph.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Item Details view for functions such as back navigation.
 */
export interface TripItemInput {
  filter?: Maybe<Scalars['String']>;
  tripItemId: Scalars['String'];
  tripViewId: Scalars['String'];
}



/**
 * The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain and an optional `filter` known by the Trips Graph Service.
 * The tripViewId identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.
 * The server will determine how much of the trip and which actions to return based on the sharing rules associated with the TripViewId.
 * The set of supported filters is the same as defined in `TripsFilterInput` and provides context to the Trip Overview view for functions such as back navigation.
 */
export interface TripOverviewInput {
  filter?: Maybe<Scalars['String']>;
  tripViewId: Scalars['String'];
}







/** Supported Trips badge themes */
export enum TripsBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  SAVED = 'SAVED',
  STATUS_NEGATIVE = 'STATUS_NEGATIVE',
  STATUS_POSITIVE = 'STATUS_POSITIVE',
  VIP = 'VIP'
}




export enum TripsButtonWidth {
  MATCH_PARENT_CONTAINER = 'MATCH_PARENT_CONTAINER',
  WRAP_CONTENT = 'WRAP_CONTENT'
}







/** Represents a TripsCard's selection/active state */
export enum TripsCardState {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}
















export enum TripsContentType {
  PDF = 'PDF'
}


/** Display theme for TripsContentUnorderedList */
export enum TripsContentUnorderedListTheme {
  /** The Unordered List should be displayed with bullets */
  BULLETS = 'BULLETS',
  /** The Unordered List should be displayed with no bullets */
  NO_BULLETS = 'NO_BULLETS'
}














/**
 * The `TripsFilterInput` contains a filter identifier.
 * The set of supported filter identifiers is defined by the Trips Graph Service and may represent a simple filter like Upcoming or Past or an arbitrarily complex filter defined by an ML algorithm.
 * See the Trips Graph team for a list of reserved values.
 */
export interface TripsFilterInput {
  filter: Scalars['String'];
}


/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export enum TripsFittedImageType {
  BARCODE = 'BARCODE',
  E_FRANKING_STAMP = 'E_FRANKING_STAMP',
  QR_CODE = 'QR_CODE'
}






















export enum TripsLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}











/** The type of map marker */
export enum TripsMarkerType {
  ACTIVITYEVENTMARKER = 'ActivityEventMarker',
  ACTIVITYGUESTPICKUPMARKER = 'ActivityGuestPickupMarker',
  ACTIVITYLOCATIONMARKER = 'ActivityLocationMarker',
  ACTIVITYREDEMPTIONMARKER = 'ActivityRedemptionMarker',
  AIRPORTMARKER = 'AirportMarker',
  CARMARKER = 'CarMarker',
  CRUISEMARKER = 'CruiseMarker',
  HOTELMARKER = 'HotelMarker',
  PLACEMARKER = 'PlaceMarker'
}

























/**
 * The `TripsPlanInput` contains an itemId and source. The `itemId` represents the identifier of the item being saved, e.g hotel id.
 * The `source` is the page or view from which the save is being requested.
 */
export interface TripsPlanInput {
  itemId: Scalars['String'];
  source: TripsPlanSourceType;
}

/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export enum TripsPlanSourceType {
  HOTEL_SEARCH = 'HOTEL_SEARCH'
}





/** Stay input details */
export interface TripsSaveStayInput {
  checkInDate?: Maybe<DateTimeInput>;
  checkoutDate?: Maybe<DateTimeInput>;
  propertyId: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  roomConfiguration?: Maybe<Array<TripsStayRoomTravelerInfoInput>>;
}







/** Stay room traveler information */
export interface TripsStayRoomTravelerInfoInput {
  childrenAges: Array<Scalars['Int']>;
  numberOfAdults: Scalars['Int'];
}



























/** Specifies whether to open the link in the same user interface context or in a different context */
export enum UiLinkTarget {
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL'
}









export enum UiSignal {
  BOOKING_SUCCESS = 'BOOKING_SUCCESS',
  GENERIC_DOWNSTREAM_ERROR = 'GENERIC_DOWNSTREAM_ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PRICE_ADJUSTED = 'PRICE_ADJUSTED',
  PRICE_CHANGED = 'PRICE_CHANGED',
  UNKNOWN = 'UNKNOWN',
  UNRECOVERABLE_FAILURE = 'UNRECOVERABLE_FAILURE'
}











export interface UniversalLoginContextInput {
  codeChallenge: Scalars['String'];
  codeRequest: Scalars['String'];
  redirectUrl?: Maybe<Scalars['String']>;
  state: Scalars['String'];
}

export enum UpdateTripType {
  ADD = 'ADD',
  REMOVE = 'REMOVE'
}


export interface UriContextAttributesInput {
  affinity?: Maybe<Scalars['String']>;
  airCarrierCode?: Maybe<Scalars['String']>;
  carClass?: Maybe<Scalars['String']>;
  carSupplier?: Maybe<Scalars['String']>;
  gaiaType?: Maybe<Scalars['String']>;
  lodgingUrlCode?: Maybe<Scalars['String']>;
  starRating?: Maybe<Scalars['String']>;
}

export interface UriContextIdentifiersInput {
  destination: Scalars['String'];
  /** Only for PDP pages */
  hotelId?: Maybe<Scalars['Int']>;
  origin?: Maybe<Scalars['String']>;
}





export interface UserLocationInput {
  userCountryCode?: Maybe<Scalars['String']>;
  userLatitude?: Maybe<Scalars['BigDecimal']>;
  userLongitude?: Maybe<Scalars['BigDecimal']>;
  userSelectedOrigin?: Maybe<Scalars['String']>;
}




















export type AddPropertyToCartMutationVariables = Exact<{
  id: Scalars['UUID'];
  context: ContextInput;
  propertyOffer: PropertyOfferInput;
  cartPropertySearchContextInput: CartPropertySearchContextInput;
}>;


export type AddPropertyToCartMutation = { __typename: 'Mutation', cartItems: { __typename: 'CartMutations', addProperty: { __typename: 'CartSummary', id: any, itemCount: number } } };

export type CreateMultiItemSessionMutationVariables = Exact<{
  context: ContextInput;
  multiItemSearchContext: MultiItemSearchContextInput;
}>;


export type CreateMultiItemSessionMutation = { __typename: 'Mutation', createMultiItemSession: { __typename: 'MultiItemSearchContextCreatedResponse', shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'MultiItemSearchContextErrorResponse' } };

export type CreateSessionCartMutationVariables = Exact<{
  context: ContextInput;
  cartOptions: CartOptionsInput;
}>;


export type CreateSessionCartMutation = { __typename: 'Mutation', createSessionCart: { __typename: 'Cart', id: any } };

export type EmptyCartMutationVariables = Exact<{
  context: ContextInput;
  id: Scalars['UUID'];
}>;


export type EmptyCartMutation = { __typename: 'Mutation', cartItems: { __typename: 'CartMutations', emptyCart: { __typename: 'CartSummary', id: any, itemCount: number } } };

export type FederatedCartQueryVariables = Exact<{
  context: ContextInput;
  id?: Maybe<Scalars['UUID']>;
}>;


export type FederatedCartQuery = { __typename: 'Query', cart: { __typename: 'Cart', itemCount: number, items: Array<{ __typename: 'PropertyCartItem', id: any, offers: Array<{ __typename: 'PropertyOffer', offerIndex: number, naturalKeys: Array<{ __typename: 'PropertyNaturalKey', id: string, roomTypeId: string, ratePlanId: string, inventoryType: InventoryType, checkIn: { __typename: 'Date', isoFormat: string }, checkOut: { __typename: 'Date', isoFormat: string }, rooms: Array<{ __typename: 'PropertyRoom', numberOfAdults: number, childAges: Array<number> }> }> }> }> } };

export type CartQueryVariables = Exact<{
  context: ContextInput;
  id?: Maybe<Scalars['UUID']>;
}>;


export type CartQuery = { __typename: 'Query', cart: { __typename: 'Cart', itemCount: number, items: Array<{ __typename: 'PropertyCartItem', id: any, offers: Array<{ __typename: 'PropertyOffer', offerIndex: number, naturalKeys: Array<{ __typename: 'PropertyNaturalKey', id: string, roomTypeId: string, ratePlanId: string, ratePlanType?: Maybe<string>, inventoryType: InventoryType, checkIn: { __typename: 'Date', isoFormat: string }, checkOut: { __typename: 'Date', isoFormat: string }, rooms: Array<{ __typename: 'PropertyRoom', numberOfAdults: number, childAges: Array<number> }> }>, offer?: Maybe<{ __typename: 'OfferDetails', marketingChannelId?: Maybe<number>, units: Array<{ __typename: 'PropertyUnit', name?: Maybe<string>, photos: Array<{ __typename: 'Image', description: string, url: any }>, ratePlans: Array<{ __typename: 'RatePlan', priceDetails: Array<{ __typename: 'Offer', availability?: Maybe<{ __typename: 'PropertyAvailability', available: boolean, minRoomsLeft?: Maybe<number> }>, offerBookButton?: Maybe<{ __typename: 'LodgingForm', inputs?: Maybe<Array<{ __typename: 'LodgingTextInput', name?: Maybe<string>, value?: Maybe<string> }>> }>, price?: Maybe<{ __typename: 'PropertyPrice', total?: Maybe<{ __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } }>, lead?: Maybe<{ __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } }> }>, priceAfterLoyaltyPointsApplied?: Maybe<{ __typename: 'PropertyPrice', total?: Maybe<{ __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } }>, lead?: Maybe<{ __typename: 'Money', formatted: string, raw: number, currency: { __typename: 'Currency', code: string, name: string, symbol: string } }> }>, fees: Array<{ __typename: 'Fees', description?: Maybe<string> }> }> }> }> }> }>, summary?: Maybe<{ __typename: 'PropertySummary', name: string, location?: Maybe<{ __typename: 'PropertyLocation', address?: Maybe<{ __typename: 'PropertyAddress', city?: Maybe<string> }> }> }>, gallery?: Maybe<{ __typename: 'PropertyGallery', featured?: Maybe<{ __typename: 'Image', url: any }> }> }> } };

export type InitiateMultiItemSessionMutationVariables = Exact<{
  context: ContextInput;
  searchContext: MultiItemSearchContextInput;
}>;


export type InitiateMultiItemSessionMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', initiate: { __typename: 'MultiItemSearchContextCreatedResponse', redirectUrl?: Maybe<any>, shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: Maybe<string> } } };

export type PropertyLocationScoreInfoQueryVariables = Exact<{
  propertyIds: Array<Scalars['String']> | Scalars['String'];
  context: ContextInput;
}>;


export type PropertyLocationScoreInfoQuery = { __typename: 'Query', propertyReviewAggregates: { __typename: 'PropertyReviewAggregates', propertySummaries?: Maybe<Array<{ __typename: 'LodgingReviewSummary', propertyId: string, locationScore?: Maybe<{ __typename: 'SummaryUnit', score?: Maybe<string>, tags: Array<{ __typename: 'Tag', label: string }> }> }>> } };

export type LodgingPwaPropertySearchQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  rooms?: Maybe<Array<RoomInput> | RoomInput>;
  dateRange?: Maybe<PropertyDateRangeInput>;
  sort?: Maybe<PropertySort>;
  filters?: Maybe<PropertySearchFiltersInput>;
  marketing?: Maybe<PropertyMarketingInfoInput>;
  legacyCriteria?: Maybe<LegacyPropertySearchCriteriaInput>;
  propertyShopOptions?: Maybe<PropertyShopOptionsInput>;
  searchPagination?: Maybe<PaginationInput>;
  searchIntent?: Maybe<SearchIntentInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
  criteria?: Maybe<PropertySearchCriteriaInput>;
  shouldFetchSortAndFilter?: Maybe<Scalars['Boolean']>;
}>;


export type LodgingPwaPropertySearchQuery = { __typename: 'Query', propertySearch: { __typename: 'PropertySearchResults', searchCriteria: { __typename: 'SearchCriteria', sort?: Maybe<PropertySort>, propertyShopOptions?: Maybe<{ __typename: 'PropertyShopOptions', points?: Maybe<Points> }>, dateRange: { __typename: 'PropertyDateRange', checkInDate: (
          { __typename: 'Date' }
          & CommonDateFieldsFragment
        ), checkOutDate: (
          { __typename: 'Date' }
          & CommonDateFieldsFragment
        ) }, destination: { __typename: 'Destination', regionId?: Maybe<string>, regionName?: Maybe<string> }, searchIntent?: Maybe<{ __typename: 'SearchIntent', theme?: Maybe<string>, userIntent?: Maybe<string>, semdtl?: Maybe<string> }>, filters?: Maybe<{ __typename: 'PropertySearchFilters', accessibility?: Maybe<Array<PropertyFilterAccessibility>>, amenities?: Maybe<Array<PropertyFilterAmenity>>, bedroomFilter?: Maybe<Array<number>>, commissionTiers?: Maybe<Array<CommissionTier>>, agencyBusinessModels?: Maybe<Array<AgencyBusinessModel>>, deals?: Maybe<Array<DealType>>, paymentType?: Maybe<Array<PaymentType>>, poi?: Maybe<string>, priceBuckets?: Maybe<Array<number>>, propertyName?: Maybe<string>, propertyStyles?: Maybe<Array<PropertyStyle>>, starList?: Maybe<Array<number>>, structureTypes?: Maybe<Array<StructureType>>, stayTypes?: Maybe<Array<StayType>>, travelerType?: Maybe<Array<TravelerType>>, mealPlan?: Maybe<Array<MealPlanFilterAmenity>>, cleaningAndSafetyPractices?: Maybe<Array<CleaningAndSafetyPractice>>, reviewScore?: Maybe<{ __typename: 'ReviewScoreRange', min?: Maybe<number>, max?: Maybe<number> }> }> }, sortAndFilter?: Maybe<{ __typename: 'SortAndFilter', defaults?: Maybe<{ __typename: 'SortAndFilterDefaults', sort: PropertySort, regionId?: Maybe<string> }>, selected?: Maybe<{ __typename: 'SortAndFilterSelected', star?: Maybe<string>, priceFilterPills?: Maybe<{ __typename: 'PriceFilterPills', buckets?: Maybe<Array<number>>, aggregate?: Maybe<{ __typename: 'PriceFilterPillsAggregate', label?: Maybe<string>, value?: Maybe<string> }> }> }>, options?: Maybe<{ __typename: 'SortAndFilterViewModel', accessibilityLabel?: Maybe<string>, appliedFilterCount: number, sortAndFilter: Array<{ __typename: 'FilterViewModel', selected: boolean, isRange?: Maybe<boolean>, label?: Maybe<string>, max?: Maybe<number>, min?: Maybe<number>, placeholder?: Maybe<string>, step?: Maybe<number>, subLabel?: Maybe<string>, name: string, title: string, hiddenThreshold?: Maybe<number>, showListOptions?: Maybe<{ __typename: 'ExpandoPeekOptions', seeMoreLabel: string, seeLessLabel: string, hiddenThreshold: number }>, dropdownOptions?: Maybe<{ __typename: 'ShowDropdownOptions', isDropDownVisible?: Maybe<ActionDetailsType> }>, options: Array<{ __typename: 'OptionViewModel', selectedLabel?: Maybe<string>, ariaLabel?: Maybe<string>, description?: Maybe<string>, icon?: Maybe<string>, isSelected: boolean, label?: Maybe<string>, value?: Maybe<string>, optionValue?: Maybe<string>, filterType?: Maybe<string>, range?: Maybe<{ __typename: 'FilterOptionRange', min?: Maybe<number>, max?: Maybe<number> }> }> }> }> }>, propertySearchListings: Array<{ __typename: 'LodgingCard' } | { __typename: 'LodgingHeading', value: string, size: number, tag?: Maybe<string> } | { __typename: 'LodgingIntentCard' } | (
      { __typename: 'MessageResult' }
      & MessageFieldsFragment
    ) | (
      { __typename: 'Property' }
      & PropertyFieldsFragment
    ) | { __typename: 'StaticLodgingMultiItemCrossSell', crossSellProductType: LodgingCrossSellProductType, fallbackListing?: Maybe<(
        { __typename: 'MessageResult' }
        & MessageFieldsFragment
      )> }>, summary: { __typename: 'PropertyResultsSummary', pricedHotelSize: number, matchedPropertiesSize: number, resultsHeading?: Maybe<string>, resultsSummary?: Maybe<Array<(
        { __typename: 'LodgingDialogTriggerMessage', value: string }
        & SearchDialogMessageFragment
      ) | (
        { __typename: 'LodgingLinkMessage', value: string }
        & SearchLinkMessageFragment
      ) | { __typename: 'LodgingPlainMessage', value: string }>>, region?: Maybe<{ __typename: 'Region', name: string, id: string }>, resultSectionHeadings?: Maybe<Array<{ __typename: 'ResultSectionHeading', heading: string, index: number }>>, loyaltyEducation?: Maybe<{ __typename: 'LoyaltyEducation', title?: Maybe<string>, action?: Maybe<{ __typename: 'LoyaltyEducationAction', href?: Maybe<string>, rfrr?: Maybe<string>, text?: Maybe<string> }>, content: (
          { __typename: 'LoyaltyPointsEducation' }
          & PointsEducationFragmentFragment
        ) | (
          { __typename: 'LoyaltyProgramEducation' }
          & ProgramEducationFragmentFragment
        ) }>, loyaltyInfo?: Maybe<{ __typename: 'PropertyLoyaltyDiscount', pointsAppliedMessage?: Maybe<string>, saveWithPointsMessage?: Maybe<string>, saveWithPointsActionMessage?: Maybe<string> }> }, navigationTabs?: Maybe<{ __typename: 'NavigationTabs', tabs: Array<{ __typename: 'PropertyNavigationBarTab', localizedName: string, sectionName: string, state?: Maybe<string>, tabLink?: Maybe<{ __typename: 'LodgingLinkMessage', value: string, link: { __typename: 'LodgingLink', url: any, target?: Maybe<string>, uri: { __typename: 'HttpURI', value: string } } }> }> }>, map?: Maybe<{ __typename: 'PropertySearchMap', staticMapSrc?: Maybe<string>, title: string, subtitle?: Maybe<string>, zoom: number, bounds: { __typename: 'Bounds', northeast: { __typename: 'Coordinates', latitude: number, longitude: number }, southwest: { __typename: 'Coordinates', latitude: number, longitude: number } }, center: { __typename: 'Coordinates', latitude: number, longitude: number }, markers: Array<{ __typename: 'PointOfInterest', name: string, mapMarker: { __typename: 'MapMarker', label: string, icon: MapIconType, type?: Maybe<MarkerType>, latLong: { __typename: 'Coordinates', latitude: number, longitude: number }, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }> } } | (
        { __typename: 'Property', mapMarker?: Maybe<{ __typename: 'MapMarker', label: string, icon: MapIconType, type?: Maybe<MarkerType>, latLong: { __typename: 'Coordinates', latitude: number, longitude: number }, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }> }> }
        & CommonPropertyCardFieldsFragment
      )>, messagingModel?: Maybe<{ __typename: 'MessageResult', type?: Maybe<MessageType>, title?: Maybe<{ __typename: 'MessagingResultTitle', text?: Maybe<string>, theme?: Maybe<Theme>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }>, subtitle?: Maybe<{ __typename: 'MessagingResultTitle', text?: Maybe<string>, theme?: Maybe<Theme>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }> }> }>, exitIntent?: Maybe<{ __typename: 'ExitIntent', logoUrl?: Maybe<string>, backgroundImageUrl?: Maybe<string>, clickHereLinkUrl?: Maybe<string>, message: { __typename: 'ExitIntentMessage', headingOne?: Maybe<string>, headingTwo?: Maybe<string>, headingThree?: Maybe<string>, couponCode?: Maybe<string>, percentOff?: Maybe<string>, termsAndConditionsOne?: Maybe<string>, termsAndConditionsTwo?: Maybe<string>, clickHere?: Maybe<string> } }>, legalDisclaimer?: Maybe<{ __typename: 'DisclaimerContentMarkup', content: Array<{ __typename: 'MarkupText', markupType: MarkupTextType, text: string }> }>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> }>, multiItemSearchContext?: Maybe<(
      { __typename: 'MultiItemSearchContext', cars?: Maybe<Array<{ __typename: 'CarSearchCriteria', primary: { __typename: 'PrimaryCarCriteria', pickUpDateTime: (
            { __typename: 'DateTime' }
            & CommonDateTimeFieldsFragment
          ), dropOffDateTime: (
            { __typename: 'DateTime' }
            & CommonDateTimeFieldsFragment
          ), pickUpLocation: { __typename: 'CarRentalLocation', airportCode?: Maybe<string> }, dropOffLocation?: Maybe<{ __typename: 'CarRentalLocation', airportCode?: Maybe<string> }> } }>>, flights?: Maybe<Array<{ __typename: 'FlightSearchCriteria', primary: { __typename: 'PrimaryFlightCriteria', tripType: FlightsTripType, travelers: Array<{ __typename: 'TravelerDetails', type: TravelerDetailsType, age?: Maybe<number> }>, journeyCriterias: Array<{ __typename: 'FlightsJourneyCriteria', destination: string, origin: string, departureDate: { __typename: 'Date', day: number, month: number, year: number } }>, searchPreferences?: Maybe<{ __typename: 'FlightsSearchPreferences', airline?: Maybe<string>, advancedFilters?: Maybe<Array<FlightsAdvancedFilterType>>, cabinClass: FlightsCabinClass }> } }>> }
      & MultiItemPropertySearchContextFieldsFragment
    )>, errorResponse?: Maybe<{ __typename: 'LodgingErrorResponse', header?: Maybe<string>, body?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }>, button: { __typename: 'UIPrimaryButton', primary?: Maybe<string>, disabled: boolean, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'EGULSubmitAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'IncentivesActionLink' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PaymentFormFieldAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UIFlightAction' } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'TelURI' } } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' }> }, errorRecoveryButtons?: Maybe<Array<{ __typename: 'UITertiaryButton', primary?: Maybe<string>, disabled: boolean, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'EGULSubmitAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'IncentivesActionLink' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PaymentFormFieldAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UIFlightAction' } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'TelURI' } } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' }> }>> }>, dialogErrorResponse?: Maybe<{ __typename: 'LodgingDialogErrorResponse', body: string, button: { __typename: 'UIPrimaryButton', primary?: Maybe<string>, disabled: boolean, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction' } | { __typename: 'ActivityCloseDialogAction' } | { __typename: 'ActivityMultiItemTripUpdateAction' } | { __typename: 'ActivityOpenDialogAction' } | { __typename: 'ActivityOpenOffersModalAction' } | { __typename: 'ActivityPaginationAction' } | { __typename: 'ActivityRemoveOffersFromTripAction' } | { __typename: 'ActivityUpdateOfferInTripAction' } | { __typename: 'AirCreditWebAction' } | { __typename: 'CDFOpenFormAction' } | { __typename: 'CDFOpenNextPageAction' } | { __typename: 'CDFSubmitFormAction' } | { __typename: 'CouponAndCreditAction' } | { __typename: 'CouponAndCreditChatbotAction' } | { __typename: 'CouponsAndCreditsSimpleAction' } | { __typename: 'CrossSellButtonAction' } | { __typename: 'CrossSellLinkAction' } | { __typename: 'CruiseAction' } | { __typename: 'DirectFeedbackOpenFormAction' } | { __typename: 'DirectFeedbackOpenNextPageAction' } | { __typename: 'DirectFeedbackSubmitFormAction' } | { __typename: 'EGDSOpenDatePickerAction' } | { __typename: 'EGDSOpenTravelerSelectorAction' } | { __typename: 'EGDSSubmitSearchFormAction' } | { __typename: 'EGULSubmitAction' } | { __typename: 'FlightsCreditSelectorOpenUIAction' } | { __typename: 'FlightsDialogCloseUIAction' } | { __typename: 'FlightsDialogTriggerUIAction' } | { __typename: 'GroundTransfersBookAction' } | { __typename: 'GroundTransfersDetailsOpenAction' } | { __typename: 'GroundTransfersDismissAction' } | { __typename: 'GroundTransfersLinkClickAction' } | { __typename: 'GroundTransfersMultiItemTripUpdateAction' } | { __typename: 'GroundTransfersSelectionClickAction' } | { __typename: 'IncentivesActionLink' } | { __typename: 'MemberWalletBadge' } | { __typename: 'MemberWalletUIAction' } | { __typename: 'MishopDetailsUIAction' } | { __typename: 'MultiItemCrossSellUIButtonAction' } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction' } | { __typename: 'MultiItemCrossSellUILinkAction' } | { __typename: 'OpenTypeaheadAction' } | { __typename: 'PaymentDialogButtonAction' } | { __typename: 'PaymentDialogElement' } | { __typename: 'PaymentFormFieldAction' } | { __typename: 'ProfileAccountFormSubmitAction' } | { __typename: 'ProfileAddMembershipAction' } | { __typename: 'ProfileFormSubmitAction' } | { __typename: 'ProfileLinkAction' } | { __typename: 'ProfileReloadAction' } | { __typename: 'ProfileUpdateMembershipAction' } | { __typename: 'QuoteAction' } | { __typename: 'ShoppingSortAndFilterAction' } | { __typename: 'UIFlightAction' } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }, resource: { __typename: 'GeoURI' } | { __typename: 'HttpURI', relativePath: string, value: string } | { __typename: 'MailToURI' } | { __typename: 'MobileAppURI' } | { __typename: 'TelURI' } } | { __typename: 'WizardAdditionalUserInputRequiredAction' } | { __typename: 'WizardSubmitAction' }> } }> } };

export type MultiItemPropertySearchContextFieldsFragment = { __typename: 'MultiItemSearchContext', properties?: Maybe<Array<{ __typename: 'PropertySearchCriteria', primary: { __typename: 'PrimaryPropertyCriteria', rooms: Array<{ __typename: 'Room', adults: number }>, destination: { __typename: 'Destination', regionId?: Maybe<string>, regionName?: Maybe<string> }, dateRange?: Maybe<{ __typename: 'PropertyDateRange', checkInDate: (
          { __typename: 'Date' }
          & CommonDateFieldsFragment
        ), checkOutDate: (
          { __typename: 'Date' }
          & CommonDateFieldsFragment
        ) }> } }>> };

export type MessageFieldsFragment = { __typename: 'MessageResult', index?: Maybe<number>, type?: Maybe<MessageType>, title?: Maybe<(
    { __typename: 'MessagingResultTitle' }
    & MessageTitleFieldsFragment
  )>, subtitle?: Maybe<(
    { __typename: 'MessagingResultTitle' }
    & MessageTitleFieldsFragment
  )>, action?: Maybe<{ __typename: 'MessagingResultAction', primary?: Maybe<(
      { __typename: 'MessagingAction' }
      & MessagingActionFieldsFragment
    )>, secondary?: Maybe<(
      { __typename: 'MessagingAction' }
      & MessagingActionFieldsFragment
    )> }> };

export type MessageTitleFieldsFragment = { __typename: 'MessagingResultTitle', text?: Maybe<string>, theme?: Maybe<Theme>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }>, mark?: Maybe<{ __typename: 'LodgingMark', description: string, id: string }>, illustration?: Maybe<{ __typename: 'LodgingIllustration', description?: Maybe<string>, assetUri?: Maybe<{ __typename: 'HttpURI', value: string }> }> };

export type MessagingActionFieldsFragment = { __typename: 'MessagingAction', linkUrl: string, referrerId?: Maybe<string>, text?: Maybe<string>, actionDetails?: Maybe<{ __typename: 'ActionDetails', details?: Maybe<string>, name: ActionDetailsType, title?: Maybe<string>, accessibilityLabel?: Maybe<string> }> };

export type PropertyFieldsFragment = (
  { __typename: 'Property', star?: Maybe<number>, starRatingIcon: string, supportingMessages?: Maybe<Array<string>>, highlightedPropertyDetails: Array<string>, amenities: Array<{ __typename: 'PropertyAmenityValue', icon: string, name: string }>, availability: { __typename: 'PropertyAvailability', available: boolean, text?: Maybe<string>, theme?: Maybe<Theme> }, offerSummary: { __typename: 'OfferSummary', messages?: Maybe<Array<{ __typename: 'OfferSummaryMessage', message?: Maybe<string>, theme?: Maybe<Theme>, type?: Maybe<string>, mark?: Maybe<{ __typename: 'Mark', id: string, url?: Maybe<{ __typename: 'HttpURI', value: string }> }> }>> }, legalDisclaimer?: Maybe<{ __typename: 'PropertyLegalDisclaimer', title?: Maybe<string>, disclaimerContents?: Maybe<Array<string>> }>, imageGallery?: Maybe<{ __typename: 'PropertyImageGallery', accessibilityLabel?: Maybe<string>, images: Array<{ __typename: 'PropertyImage', subjectId?: Maybe<number>, imageId?: Maybe<string>, image: { __typename: 'Image', url: any, description: string }, fallbackImage?: Maybe<{ __typename: 'Image', url: any, description: string }> }> }>, mapMarker?: Maybe<{ __typename: 'MapMarker', icon: MapIconType, label: string, type?: Maybe<MarkerType>, latLong: { __typename: 'Coordinates', latitude: number, longitude: number }, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }> }>, neighborhood?: Maybe<{ __typename: 'Region', name: string }>, offerBadge?: Maybe<{ __typename: 'OfferBadge', primary?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string }>, mark?: Maybe<{ __typename: 'Mark', id: string, description: string }> }>, secondary?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string, title?: Maybe<string> }> }> }>, pinnedDetails?: Maybe<{ __typename: 'PinnedPropertyModel', heading: string }>, recentlyViewed?: Maybe<{ __typename: 'Icon', id: string, description: string }>, featuredMessages?: Maybe<Array<(
    { __typename: 'LodgingEnrichedMessage' }
    & FeaturedMessageFragment
  )>>, shortList?: Maybe<{ __typename: 'ShortList', favorited: boolean, saveUrl: string, removeUrl: string, metaData: { __typename: 'ShortListMetaData', chkIn: string, chkOut: string, hotelId: string, roomConfiguration: string } }>, propertySource?: Maybe<{ __typename: 'PropertySource', accessibilityLabel?: Maybe<string>, label?: Maybe<string>, graphic?: Maybe<{ __typename: 'Icon' } | { __typename: 'Illustration' } | { __typename: 'Mark', description: string, id: string, size?: Maybe<string>, token: string, url?: Maybe<{ __typename: 'HttpURI', value: string }> }>, text: { __typename: 'LodgingPlainMessage', value: string } }>, dataAttributes?: Maybe<{ __typename: 'GraphQLPair', key: string, value: string }>, listingFooter?: Maybe<{ __typename: 'MessagingAction', linkUrl: string, referrerId?: Maybe<string>, text?: Maybe<string>, actionDetails?: Maybe<{ __typename: 'ActionDetails', name: ActionDetailsType }>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }> }
  & CommonPropertyCardFieldsFragment
);

export type SearchLinkMessageFragment = { __typename: 'LodgingLinkMessage', label?: Maybe<string>, link: (
    { __typename: 'LodgingLink' }
    & SearchLinkFragment
  ), icon?: Maybe<{ __typename: 'Icon', id: string }> };

export type SearchDialogMessageFragment = { __typename: 'LodgingDialogTriggerMessage', dialogTrigger: { __typename: 'LodgingDialogTrigger', dialogName: string, referrerId?: Maybe<string>, actionDetails?: Maybe<{ __typename: 'DialogAction', linkUrl: string, referrerId?: Maybe<string>, message?: Maybe<string>, text?: Maybe<string> }> }, icon?: Maybe<{ __typename: 'Icon', id: string }> };

export type SearchLinkFragment = { __typename: 'LodgingLink', url: any, referrerId?: Maybe<string> };

export type DisplayPriceFragmentFragment = { __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: Maybe<string> }, disclaimer?: Maybe<{ __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: Maybe<{ __typename: 'UIPrimaryButton', accessibility?: Maybe<string>, primary?: Maybe<string> }> }> };

export type EnrichedMessageFragmentFragment = { __typename: 'LodgingEnrichedMessage', value: string, state?: Maybe<string> };

export type CommonPropertyCardFieldsFragment = { __typename: 'Property', id: string, name: string, vipMessaging?: Maybe<string>, propertyImage?: Maybe<{ __typename: 'PropertyImage', image: { __typename: 'Image', description: string, url: any }, fallbackImage?: Maybe<{ __typename: 'Image', description: string, url: any }> }>, offerBadge?: Maybe<{ __typename: 'OfferBadge', primary?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string }>, mark?: Maybe<{ __typename: 'Mark', id: string, description: string }> }>, secondary?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string }> }> }>, price?: Maybe<{ __typename: 'PropertyPrice', alignment?: Maybe<string>, strikeOutType?: Maybe<StrikeOutType>, roomNightMessage?: Maybe<string>, displayMessages?: Maybe<Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<(
        { __typename: 'DisplayPrice' }
        & DisplayPriceFragmentFragment
      ) | (
        { __typename: 'LodgingEnrichedMessage' }
        & EnrichedMessageFragmentFragment
      )> }>>, lead?: Maybe<{ __typename: 'Money', formatted: string }>, strikeOut?: Maybe<{ __typename: 'Money', formatted: string }>, disclaimer?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }>, priceMessages?: Maybe<Array<{ __typename: 'LodgingPlainMessage', value: string }>>, marketingFeeDetails?: Maybe<{ __typename: 'MarketingFeeDetails', tierName: string, tierIcon: string, marketingFeeMessage: { __typename: 'LodgingPlainMessage', value: string } }>, options?: Maybe<Array<{ __typename: 'PropertyPriceOption', leadingCaption?: Maybe<string>, displayPrice?: Maybe<{ __typename: 'Money', formatted: string }>, strikeOut?: Maybe<{ __typename: 'Money', formatted: string }>, loyaltyPrice?: Maybe<{ __typename: 'LoyaltyPrice', unit?: Maybe<string>, amount?: Maybe<{ __typename: 'FormattedNumber', formatted: string }>, totalStrikeOutPoints?: Maybe<{ __typename: 'FormattedNumber', formatted: string }> }>, disclaimer?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }> }>> }>, reviews: { __typename: 'PropertyReviewsSummary', score?: Maybe<number>, localizedScore?: Maybe<string>, total?: Maybe<number>, localizedTotal?: Maybe<string>, superlative?: Maybe<string>, localizedSubtitle?: Maybe<string>, localizedSubtitleA11y?: Maybe<{ __typename: 'LodgingEnrichedMessage', accessibilityLabel?: Maybe<string>, value: string }>, mark?: Maybe<{ __typename: 'LodgingMark', id: string, description: string }> }, destinationInfo: { __typename: 'PropertyDestinationInfo', distanceFromMessaging?: Maybe<string> }, propertyDetailsLink?: Maybe<{ __typename: 'LodgingLink', uri: { __typename: 'HttpURI', value: string, relativePath: string }, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }> }>, sponsoredListing?: Maybe<{ __typename: 'SponsoredListing', id?: Maybe<string>, clickRedirectTrackingUrl?: Maybe<any>, clickTrackingUrl?: Maybe<any>, details?: Maybe<string>, detailsHeadline?: Maybe<string>, hotelImage?: Maybe<string>, impressionTrackingUrl?: Maybe<any>, trackingData?: Maybe<string>, brand?: Maybe<string>, clickRedirectLinkoffTrackingUrl?: Maybe<any>, logo?: Maybe<string>, lotagline?: Maybe<string>, rating?: Maybe<string>, slots?: Maybe<string>, vanityUrl?: Maybe<any>, rank?: Maybe<string>, position?: Maybe<string> }> };

export type CommonDateFieldsFragment = { __typename: 'Date', year: number, month: number, day: number };

export type CommonDateTimeFieldsFragment = { __typename: 'DateTime', year: number, month: number, day: number, hour: number, minute: number, second: number };

export type PointsEducationFragmentFragment = { __typename: 'LoyaltyPointsEducation', description?: Maybe<string>, programFeatures: Array<{ __typename: 'LoyaltyEducationSection', description?: Maybe<string>, title?: Maybe<string>, perks?: Maybe<(
      { __typename: 'LoyaltyEducationPerks' }
      & PerksFragmentFragment
    )> }>, heroImage?: Maybe<{ __typename: 'Image', url: any, description: string }> };

export type ProgramEducationFragmentFragment = { __typename: 'LoyaltyProgramEducation', joinProgramText?: Maybe<string>, perks: (
    { __typename: 'LoyaltyEducationPerks' }
    & PerksFragmentFragment
  ) };

export type PerksFragmentFragment = { __typename: 'LoyaltyEducationPerks', descriptions: Array<string>, icon?: Maybe<string> };

export type FeaturedMessageFragment = { __typename: 'LodgingEnrichedMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }> };

export type LodgingPwaPropertySearchSortAndFilterQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  rooms?: Maybe<Array<RoomInput> | RoomInput>;
  dateRange?: Maybe<PropertyDateRangeInput>;
  sort?: Maybe<PropertySort>;
  filters?: Maybe<PropertySearchFiltersInput>;
  marketing?: Maybe<PropertyMarketingInfoInput>;
  legacyCriteria?: Maybe<LegacyPropertySearchCriteriaInput>;
  propertyShopOptions?: Maybe<PropertyShopOptionsInput>;
  searchPagination?: Maybe<PaginationInput>;
  searchIntent?: Maybe<SearchIntentInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
  criteria?: Maybe<PropertySearchCriteriaInput>;
}>;


export type LodgingPwaPropertySearchSortAndFilterQuery = { __typename: 'Query', propertySearch: { __typename: 'PropertySearchResults', sortAndFilter: { __typename: 'SortAndFilter', defaults?: Maybe<{ __typename: 'SortAndFilterDefaults', sort: PropertySort, regionId?: Maybe<string> }>, selected?: Maybe<{ __typename: 'SortAndFilterSelected', star?: Maybe<string>, priceFilterPills?: Maybe<{ __typename: 'PriceFilterPills', buckets?: Maybe<Array<number>>, aggregate?: Maybe<{ __typename: 'PriceFilterPillsAggregate', label?: Maybe<string>, value?: Maybe<string> }> }> }>, options?: Maybe<{ __typename: 'SortAndFilterViewModel', appliedFilterCount: number, sortAndFilter: Array<{ __typename: 'FilterViewModel', selected: boolean, isRange?: Maybe<boolean>, label?: Maybe<string>, max?: Maybe<number>, min?: Maybe<number>, name: string, title: string, placeholder?: Maybe<string>, step?: Maybe<number>, subLabel?: Maybe<string>, hiddenThreshold?: Maybe<number>, showListOptions?: Maybe<{ __typename: 'ExpandoPeekOptions', seeMoreLabel: string, seeLessLabel: string, hiddenThreshold: number }>, dropdownOptions?: Maybe<{ __typename: 'ShowDropdownOptions', isDropDownVisible?: Maybe<ActionDetailsType> }>, options: Array<{ __typename: 'OptionViewModel', selectedLabel?: Maybe<string>, ariaLabel?: Maybe<string>, description?: Maybe<string>, icon?: Maybe<string>, isSelected: boolean, label?: Maybe<string>, value?: Maybe<string>, optionValue?: Maybe<string>, filterType?: Maybe<string>, range?: Maybe<{ __typename: 'FilterOptionRange', min?: Maybe<number>, max?: Maybe<number> }> }> }> }> } } };

export type PrepareCheckoutByCartIdMutationVariables = Exact<{
  context: ContextInput;
  id: Scalars['UUID'];
  totalPrice: MoneyInput;
  marketingChannelId?: Maybe<Scalars['Int']>;
  checkoutOptions?: Maybe<Array<CheckoutOptionInput> | CheckoutOptionInput>;
}>;


export type PrepareCheckoutByCartIdMutation = { __typename: 'Mutation', prepareCheckoutByCartId: { __typename: 'PrepareCheckoutResponse', tripId?: Maybe<any>, checkoutUrl?: Maybe<any>, failureReason?: Maybe<{ __typename: 'CheckoutFailureReason' } | { __typename: 'MaxRoomsFailure', groupLinkMessage?: Maybe<string>, message: string }> } };

export type PrepareCheckoutMutationVariables = Exact<{
  context: ContextInput;
  properties?: Maybe<Array<PropertyNaturalKeyInput> | PropertyNaturalKeyInput>;
  cookies: Scalars['String'];
}>;


export type PrepareCheckoutMutation = { __typename: 'Mutation', prepareCheckout: { __typename: 'PrepareCheckoutResponse', tripId?: Maybe<any>, checkoutUrl?: Maybe<any> } };

export type PropertyAvailabilityCheckQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars['String'];
  searchCriteria: PropertySearchCriteriaInput;
}>;


export type PropertyAvailabilityCheckQuery = { __typename: 'Query', propertyOffers?: Maybe<{ __typename: 'OfferDetails', errorMessage?: Maybe<{ __typename: 'MessageResult', title?: Maybe<{ __typename: 'MessagingResultTitle', text?: Maybe<string> }> }>, listings?: Maybe<Array<{ __typename: 'MessageResult' } | { __typename: 'PropertyUnit', id: string } | { __typename: 'RecommendedOffer' }>> }> };

export type PropertyInfoPageLayoutQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars['String'];
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type PropertyInfoPageLayoutQuery = { __typename: 'Query', propertyInfo: { __typename: 'PropertyInfo', experimental: { __typename: 'PropertyDetailsExperimentalSection', pageLayoutExperimentalFeature: { __typename: 'PageLayoutExperimentalFeature', templateName?: Maybe<string> } } } };

export type PropertyRoomScoreInfoQueryVariables = Exact<{
  propertyIds: Array<Scalars['String']> | Scalars['String'];
  context: ContextInput;
}>;


export type PropertyRoomScoreInfoQuery = { __typename: 'Query', propertyReviewAggregates: { __typename: 'PropertyReviewAggregates', propertySummaries?: Maybe<Array<{ __typename: 'LodgingReviewSummary', propertyId: string, roomsScore?: Maybe<Array<{ __typename: 'RoomSummary', roomRatingListTitle?: Maybe<string>, id: string, score?: Maybe<string>, scoreLabel?: Maybe<string>, tags: Array<{ __typename: 'Tag', label: string }> }>> }>> } };

export type PropertyOffersQueryVariables = Exact<{
  context: ContextInput;
  propertyId: Scalars['String'];
  searchCriteria?: Maybe<PropertySearchCriteriaInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
  travelAdTrackingInfo?: Maybe<PropertyTravelAdTrackingInfoInput>;
  searchOffer?: Maybe<SearchOfferInput>;
  referrer?: Maybe<Scalars['String']>;
}>;


export type PropertyOffersQuery = { __typename: 'Query', propertyOffers?: Maybe<{ __typename: 'OfferDetails', soldOut: boolean, propertyHighlightSection?: Maybe<{ __typename: 'PropertyHighlightSection', label?: Maybe<string>, header?: Maybe<{ __typename: 'LodgingHeader', badge?: Maybe<{ __typename: 'Badge', theme_temp?: Maybe<Theme>, theme?: Maybe<Theme>, text?: Maybe<string>, icon_temp?: Maybe<{ __typename: 'Icon', id: string }> }>, mark?: Maybe<{ __typename: 'Mark', id: string, description: string }> }>, subSections: Array<{ __typename: 'PropertyHighlightSubSection', description?: Maybe<string>, contents: Array<{ __typename: 'LodgingEnrichedMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string, withBackground?: Maybe<boolean>, description: string }> }> }>, footerLink?: Maybe<{ __typename: 'LodgingLinkMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string }>, link: { __typename: 'LodgingLink', referrerId?: Maybe<string>, target?: Maybe<string>, uri: { __typename: 'HttpURI', relativePath: string, value: string } } }> }>, propertySearchLink?: Maybe<{ __typename: 'LodgingLinkMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string }>, link: { __typename: 'LodgingLink', referrerId?: Maybe<string>, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }>, uri: { __typename: 'HttpURI', relativePath: string, value: string } } }>, partnerPropertySearchLink?: Maybe<{ __typename: 'LodgingLinkMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string }>, link: { __typename: 'LodgingLink', referrerId?: Maybe<string>, uri: { __typename: 'HttpURI', relativePath: string, value: string } } }>, filterPills?: Maybe<Array<{ __typename: 'LodgingPill', pillLabel: string, type: string, value?: Maybe<string>, state?: Maybe<string>, query?: Maybe<string> }>>, loading?: Maybe<{ __typename: 'OfferDetailsLoading', accessibilityLabel?: Maybe<string> }>, listingsHeader: { __typename: 'LodgingHeader', text?: Maybe<string> }, searchCriteria?: Maybe<{ __typename: 'PropertySearchCriteria', primary: { __typename: 'PrimaryPropertyCriteria', dateRange?: Maybe<{ __typename: 'PropertyDateRange', checkInDate: (
            { __typename: 'Date' }
            & DateFragmentFragment
          ), checkOutDate: (
            { __typename: 'Date' }
            & DateFragmentFragment
          ) }>, destination: { __typename: 'Destination', regionId?: Maybe<string> }, rooms: Array<{ __typename: 'Room', adults: number, children?: Maybe<Array<{ __typename: 'Child', age: number }>> }> }, secondary?: Maybe<{ __typename: 'ShoppingSearchCriteria', booleans?: Maybe<Array<{ __typename: 'BooleanValue', id: string, value: boolean }>>, counts?: Maybe<Array<{ __typename: 'NumberValue', id: string, value: number }>>, dates?: Maybe<Array<{ __typename: 'DateValue', id: string, value: { __typename: 'Date', isoFormat: string } }>>, ranges?: Maybe<Array<{ __typename: 'RangeValue', id: string, min: number, max: number }>>, selections?: Maybe<Array<{ __typename: 'SelectedValue', id: string, value: string }>> }> }>, tripSummary?: Maybe<(
      { __typename: 'TripSummaryContent' }
      & TripSummaryFragmentFragment
    )>, listings?: Maybe<Array<{ __typename: 'MessageResult' } | (
      { __typename: 'PropertyUnit' }
      & UnitFragmentFragment
    ) | { __typename: 'RecommendedOffer' }>>, categorizedListings?: Maybe<Array<(
      { __typename: 'LodgingCategorizedUnit' }
      & CategorizedUnitFragmentFragment
    ) | { __typename: 'LodgingHeader' } | (
      { __typename: 'MessageResult' }
      & MessageFragmentFragment
    )>>, errorMessage?: Maybe<{ __typename: 'MessageResult', title?: Maybe<{ __typename: 'MessagingResultTitle', text?: Maybe<string> }>, action?: Maybe<{ __typename: 'MessagingResultAction', primary?: Maybe<{ __typename: 'MessagingAction', text?: Maybe<string>, linkUrl: string }> }> }>, paymentPolicy: Array<(
      { __typename: 'PropertyPaymentPolicyInfo' }
      & PaymentPolicyFragmentFragment
    )>, serpMetadata?: Maybe<{ __typename: 'SerpMetadata', priceRange?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }>, priceRating?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }> }>, stickyBar?: Maybe<{ __typename: 'PropertyDetailsStickyBar', displayPrice?: Maybe<string>, qualifier?: Maybe<string>, subText?: Maybe<string>, stickyButton?: Maybe<{ __typename: 'LodgingStickyButton', text?: Maybe<string>, targetRef?: Maybe<PropertySectionRef> }>, price?: Maybe<{ __typename: 'PropertyPriceOption', leadingCaption?: Maybe<string>, displayPrice?: Maybe<{ __typename: 'Money', formatted: string }>, disclaimer?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }> }> }>, toastMessage?: Maybe<{ __typename: 'LodgingToastMessage', value: string }>, loyaltyDiscount?: Maybe<{ __typename: 'PropertyLoyaltyDiscount', saveWithPointsMessage?: Maybe<string>, saveWithPointsActionMessage?: Maybe<string> }>, legalDisclaimer?: Maybe<{ __typename: 'DisclaimerContentMarkup', content: Array<{ __typename: 'MarkupText', markupType: MarkupTextType, text: string }> }>, propertyLevelOffersMessage?: Maybe<(
      { __typename: 'MessageResult' }
      & MessageFragmentFragment
    )>, offerLevelMessages?: Maybe<Array<(
      { __typename: 'MessageResult' }
      & MessageFragmentFragment
    )>>, alternateDates?: Maybe<(
      { __typename: 'AlternateDatesCard' }
      & AlternateDatesFragmentFragment
    )>, alternateAvailabilityMsg?: Maybe<(
      { __typename: 'LodgingComplexLinkMessage' }
      & AlternateAvailabilityMsgFragmentFragment
    )>, shoppingContext?: Maybe<{ __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> }>, singleUnitOffer?: Maybe<(
      { __typename: 'SingleUnitOfferDetails' }
      & SingleOfferFragmentFragment
    )>, singleUnitOfferDialog?: Maybe<{ __typename: 'SingleUnitOfferDialog', content: (
        { __typename: 'SingleUnitOfferDetails' }
        & SingleOfferFragmentFragment
      ), toolbar: (
        { __typename: 'LodgingDialogToolbar' }
        & LodgingDialogToolbarFragmentFragment
      ), trigger: (
        { __typename: 'LodgingDialogTriggerMessage' }
        & LodgingDialogTriggerMessageFragmentFragment
      ) }>, spaceDetails?: Maybe<{ __typename: 'SpaceDetails', summary?: Maybe<Array<string>>, header: { __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string> }, floorPlan?: Maybe<{ __typename: 'FloorPlanDialog', images: Array<{ __typename: 'PropertyImage', alt?: Maybe<string>, subjectId?: Maybe<number>, image: { __typename: 'Image', description: string, url: any } }>, toolbar?: Maybe<(
          { __typename: 'LodgingDialogToolbar' }
          & LodgingDialogToolbarFragmentFragment
        )>, trigger: (
          { __typename: 'LodgingDialogTriggerMessage' }
          & LodgingDialogTriggerMessageFragmentFragment
        ) }>, spaces?: Maybe<Array<{ __typename: 'Spaces', name: string, description?: Maybe<Array<string>>, icons?: Maybe<Array<(
          { __typename: 'Icon' }
          & IconFragmentFragment
        )>> }>> }> }> };

export type AlternateDatesFragmentFragment = { __typename: 'AlternateDatesCard', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string> }>, options: Array<(
    { __typename: 'AlternateDateOption' }
    & AlternateDateOptionFragmentFragment
  )> };

export type AlternateAvailabilityMsgFragmentFragment = { __typename: 'LodgingComplexLinkMessage', text: { __typename: 'LodgingPlainMessage', value: string }, actionLink: { __typename: 'LodgingLinkMessage', value: string, link: { __typename: 'LodgingLink', uri: { __typename: 'HttpURI', relativePath: string, value: string } } } };

export type PropertyUnitDetailsDialogFragment = { __typename: 'PropertyUnitDetailsDialog', content: { __typename: 'PropertyUnitDetails', ratePlanTitle?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, details?: Maybe<{ __typename: 'PropertyInfoSection', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string> }>, contents: Array<{ __typename: 'PropertyInfoContent', heading?: Maybe<string>, items: Array<{ __typename: 'PropertyInfoItem', text: string }> }> }> }, trigger: { __typename: 'LodgingDialogTriggerMessage', value: string, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }>, dialogTrigger: { __typename: 'LodgingDialogTrigger', clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string }> } }, toolbar?: Maybe<{ __typename: 'LodgingDialogToolbar', title?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', description: string }>, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }> }> };

export type MessageFragmentFragment = { __typename: 'MessageResult', type?: Maybe<MessageType>, title?: Maybe<(
    { __typename: 'MessagingResultTitle' }
    & TitleFragmentFragment
  )>, subtitle?: Maybe<(
    { __typename: 'MessagingResultTitle' }
    & TitleFragmentFragment
  )>, action?: Maybe<{ __typename: 'MessagingResultAction', primary?: Maybe<(
      { __typename: 'MessagingAction' }
      & ActionFragmentFragment
    )>, secondary?: Maybe<(
      { __typename: 'MessagingAction' }
      & ActionFragmentFragment
    )> }>, featuredImage?: Maybe<{ __typename: 'Image', url: any, description: string }> };

export type TitleFragmentFragment = { __typename: 'MessagingResultTitle', text?: Maybe<string>, theme?: Maybe<Theme>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragmentFragment
  )>, mark?: Maybe<{ __typename: 'LodgingMark', id: string, description: string }>, illustration?: Maybe<{ __typename: 'LodgingIllustration', description?: Maybe<string>, assetUri?: Maybe<{ __typename: 'HttpURI', value: string }> }> };

export type ActionFragmentFragment = { __typename: 'MessagingAction', linkUrl: string, text?: Maybe<string>, referrerId?: Maybe<string>, actionDetails?: Maybe<{ __typename: 'ActionDetails', name: ActionDetailsType, details?: Maybe<string>, title?: Maybe<string>, accessibilityLabel?: Maybe<string>, action: string }>, icon?: Maybe<{ __typename: 'Icon', id: string }> };

export type LodgingNotificationsCardFragmentFragment = { __typename: 'LodgingNotificationsCard', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, messages: Array<(
    { __typename: 'LodgingEnrichedMessage' }
    & LodgingEnrichedMessageFragmentFragment
  ) | { __typename: 'LodgingPlainDialog' } | { __typename: 'LodgingPlainMessage' }> };

export type UnitCategorizationSelectionFragmentFragment = { __typename: 'LodgingOfferOption', description: string, subText?: Maybe<string>, enabled: boolean, price?: Maybe<string>, optionId?: Maybe<string>, clientSideAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragmentFragment
  )>, dialog?: Maybe<(
    { __typename: 'LodgingPlainDialog' }
    & LodgingPlainDialogFragmentFragment
  )> };

export type UnitCategorizationHeaderFragmentFragment = { __typename: 'LodgingOfferSelectionHeader', dialog?: Maybe<{ __typename: 'LodgingComplexDialog', content?: Maybe<Array<{ __typename: 'DialogContent', content?: Maybe<Array<string>>, title?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string> }> }>>, primaryUIButton?: Maybe<(
      { __typename: 'UIPrimaryButton' }
      & UiPrimaryButtonFragmentFragment
    )>, toolbar?: Maybe<(
      { __typename: 'LodgingDialogToolbar' }
      & LodgingDialogToolbarFragmentFragment
    )>, trigger: (
      { __typename: 'LodgingDialogTriggerMessage' }
      & LodgingDialogTriggerMessageFragmentFragment
    ) }>, title: { __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string> } };

export type CategorizedUnitFragmentFragment = { __typename: 'LodgingCategorizedUnit', label?: Maybe<string>, header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, highlightedMessages: Array<(
    { __typename: 'LodgingEnrichedMessage' }
    & CancellationPolicyFragment_LodgingEnrichedMessage_Fragment
  ) | (
    { __typename: 'LodgingPlainDialog' }
    & CancellationPolicyFragment_LodgingPlainDialog_Fragment
  ) | (
    { __typename: 'LodgingPlainMessage' }
    & CancellationPolicyFragment_LodgingPlainMessage_Fragment
  )>, features?: Maybe<Array<{ __typename: 'PropertyInfoItem', text: string, moreInfo?: Maybe<string>, graphic?: Maybe<(
      { __typename: 'Icon' }
      & IconFragmentFragment
      & IconFragmentFragment
    ) | { __typename: 'Illustration' } | (
      { __typename: 'Mark', description: string, id: string }
      & MarkFragmentFragment
    )>, moreInfoDialog?: Maybe<(
      { __typename: 'LodgingPlainDialog' }
      & LodgingPlainFullscreenDialogFragmentFragment
    )> }>>, primaryHeader?: Maybe<(
    { __typename: 'LodgingOfferSelectionHeader' }
    & UnitCategorizationHeaderFragmentFragment
  )>, secondaryHeader?: Maybe<(
    { __typename: 'LodgingOfferSelectionHeader' }
    & UnitCategorizationHeaderFragmentFragment
  )>, tertiaryHeader?: Maybe<(
    { __typename: 'LodgingOfferSelectionHeader' }
    & UnitCategorizationHeaderFragmentFragment
  )>, primarySelections?: Maybe<Array<{ __typename: 'LodgingPrimaryOfferSelection', primarySelection?: Maybe<(
      { __typename: 'LodgingOfferOption' }
      & UnitCategorizationSelectionFragmentFragment
    )>, secondarySelections?: Maybe<Array<{ __typename: 'LodgingSecondaryOfferSelection', recommendedSelection?: Maybe<boolean>, secondarySelection?: Maybe<(
        { __typename: 'LodgingOfferOption' }
        & UnitCategorizationSelectionFragmentFragment
      )>, tertiarySelections?: Maybe<Array<(
        { __typename: 'LodgingOfferOption' }
        & UnitCategorizationSelectionFragmentFragment
      )>> }>>, propertyUnit: { __typename: 'PropertyUnit', id: string, unitGallery?: Maybe<{ __typename: 'PropertyImageGallery', accessibilityLabel?: Maybe<string>, label?: Maybe<string>, images: Array<{ __typename: 'PropertyImage', image: { __typename: 'Image', description: string, url: any } }> }>, availabilityCallToAction?: Maybe<{ __typename: 'LodgingButton', text: string } | { __typename: 'LodgingPlainMessage', value: string }>, detailsDialog?: Maybe<{ __typename: 'EtpDialog' } | { __typename: 'FloorPlanDialog' } | { __typename: 'LodgingAmenitiesDialog' } | { __typename: 'LodgingCancellationPolicyDialog' } | { __typename: 'LodgingComplexDialog' } | { __typename: 'LodgingGalleryDialog' } | { __typename: 'LodgingMapDialog' } | { __typename: 'LodgingPlainDialog' } | { __typename: 'PricePresentationDialog' } | { __typename: 'PropertyInfoMap' } | { __typename: 'PropertyReviewFlagDialog' } | (
        { __typename: 'PropertyUnitDetailsDialog' }
        & PropertyUnitDetailsDialogFragment
      ) | { __typename: 'SingleUnitOfferDialog' }>, roomAmenities?: Maybe<{ __typename: 'PropertyContentSection', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, bodySubSections: Array<{ __typename: 'PropertyContentSubSection', contents: Array<{ __typename: 'PropertyContent', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', id: string }> }>, items: Array<{ __typename: 'PropertyContentItemImages' } | { __typename: 'PropertyContentItemMarkup', content: { __typename: 'MarkupText', text: string } } | { __typename: 'PropertyContentItemText' } | { __typename: 'PropertyContentItemTexts' }> }> }> }>, ratePlans: Array<(
        { __typename: 'RatePlan' }
        & RatePlanFragmentFragment
      )> } }>> };

export type UnitFragmentFragment = { __typename: 'PropertyUnit', id: string, name?: Maybe<string>, bedOptions: Array<{ __typename: 'BedOptions', name: string, icon: string }>, header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string>, icon?: Maybe<(
      { __typename: 'Icon' }
      & IconFragmentFragment
    )> }>, detailsDialog?: Maybe<{ __typename: 'EtpDialog' } | { __typename: 'FloorPlanDialog' } | { __typename: 'LodgingAmenitiesDialog' } | { __typename: 'LodgingCancellationPolicyDialog' } | { __typename: 'LodgingComplexDialog' } | { __typename: 'LodgingGalleryDialog' } | { __typename: 'LodgingMapDialog' } | { __typename: 'LodgingPlainDialog' } | { __typename: 'PricePresentationDialog' } | { __typename: 'PropertyInfoMap' } | { __typename: 'PropertyReviewFlagDialog' } | (
    { __typename: 'PropertyUnitDetailsDialog' }
    & PropertyUnitDetailsDialogFragment
  ) | { __typename: 'SingleUnitOfferDialog' }>, ratePlans: Array<(
    { __typename: 'RatePlan' }
    & RatePlanFragmentFragment
  )>, unavailableRatePlans: Array<(
    { __typename: 'RatePlan' }
    & RatePlanFragmentFragment
  )>, ratePlansExpando: { __typename: 'RatePlansExpando', expandButton: { __typename: 'LodgingButton', text: string } }, features: Array<{ __typename: 'PropertyInfoItem', text: string, moreInfo?: Maybe<string>, graphic?: Maybe<(
      { __typename: 'Icon' }
      & IconFragmentFragment
      & IconFragmentFragment
    ) | { __typename: 'Illustration' } | (
      { __typename: 'Mark', description: string, id: string }
      & MarkFragmentFragment
    )>, moreInfoDialog?: Maybe<(
      { __typename: 'LodgingPlainDialog' }
      & LodgingPlainFullscreenDialogFragmentFragment
    )> }>, spaceDetails?: Maybe<{ __typename: 'SpaceDetails', summary?: Maybe<Array<string>>, header: { __typename: 'LodgingHeader', text?: Maybe<string>, subText?: Maybe<string> }, floorPlan?: Maybe<{ __typename: 'FloorPlanDialog', images: Array<{ __typename: 'PropertyImage', alt?: Maybe<string>, subjectId?: Maybe<number>, image: { __typename: 'Image', description: string, url: any } }>, toolbar?: Maybe<(
        { __typename: 'LodgingDialogToolbar' }
        & LodgingDialogToolbarFragmentFragment
      )>, trigger: (
        { __typename: 'LodgingDialogTriggerMessage' }
        & LodgingDialogTriggerMessageFragmentFragment
      ) }>, spaces?: Maybe<Array<{ __typename: 'Spaces', name: string, description?: Maybe<Array<string>>, icons?: Maybe<Array<(
        { __typename: 'Icon' }
        & IconFragmentFragment
      )>> }>> }>, roomAmenities?: Maybe<{ __typename: 'PropertyContentSection', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, bodySubSections: Array<{ __typename: 'PropertyContentSubSection', contents: Array<{ __typename: 'PropertyContent', header?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', id: string }> }>, items: Array<{ __typename: 'PropertyContentItemImages' } | { __typename: 'PropertyContentItemMarkup', content: { __typename: 'MarkupText', text: string } } | { __typename: 'PropertyContentItemText' } | { __typename: 'PropertyContentItemTexts' }> }> }> }>, unitGallery?: Maybe<{ __typename: 'PropertyImageGallery', accessibilityLabel?: Maybe<string>, images: Array<{ __typename: 'PropertyImage', alt?: Maybe<string>, subjectId?: Maybe<number>, image: { __typename: 'Image', description: string, url: any }, thumbnail?: Maybe<{ __typename: 'Image', description: string, url: any }>, fallbackImage?: Maybe<{ __typename: 'Image', description: string, url: any }> }> }>, availabilityCallToAction?: Maybe<{ __typename: 'LodgingButton', text: string } | { __typename: 'LodgingPlainMessage', value: string }> };

type CancellationPolicyFragment_LodgingEnrichedMessage_Fragment = (
  { __typename: 'LodgingEnrichedMessage' }
  & LodgingEnrichedMessageFragmentFragment
);

type CancellationPolicyFragment_LodgingPlainDialog_Fragment = (
  { __typename: 'LodgingPlainDialog' }
  & LodgingPlainDialogFragmentFragment
);

type CancellationPolicyFragment_LodgingPlainMessage_Fragment = { __typename: 'LodgingPlainMessage' };

export type CancellationPolicyFragmentFragment = CancellationPolicyFragment_LodgingEnrichedMessage_Fragment | CancellationPolicyFragment_LodgingPlainDialog_Fragment | CancellationPolicyFragment_LodgingPlainMessage_Fragment;

export type DateFragmentFragment = { __typename: 'Date', month: number, day: number, year: number, shortDateFormat?: Maybe<string> };

export type RatePlanFragmentFragment = { __typename: 'RatePlan', id: string, name?: Maybe<string>, description?: Maybe<string>, loyaltyMessage?: Maybe<{ __typename: 'LodgingEnrichedMessage', value: string, state?: Maybe<string>, label?: Maybe<string>, mark?: Maybe<{ __typename: 'LodgingMark', id: string }>, egdsMark?: Maybe<{ __typename: 'Mark', url?: Maybe<{ __typename: 'HttpURI', value: string }> }> }>, headerMessage?: Maybe<{ __typename: 'LodgingEnrichedMessage', value: string, subText?: Maybe<string>, theme?: Maybe<LodgingMessageTheme>, label?: Maybe<string> }>, priceDetails: Array<(
    { __typename: 'Offer' }
    & PriceDetailsFragmentFragment
  )>, amenities: Array<{ __typename: 'RatePlanAmenity', id?: Maybe<number>, additionalInformation?: Maybe<string>, category?: Maybe<AmenityCategory>, description?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }> }>, marketingSection?: Maybe<(
    { __typename: 'MarketingSection' }
    & MarketingSectionFragmentFragment
  )>, offerNotifications?: Maybe<(
    { __typename: 'LodgingNotificationsCard' }
    & LodgingNotificationsCardFragmentFragment
  )>, highlightedMessages?: Maybe<Array<Maybe<(
    { __typename: 'LodgingEnrichedMessage' }
    & LodgingEnrichedMessageFragmentFragment
  ) | (
    { __typename: 'LodgingPlainDialog' }
    & LodgingPlainDialogFragmentFragment
  ) | (
    { __typename: 'LodgingPlainMessage' }
    & LodgingPlainMessageFragmentFragment
  )>>>, marketingChannelMessage?: Maybe<{ __typename: 'LodgingEnrichedMessage', value: string, mark?: Maybe<{ __typename: 'LodgingMark', id: string }> }>, badge?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }> }>, etpDialogTopMessage?: Maybe<(
    { __typename: 'MessageResult' }
    & MessageFragmentFragment
  )>, paymentPolicy: Array<(
    { __typename: 'PropertyPaymentPolicyInfo' }
    & PaymentPolicyFragmentFragment
  )>, reserveCallToAction?: Maybe<{ __typename: 'EtpDialog', trigger: { __typename: 'LodgingDialogTriggerMessage', value: string }, toolbar: { __typename: 'LodgingDialogToolbar', title?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', description: string }> } } | { __typename: 'LodgingForm', action: string, method: LodgingFormMethod, inputs?: Maybe<Array<{ __typename: 'LodgingTextInput', name?: Maybe<string>, type?: Maybe<LodgingInputType>, value?: Maybe<string> }>>, submit: { __typename: 'LodgingButton', text: string } }>, shareUrl?: Maybe<{ __typename: 'LodgingLinkMessage', accessibilityLabel?: Maybe<string>, value: string, link: { __typename: 'LodgingLink', uri: { __typename: 'HttpURI', relativePath: string } } }> };

export type PriceDetailsFragmentFragment = (
  { __typename: 'Offer', pointsApplied?: Maybe<string>, paymentModel?: Maybe<PropertyPaymentModel>, noCreditCard: boolean, installmentPayable: boolean, totalPriceMessage?: Maybe<string>, hotelCollect?: Maybe<boolean>, etpModalPolicies?: Maybe<Array<string>>, optionTitle?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, availability?: Maybe<{ __typename: 'PropertyAvailability', available: boolean, text?: Maybe<string>, theme?: Maybe<Theme>, scarcityMessage?: Maybe<string> }>, price?: Maybe<(
    { __typename: 'PropertyPrice', roomNightMessage?: Maybe<string>, strikeOutType?: Maybe<StrikeOutType>, multiItemPriceToken?: Maybe<string>, options?: Maybe<Array<(
      { __typename: 'PropertyPriceOption' }
      & OptionFragmentFragment
    )>>, priceMessaging?: Maybe<Array<{ __typename: 'LodgingEnrichedMessage', value: string, theme?: Maybe<LodgingMessageTheme> }>>, lead?: Maybe<{ __typename: 'Money', formatted: string }>, disclaimer?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }>, strikeOut?: Maybe<{ __typename: 'Money', formatted: string }>, marketingFeeDetails?: Maybe<{ __typename: 'MarketingFeeDetails', tierName: string, tierIcon: string, marketingFeeMessage: { __typename: 'LodgingPlainMessage', value: string } }> }
    & PriceDisplayFragmentFragment
  )>, cancellationPolicy?: Maybe<{ __typename: 'PropertyCancellationPolicy', type: PropertyCancellationPolicyType, text: string, cancellationWindow?: Maybe<{ __typename: 'ZonedDateTime', day: number, month: number, year: number, hour: number, minute: number, second: number, timeZoneOffsetSeconds: number, fullDateFormat?: Maybe<string> }> }>, priceBreakDownSummary?: Maybe<{ __typename: 'PriceSummary', priceSummaryHeading?: Maybe<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )>, sections: Array<{ __typename: 'PriceSummarySection', sectionHeading?: Maybe<(
        { __typename: 'LodgingEnrichedMessage' }
        & LodgingEnrichedMessageFragmentFragment
      )>, items: Array<{ __typename: 'PriceSummaryLineItem', name: { __typename: 'PriceSummaryLineItemEntry', primaryMessage: (
            { __typename: 'LodgingEnrichedMessage' }
            & LodgingEnrichedMessageFragmentFragment
          ), secondaryMessages?: Maybe<Array<(
            { __typename: 'LodgingEnrichedMessage' }
            & LodgingEnrichedMessageFragmentFragment
          )>> }, value: { __typename: 'PriceSummaryLineItemEntry', primaryMessage: (
            { __typename: 'LodgingEnrichedMessage' }
            & LodgingEnrichedMessageFragmentFragment
          ), secondaryMessages?: Maybe<Array<(
            { __typename: 'LodgingEnrichedMessage' }
            & LodgingEnrichedMessageFragmentFragment
          )>> } }>, sectionFooter?: Maybe<{ __typename: 'PriceSummaryFooter', footerHeading?: Maybe<(
          { __typename: 'LodgingEnrichedMessage' }
          & LodgingEnrichedMessageFragmentFragment
        )>, footerMessages?: Maybe<Array<(
          { __typename: 'LodgingEnrichedMessage' }
          & LodgingEnrichedMessageFragmentFragment
        )>> }> }>, disclaimers?: Maybe<Array<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )>> }>, dataAttributes?: Maybe<{ __typename: 'GraphQLPair', key: string, value: string }>, feeMessages?: Maybe<Array<{ __typename: 'LodgingEnrichedMessage', value: string }>>, loyaltyMessage?: Maybe<{ __typename: 'LodgingEnrichedMessage', state?: Maybe<string>, value: string }>, offerBookButton?: Maybe<{ __typename: 'LodgingForm', action: string, method: LodgingFormMethod, inputs?: Maybe<Array<(
      { __typename: 'LodgingTextInput' }
      & LodgingTextInputFragment
    )>>, submit: (
      { __typename: 'LodgingButton' }
      & ButtonFragmentFragment
    ) }>, deposit?: Maybe<(
    { __typename: 'Money' }
    & MoneyFragmentFragment
  )>, propertyNaturalKeys: Array<(
    { __typename: 'PropertyNaturalKey' }
    & PropertyNaturalKeyFragmentFragment
  )> }
  & PricePresentationDialogFragmentFragment
);

export type PropertyNaturalKeyFragmentFragment = { __typename: 'PropertyNaturalKey', id: string, inventoryType: InventoryType, noCreditCard?: Maybe<boolean>, ratePlanId: string, ratePlanType?: Maybe<string>, roomTypeId: string, shoppingPath?: Maybe<ShoppingPathType>, checkIn: (
    { __typename: 'Date' }
    & DateFragmentFragment
  ), checkOut: (
    { __typename: 'Date' }
    & DateFragmentFragment
  ), rooms: Array<{ __typename: 'PropertyRoom', childAges: Array<number>, numberOfAdults: number }> };

export type ButtonFragmentFragment = { __typename: 'LodgingButton', text: string, analytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }> };

export type IconFragmentFragment = { __typename: 'Icon', description: string, id: string, size?: Maybe<IconSize> };

export type MarkFragmentFragment = { __typename: 'Mark', id: string, description: string };

export type MarketingSectionFragmentFragment = { __typename: 'MarketingSection', title?: Maybe<{ __typename: 'LodgingHeader', text?: Maybe<string> }>, feeDetails: { __typename: 'MarketingFeeDetails', formattedFee?: Maybe<string>, tierName: string, marketingFeeMessage: { __typename: 'LodgingPlainMessage', value: string }, mark?: Maybe<{ __typename: 'LodgingMark', id: string }>, tierMessage: { __typename: 'LodgingEnrichedMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }>, mark?: Maybe<{ __typename: 'LodgingMark', id: string }> } }, feeDialog: { __typename: 'LodgingPlainDialog', title?: Maybe<string>, content: Array<string>, tertiaryUIButton?: Maybe<{ __typename: 'UITertiaryButton', primary?: Maybe<string> }>, trigger: { __typename: 'LodgingDialogTriggerMessage', value: string, mark?: Maybe<{ __typename: 'Mark', id: string }>, icon?: Maybe<{ __typename: 'Icon', id: string, size?: Maybe<IconSize> }>, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }> } }, paymentDetails?: Maybe<{ __typename: 'LodgingEnrichedMessage', value: string, icon?: Maybe<{ __typename: 'Icon', id: string }> }> };

export type LodgingTextInputFragment = { __typename: 'LodgingTextInput', name?: Maybe<string>, type?: Maybe<LodgingInputType>, value?: Maybe<string> };

export type PaymentPolicyFragmentFragment = { __typename: 'PropertyPaymentPolicyInfo', paymentType: PropertyPaymentType, heading: string, descriptions: Array<{ __typename: 'PropertyInfoContent', heading?: Maybe<string>, items: Array<{ __typename: 'PropertyInfoItem', text: string }> }> };

export type OptionFragmentFragment = { __typename: 'PropertyPriceOption', leadingCaption?: Maybe<string>, accessibilityLabel?: Maybe<string>, disclaimer?: Maybe<(
    { __typename: 'LodgingPlainMessage' }
    & LodgingPlainMessageFragmentFragment
  )>, priceDisclaimer?: Maybe<(
    { __typename: 'LodgingPlainDialog' }
    & LodgingPlainDialogFragmentFragment
  )>, displayPrice?: Maybe<(
    { __typename: 'Money' }
    & MoneyFragmentFragment
  )>, loyaltyPrice?: Maybe<{ __typename: 'LoyaltyPrice', unit?: Maybe<string>, amount?: Maybe<{ __typename: 'FormattedNumber', formatted: string, raw: number }>, totalStrikeOutPoints?: Maybe<{ __typename: 'FormattedNumber', formatted: string }> }>, strikeOut?: Maybe<(
    { __typename: 'Money' }
    & MoneyFragmentFragment
  )> };

export type LodgingEnrichedMessageFragmentFragment = { __typename: 'LodgingEnrichedMessage', label?: Maybe<string>, theme?: Maybe<LodgingMessageTheme>, subText?: Maybe<string>, value: string, icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }>, mark?: Maybe<{ __typename: 'LodgingMark', id: string, description: string }> };

export type LodgingPlainMessageFragmentFragment = { __typename: 'LodgingPlainMessage', value: string };

export type LodgingPlainDialogFragmentFragment = { __typename: 'LodgingPlainDialog', content: Array<string>, title?: Maybe<string>, primaryButton?: Maybe<(
    { __typename: 'LodgingButton' }
    & ButtonFragmentFragment
  )>, secondaryButton?: Maybe<(
    { __typename: 'LodgingButton' }
    & ButtonFragmentFragment
  )>, tertiaryButton?: Maybe<(
    { __typename: 'LodgingButton' }
    & ButtonFragmentFragment
  )>, primaryUIButton?: Maybe<(
    { __typename: 'UIPrimaryButton' }
    & UiPrimaryButtonFragmentFragment
  )>, secondaryUIButton?: Maybe<{ __typename: 'UISecondaryButton', primary?: Maybe<string> }>, toolbar?: Maybe<(
    { __typename: 'LodgingDialogToolbar' }
    & LodgingDialogToolbarFragmentFragment
  )>, trigger: (
    { __typename: 'LodgingDialogTriggerMessage' }
    & LodgingDialogTriggerMessageFragmentFragment
  ) };

export type UiPrimaryButtonFragmentFragment = { __typename: 'UIPrimaryButton', primary?: Maybe<string>, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityCloseDialogAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityOpenDialogAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityOpenOffersModalAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityPaginationAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityRemoveOffersFromTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ActivityUpdateOfferInTripAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'AirCreditWebAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CDFSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponAndCreditAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponAndCreditChatbotAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CouponsAndCreditsSimpleAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CrossSellButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CrossSellLinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'CruiseAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'DirectFeedbackSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSOpenDatePickerAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSOpenTravelerSelectorAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGDSSubmitSearchFormAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'EGULSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsCreditSelectorOpenUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsDialogCloseUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'FlightsDialogTriggerUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersBookAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersDetailsOpenAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersDismissAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersLinkClickAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'GroundTransfersSelectionClickAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'IncentivesActionLink', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MemberWalletBadge', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MemberWalletUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MishopDetailsUIAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUIButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'MultiItemCrossSellUILinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'OpenTypeaheadAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentDialogElement', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'PaymentFormFieldAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAccountFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileAddMembershipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileLinkAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileReloadAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ProfileUpdateMembershipAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'QuoteAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'ShoppingSortAndFilterAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'UIFlightAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'UILinkAction', resource: { __typename: 'GeoURI', value: string } | { __typename: 'HttpURI', value: string } | { __typename: 'MailToURI', value: string } | { __typename: 'MobileAppURI', value: string } | { __typename: 'TelURI', value: string }, analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'WizardAdditionalUserInputRequiredAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } } | { __typename: 'WizardSubmitAction', analytics: { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string } }> };

export type LodgingPlainFullscreenDialogFragmentFragment = { __typename: 'LodgingPlainDialog', content: Array<string>, trigger: { __typename: 'LodgingDialogTriggerMessage', theme?: Maybe<LodgingMessageTheme>, value: string, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }>, icon?: Maybe<{ __typename: 'Icon', description: string, id: string }> }, toolbar?: Maybe<{ __typename: 'LodgingDialogToolbar', title?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', description: string }>, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }> }> };

export type LodgingDialogToolbarFragmentFragment = { __typename: 'LodgingDialogToolbar', title?: Maybe<string>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragmentFragment
  )>, clientSideAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragmentFragment
  )> };

export type LodgingDialogTriggerMessageFragmentFragment = { __typename: 'LodgingDialogTriggerMessage', theme?: Maybe<LodgingMessageTheme>, value: string, secondaryValue?: Maybe<string>, clientSideAnalytics?: Maybe<(
    { __typename: 'ClientSideAnalytics' }
    & ClientSideAnalyticsFragmentFragment
  )>, icon?: Maybe<(
    { __typename: 'Icon' }
    & IconFragmentFragment
  )> };

export type ClientSideAnalyticsFragmentFragment = { __typename: 'ClientSideAnalytics', linkName: string, referrerId: string };

export type MoneyFragmentFragment = { __typename: 'Money', amount: number, formatted: string, currencyInfo?: Maybe<(
    { __typename: 'Currency' }
    & CurrencyFragmentFragment
  )> };

export type CurrencyFragmentFragment = { __typename: 'Currency', code: string, name: string, symbol: string };

export type AlternateDateOptionFragmentFragment = { __typename: 'AlternateDateOption', dates: { __typename: 'LodgingLinkMessage', value: string, link: { __typename: 'LodgingLink', referrerId?: Maybe<string>, uri: { __typename: 'HttpURI', relativePath: string } } }, price?: Maybe<{ __typename: 'PropertyPriceOption', displayPrice?: Maybe<{ __typename: 'Money', formatted: string }> }> };

export type TripSummaryFragmentFragment = { __typename: 'TripSummaryContent', header: { __typename: 'LodgingHeader', text?: Maybe<string> }, summary: Array<{ __typename: 'LodgingEnrichedMessage', value: string }>, price: (
    { __typename: 'PropertyPrice', options?: Maybe<Array<{ __typename: 'PropertyPriceOption', accessibilityLabel?: Maybe<string>, displayPrice?: Maybe<{ __typename: 'Money', formatted: string }>, strikeOut?: Maybe<{ __typename: 'Money', formatted: string }>, priceDisclaimer?: Maybe<{ __typename: 'LodgingPlainDialog', content: Array<string>, tertiaryUIButton?: Maybe<{ __typename: 'UITertiaryButton', primary?: Maybe<string>, action?: Maybe<{ __typename: 'ActivityAddOfferToTripAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityCloseDialogAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityOpenDialogAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityOpenOffersModalAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityPaginationAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityRemoveOffersFromTripAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ActivityUpdateOfferInTripAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'AirCreditWebAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CDFOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CDFOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CDFSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CouponAndCreditAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CouponAndCreditChatbotAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CouponsAndCreditsSimpleAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CrossSellButtonAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CrossSellLinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'CruiseAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'DirectFeedbackOpenFormAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'DirectFeedbackOpenNextPageAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'DirectFeedbackSubmitFormAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'EGDSOpenDatePickerAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'EGDSOpenTravelerSelectorAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'EGDSSubmitSearchFormAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'EGULSubmitAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'FlightsCreditSelectorOpenUIAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'FlightsDialogCloseUIAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'FlightsDialogTriggerUIAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'GroundTransfersBookAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'GroundTransfersDetailsOpenAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'GroundTransfersDismissAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'GroundTransfersLinkClickAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'GroundTransfersMultiItemTripUpdateAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'GroundTransfersSelectionClickAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'IncentivesActionLink', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'MemberWalletBadge', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'MemberWalletUIAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'MishopDetailsUIAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'MultiItemCrossSellUIButtonAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'MultiItemCrossSellUICheckoutButtonAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'MultiItemCrossSellUILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'OpenTypeaheadAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'PaymentDialogButtonAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'PaymentDialogElement', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'PaymentFormFieldAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ProfileAccountFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ProfileAddMembershipAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ProfileFormSubmitAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ProfileLinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ProfileReloadAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ProfileUpdateMembershipAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'QuoteAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'ShoppingSortAndFilterAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'UIFlightAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'UILinkAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'WizardAdditionalUserInputRequiredAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } } | { __typename: 'WizardSubmitAction', analytics: { __typename: 'ClientSideAnalytics', referrerId: string, linkName: string } }> }>, trigger: { __typename: 'LodgingDialogTriggerMessage', value: string, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }> } }> }>>, priceMessaging?: Maybe<Array<{ __typename: 'LodgingEnrichedMessage', value: string }>> }
    & PriceDisplayFragmentFragment
  ) };

export type SingleOfferFragmentFragment = { __typename: 'SingleUnitOfferDetails', accessibilityLabel?: Maybe<string>, id: string, availabilityCallToAction?: Maybe<{ __typename: 'LodgingButton', text: string } | { __typename: 'LodgingPlainMessage', value: string }>, displayPrice?: Maybe<{ __typename: 'DisplayPriceSummaryItem', leadPrice?: Maybe<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )>, priceLabel?: Maybe<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )>, priceMessages?: Maybe<Array<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )>> }>, ratePlans?: Maybe<Array<Maybe<(
    { __typename: 'RatePlan' }
    & RatePlanFragmentFragment
  )>>>, totalPrice?: Maybe<{ __typename: 'TotalPriceSummary', amount?: Maybe<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )>, label?: Maybe<(
      { __typename: 'LodgingEnrichedMessage' }
      & LodgingEnrichedMessageFragmentFragment
    )> }> };

export type PriceDisplayFragmentFragment = { __typename: 'PropertyPrice', alignment?: Maybe<string>, displayMessages?: Maybe<Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<(
      { __typename: 'DisplayPrice' }
      & PriceMessageFragmentFragment
    ) | { __typename: 'LodgingEnrichedMessage', value: string, state?: Maybe<string> }> }>> };

export type PriceMessageFragmentFragment = { __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: Maybe<string> }, disclaimer?: Maybe<{ __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: Maybe<{ __typename: 'UIPrimaryButton', accessibility?: Maybe<string>, primary?: Maybe<string> }> }> };

export type PricePresentationDialogFragmentFragment = { __typename: 'Offer', pricePresentationDialog?: Maybe<{ __typename: 'PricePresentationDialog', toolbar?: Maybe<{ __typename: 'LodgingDialogToolbar', title?: Maybe<string>, icon?: Maybe<{ __typename: 'Icon', description: string }>, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }> }>, trigger: { __typename: 'LodgingDialogTriggerMessage', value: string, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }> } }>, pricePresentation?: Maybe<{ __typename: 'PricePresentation', title?: Maybe<{ __typename: 'PricePresentationTitle', primary: string }>, sections: Array<(
      { __typename: 'PricePresentationSection' }
      & PricePresentationSectionFragmentFragment
    )>, footer?: Maybe<{ __typename: 'PricePresentationFooter', header?: Maybe<string>, messages: Array<(
        { __typename: 'PriceLineHeading' }
        & PriceLineHeadingFragmentFragment
      ) | (
        { __typename: 'PriceLineText' }
        & PriceLineTextFragmentFragment
      )> }> }> };

export type PricePresentationSectionFragmentFragment = { __typename: 'PricePresentationSection', header?: Maybe<{ __typename: 'PricePresentationLineItem', name: (
      { __typename: 'PricePresentationLineItemEntry' }
      & PricePresentationLineItemEntryFragmentFragment
    ), enrichedValue?: Maybe<(
      { __typename: 'PricePresentationLineItemEntry' }
      & PricePresentationLineItemEntryFragmentFragment
    )> }>, subSections: Array<(
    { __typename: 'PricePresentationSubSection' }
    & PricePresentationSubSectionFragmentFragment
  )> };

export type PriceLineTextFragmentFragment = { __typename: 'PriceLineText', theme?: Maybe<TextTheme>, primary: string, weight?: Maybe<TextWeight>, additionalInfo?: Maybe<(
    { __typename: 'AdditionalInformationPopover' }
    & AdditionalInformationPopoverFragmentFragment
  )>, icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }> };

export type PriceLineHeadingFragmentFragment = { __typename: 'PriceLineHeading', primary: string, tag: string, size: string, additionalInfo?: Maybe<(
    { __typename: 'AdditionalInformationPopover' }
    & AdditionalInformationPopoverFragmentFragment
  )>, icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }> };

export type PricePresentationLineItemEntryFragmentFragment = { __typename: 'PricePresentationLineItemEntry', primaryMessage: (
    { __typename: 'PriceLineHeading' }
    & PriceLineHeadingFragmentFragment
  ) | (
    { __typename: 'PriceLineText' }
    & PriceLineTextFragmentFragment
  ), secondaryMessages: Array<(
    { __typename: 'PriceLineHeading' }
    & PriceLineHeadingFragmentFragment
  ) | (
    { __typename: 'PriceLineText' }
    & PriceLineTextFragmentFragment
  )> };

export type PricePresentationSubSectionFragmentFragment = { __typename: 'PricePresentationSubSection', header?: Maybe<{ __typename: 'PricePresentationLineItem', name: { __typename: 'PricePresentationLineItemEntry', primaryMessage: { __typename: 'PriceLineHeading', primary: string } | { __typename: 'PriceLineText', primary: string } }, enrichedValue?: Maybe<(
      { __typename: 'PricePresentationLineItemEntry' }
      & PricePresentationLineItemEntryFragmentFragment
    )> }>, items: Array<(
    { __typename: 'PricePresentationLineItem' }
    & PricePresentationLineItemFragmentFragment
  )> };

export type PricePresentationLineItemFragmentFragment = { __typename: 'PricePresentationLineItem', enrichedValue?: Maybe<(
    { __typename: 'PricePresentationLineItemEntry' }
    & PricePresentationLineItemEntryFragmentFragment
  )>, name: (
    { __typename: 'PricePresentationLineItemEntry' }
    & PricePresentationLineItemEntryFragmentFragment
  ) };

export type AdditionalInformationPopoverFragmentFragment = { __typename: 'AdditionalInformationPopover', icon?: Maybe<{ __typename: 'Icon', id: string, description: string, size?: Maybe<IconSize> }>, analytics?: Maybe<{ __typename: 'ClientSideAnalytics', linkName: string, referrerId: string }>, enrichedSecondaries: Array<(
    { __typename: 'AdditionalInformationPopoverGridSection' }
    & AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverGridSection_Fragment
  ) | (
    { __typename: 'AdditionalInformationPopoverListSection' }
    & AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverListSection_Fragment
  ) | (
    { __typename: 'AdditionalInformationPopoverTextSection' }
    & AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverTextSection_Fragment
  )> };

type AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverGridSection_Fragment = { __typename: 'AdditionalInformationPopoverGridSection' };

type AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverListSection_Fragment = (
  { __typename: 'AdditionalInformationPopoverListSection' }
  & AdditionalInformationPopoverListSectionFragmentFragment
);

type AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverTextSection_Fragment = (
  { __typename: 'AdditionalInformationPopoverTextSection' }
  & AdditionalInformationPopoverTextSectionFragmentFragment
);

export type AdditionalInformationPopoverSectionFragmentFragment = AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverGridSection_Fragment | AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverListSection_Fragment | AdditionalInformationPopoverSectionFragment_AdditionalInformationPopoverTextSection_Fragment;

export type AdditionalInformationPopoverTextSectionFragmentFragment = { __typename: 'AdditionalInformationPopoverTextSection', text: { __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string } };

export type AdditionalInformationPopoverListSectionFragmentFragment = { __typename: 'AdditionalInformationPopoverListSection', content: { __typename: 'EGDSOrderedList', items: Array<{ __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string }> } | { __typename: 'EGDSUnorderedList', items: Array<{ __typename: 'EGDSBasicLocalizedText', text: string } | { __typename: 'EGDSCardinalLocalizedText', text: string } | { __typename: 'EGDSCompositeLocalizedText', text: string } | { __typename: 'EGDSHeading', text: string } | { __typename: 'EGDSIconText', text: string } | { __typename: 'EGDSInlineLink', text: string } | { __typename: 'EGDSLocalizedTextTemplate', text: string } | { __typename: 'EGDSParagraph', text: string } | { __typename: 'EGDSPlainText', text: string } | { __typename: 'EGDSSpannableText', text: string } | { __typename: 'EGDSStandardLink', text: string } | { __typename: 'EGDSStylizedText', text: string } | { __typename: 'EGDSTextIconListItem', text: string } | { __typename: 'EGDSTextStandardListItem', text: string }> } };

export type PropertyRateCalendarQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  criteria?: Maybe<PropertySearchCriteriaInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
}>;


export type PropertyRateCalendarQuery = { __typename: 'Query', propertySearch: { __typename: 'PropertySearchResults', rateCalendar: { __typename: 'PropertyCalendar', disclaimer: { __typename: 'LodgingPlainMessage', value: string }, legend?: Maybe<Array<{ __typename: 'PropertyCalendarPriceTrendLegend', trend: PropertyCalendarPriceTrend, symbol: string, label: string }>>, propertyCalendarRates: Array<{ __typename: 'PropertyCalendarRate', accessibilityLabel: string, displayPrice: string, date: { __typename: 'Date', isoFormat: string } }> } } };

export type PropertySearchTravelAdsQueryVariables = Exact<{
  context: ContextInput;
  destination: DestinationInput;
  rooms?: Maybe<Array<RoomInput> | RoomInput>;
  dateRange?: Maybe<PropertyDateRangeInput>;
  sort?: Maybe<PropertySort>;
  filters?: Maybe<PropertySearchFiltersInput>;
  marketing?: Maybe<PropertyMarketingInfoInput>;
  legacyCriteria?: Maybe<LegacyPropertySearchCriteriaInput>;
  propertyShopOptions?: Maybe<PropertyShopOptionsInput>;
  searchPagination?: Maybe<PaginationInput>;
  searchIntent?: Maybe<SearchIntentInput>;
  shoppingContext?: Maybe<ShoppingContextInput>;
  criteria?: Maybe<PropertySearchCriteriaInput>;
}>;


export type PropertySearchTravelAdsQuery = { __typename: 'Query', propertySearch: { __typename: 'PropertySearchResults', properties: Array<{ __typename: 'Property', id: string, name: string, vipMessaging?: Maybe<string>, infositeURL: string, star?: Maybe<number>, starRatingIcon: string, supportingMessages?: Maybe<Array<string>>, highlightedPropertyDetails: Array<string>, amenities: Array<{ __typename: 'PropertyAmenityValue', icon: string, name: string }>, propertyImage?: Maybe<{ __typename: 'PropertyImage', imageId?: Maybe<string>, image: { __typename: 'Image', description: string, url: any }, fallbackImage?: Maybe<{ __typename: 'Image', description: string, url: any }> }>, offerBadge?: Maybe<{ __typename: 'OfferBadge', primary?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string }>, mark?: Maybe<{ __typename: 'Mark', id: string, description: string }> }>, secondary?: Maybe<{ __typename: 'Badge', text?: Maybe<string>, theme_temp?: Maybe<Theme>, icon_temp?: Maybe<{ __typename: 'Icon', id: string, description: string }> }> }>, price?: Maybe<{ __typename: 'PropertyPrice', alignment?: Maybe<string>, strikeOutType?: Maybe<StrikeOutType>, roomNightMessage?: Maybe<string>, displayMessages?: Maybe<Array<{ __typename: 'PriceDisplayMessage', lineItems: Array<{ __typename: 'DisplayPrice', role: string, price: { __typename: 'FormattedMoney', formatted: string, accessibilityLabel?: Maybe<string> }, disclaimer?: Maybe<{ __typename: 'LodgingPlainDialog', content: Array<string>, primaryUIButton?: Maybe<{ __typename: 'UIPrimaryButton', accessibility?: Maybe<string>, primary?: Maybe<string> }> }> } | { __typename: 'LodgingEnrichedMessage', value: string, state?: Maybe<string> }> }>>, lead?: Maybe<{ __typename: 'Money', formatted: string }>, strikeOut?: Maybe<{ __typename: 'Money', formatted: string }>, disclaimer?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }>, priceMessages?: Maybe<Array<{ __typename: 'LodgingPlainMessage', value: string }>>, marketingFeeDetails?: Maybe<{ __typename: 'MarketingFeeDetails', tierName: string, tierIcon: string, marketingFeeMessage: { __typename: 'LodgingPlainMessage', value: string } }>, options?: Maybe<Array<{ __typename: 'PropertyPriceOption', leadingCaption?: Maybe<string>, displayPrice?: Maybe<{ __typename: 'Money', formatted: string }>, strikeOut?: Maybe<{ __typename: 'Money', formatted: string }>, loyaltyPrice?: Maybe<{ __typename: 'LoyaltyPrice', unit?: Maybe<string>, amount?: Maybe<{ __typename: 'FormattedNumber', formatted: string }>, totalStrikeOutPoints?: Maybe<{ __typename: 'FormattedNumber', formatted: string }> }>, disclaimer?: Maybe<{ __typename: 'LodgingPlainMessage', value: string }> }>> }>, reviews: { __typename: 'PropertyReviewsSummary', score?: Maybe<number>, localizedScore?: Maybe<string>, total?: Maybe<number>, localizedTotal?: Maybe<string>, superlative?: Maybe<string>, localizedSubtitle?: Maybe<string>, localizedSubtitleA11y?: Maybe<{ __typename: 'LodgingEnrichedMessage', accessibilityLabel?: Maybe<string>, value: string }> }, destinationInfo: { __typename: 'PropertyDestinationInfo', distanceFromMessaging?: Maybe<string> }, propertyDetailsLink?: Maybe<{ __typename: 'LodgingLink', uri: { __typename: 'HttpURI', relativePath: string, value: string }, clientSideAnalytics?: Maybe<{ __typename: 'ClientSideAnalytics', referrerId: string, linkName: string }> }>, availability: { __typename: 'PropertyAvailability', available: boolean, text?: Maybe<string>, theme?: Maybe<Theme> }, offerSummary: { __typename: 'OfferSummary', messages?: Maybe<Array<{ __typename: 'OfferSummaryMessage', message?: Maybe<string>, theme?: Maybe<Theme>, type?: Maybe<string>, mark?: Maybe<{ __typename: 'Mark', id: string }> }>> }, legalDisclaimer?: Maybe<{ __typename: 'PropertyLegalDisclaimer', title?: Maybe<string>, disclaimerContents?: Maybe<Array<string>> }>, neighborhood?: Maybe<{ __typename: 'Region', name: string }>, recentlyViewed?: Maybe<{ __typename: 'Icon', id: string, description: string }>, shortList?: Maybe<{ __typename: 'ShortList', favorited: boolean, saveUrl: string, removeUrl: string, metaData: { __typename: 'ShortListMetaData', chkIn: string, chkOut: string, hotelId: string, roomConfiguration: string } }>, sponsoredListing?: Maybe<{ __typename: 'SponsoredListing', id?: Maybe<string>, clickRedirectTrackingUrl?: Maybe<any>, clickTrackingUrl?: Maybe<any>, details?: Maybe<string>, detailsHeadline?: Maybe<string>, hotelImage?: Maybe<string>, impressionTrackingUrl?: Maybe<any>, trackingData?: Maybe<string>, brand?: Maybe<string>, clickRedirectLinkoffTrackingUrl?: Maybe<any>, logo?: Maybe<string>, lotagline?: Maybe<string>, rating?: Maybe<string>, slots?: Maybe<string>, vanityUrl?: Maybe<any>, rank?: Maybe<string>, position?: Maybe<string> }>, dataAttributes?: Maybe<{ __typename: 'GraphQLPair', key: string, value: string }> }> } };

export type RemoveItemFromCartMutationVariables = Exact<{
  cartId: Scalars['UUID'];
  context: ContextInput;
  itemId: Scalars['UUID'];
}>;


export type RemoveItemFromCartMutation = { __typename: 'Mutation', cartItems: { __typename: 'CartMutations', remove: { __typename: 'CartSummary', id: any, itemCount: number } } };

export type SelectProductsMutationVariables = Exact<{
  context: ContextInput;
  sessionId: Scalars['String'];
  priceToken?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<PropertyNaturalKeyInput> | PropertyNaturalKeyInput>;
  flights?: Maybe<Array<FlightNaturalKeyInput> | FlightNaturalKeyInput>;
  cars?: Maybe<Array<CarNaturalKeyInput> | CarNaturalKeyInput>;
}>;


export type SelectProductsMutation = { __typename: 'Mutation', multiItemShopping: { __typename: 'MultiItemSessionMutations', selectProducts: { __typename: 'MultiItemSearchContextCreatedResponse', redirectUrl?: Maybe<any>, shoppingContext: { __typename: 'ShoppingContext', multiItem?: Maybe<{ __typename: 'MultiItemContext', id: string, packageType: PackageType }> } } | { __typename: 'MultiItemSearchContextErrorResponse', message?: Maybe<string> } } };

type DiscriminateUnion<T, U> = T extends U ? T : never;

export namespace AddPropertyToCart {
  export type Variables = AddPropertyToCartMutationVariables;
  export type Mutation = AddPropertyToCartMutation;
  export type CartItems = (NonNullable<AddPropertyToCartMutation['cartItems']>);
  export type AddProperty = (NonNullable<(NonNullable<AddPropertyToCartMutation['cartItems']>)['addProperty']>);
}

export namespace CreateMultiItemSession {
  export type Variables = CreateMultiItemSessionMutationVariables;
  export type Mutation = CreateMultiItemSessionMutation;
  export type CreateMultiItemSession = (NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type ShoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<CreateMultiItemSessionMutation['createMultiItemSession']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
}

export namespace CreateSessionCart {
  export type Variables = CreateSessionCartMutationVariables;
  export type Mutation = CreateSessionCartMutation;
  export type CreateSessionCart = (NonNullable<CreateSessionCartMutation['createSessionCart']>);
}

export namespace EmptyCart {
  export type Variables = EmptyCartMutationVariables;
  export type Mutation = EmptyCartMutation;
  export type CartItems = (NonNullable<EmptyCartMutation['cartItems']>);
  export type EmptyCart = (NonNullable<(NonNullable<EmptyCartMutation['cartItems']>)['emptyCart']>);
}

export namespace FederatedCart {
  export type Variables = FederatedCartQueryVariables;
  export type Query = FederatedCartQuery;
  export type Cart = (NonNullable<FederatedCartQuery['cart']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>;
  export type PropertyCartItemInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>);
  export type Offers = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>;
  export type NaturalKeys = NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>;
  export type CheckIn = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkIn']>);
  export type CheckOut = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkOut']>);
  export type Rooms = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<FederatedCartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['rooms']>)[number]>;
}

export namespace Cart {
  export type Variables = CartQueryVariables;
  export type Query = CartQuery;
  export type Cart = (NonNullable<CartQuery['cart']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>;
  export type PropertyCartItemInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>);
  export type Offers = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>;
  export type NaturalKeys = NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>;
  export type CheckIn = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkIn']>);
  export type CheckOut = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['checkOut']>);
  export type Rooms = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['naturalKeys']>)[number]>['rooms']>)[number]>;
  export type Offer = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>);
  export type Units = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>;
  export type Photos = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['photos']>)[number]>;
  export type RatePlans = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>;
  export type PriceDetails = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>;
  export type Availability = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['availability']>);
  export type OfferBookButton = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['offerBookButton']>);
  export type Inputs = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['offerBookButton']>)['inputs']>)[number]>;
  export type LodgingTextInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['offerBookButton']>)['inputs']>)[number]>, { __typename: 'LodgingTextInput' }>);
  export type Price = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>);
  export type Total = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['total']>);
  export type Currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['total']>)['currency']>);
  export type Lead = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['lead']>);
  export type _Currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['price']>)['lead']>)['currency']>);
  export type PriceAfterLoyaltyPointsApplied = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>);
  export type _Total = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['total']>);
  export type __Currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['total']>)['currency']>);
  export type _Lead = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['lead']>);
  export type ___Currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['priceAfterLoyaltyPointsApplied']>)['lead']>)['currency']>);
  export type Fees = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['offers']>)[number]>['offer']>)['units']>)[number]>['ratePlans']>)[number]>['priceDetails']>)[number]>['fees']>)[number]>;
  export type Summary = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['summary']>);
  export type Location = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['summary']>)['location']>);
  export type Address = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['summary']>)['location']>)['address']>);
  export type Gallery = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['gallery']>);
  export type Featured = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<CartQuery['cart']>)['items']>)[number]>, { __typename: 'PropertyCartItem' }>)['gallery']>)['featured']>);
}

export namespace InitiateMultiItemSession {
  export type Variables = InitiateMultiItemSessionMutationVariables;
  export type Mutation = InitiateMultiItemSessionMutation;
  export type MultiItemShopping = (NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>);
  export type Initiate = (NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type ShoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<InitiateMultiItemSessionMutation['multiItemShopping']>)['initiate']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}

export namespace PropertyLocationScoreInfo {
  export type Variables = PropertyLocationScoreInfoQueryVariables;
  export type Query = PropertyLocationScoreInfoQuery;
  export type PropertyReviewAggregates = (NonNullable<PropertyLocationScoreInfoQuery['propertyReviewAggregates']>);
  export type PropertySummaries = NonNullable<(NonNullable<(NonNullable<PropertyLocationScoreInfoQuery['propertyReviewAggregates']>)['propertySummaries']>)[number]>;
  export type LocationScore = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyLocationScoreInfoQuery['propertyReviewAggregates']>)['propertySummaries']>)[number]>['locationScore']>);
  export type Tags = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyLocationScoreInfoQuery['propertyReviewAggregates']>)['propertySummaries']>)[number]>['locationScore']>)['tags']>)[number]>;
}

export namespace LodgingPwaPropertySearch {
  export type Variables = LodgingPwaPropertySearchQueryVariables;
  export type Query = LodgingPwaPropertySearchQuery;
  export type PropertySearch = (NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>);
  export type SearchCriteria = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>);
  export type PropertyShopOptions = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['propertyShopOptions']>);
  export type DateRange = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['dateRange']>);
  export type CheckInDate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['dateRange']>)['checkInDate']>);
  export type CheckOutDate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['dateRange']>)['checkOutDate']>);
  export type Destination = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['destination']>);
  export type SearchIntent = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['searchIntent']>);
  export type Filters = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['filters']>);
  export type ReviewScore = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['searchCriteria']>)['filters']>)['reviewScore']>);
  export type SortAndFilter = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>);
  export type Defaults = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['defaults']>);
  export type Selected = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['selected']>);
  export type PriceFilterPills = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['selected']>)['priceFilterPills']>);
  export type Aggregate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['selected']>)['priceFilterPills']>)['aggregate']>);
  export type Options = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['options']>);
  export type _SortAndFilter = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>;
  export type ShowListOptions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['showListOptions']>);
  export type DropdownOptions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['dropdownOptions']>);
  export type _Options = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['options']>)[number]>;
  export type Range = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['options']>)[number]>['range']>);
  export type PropertySearchListings = NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>;
  export type PropertyInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'Property' }>);
  export type MessageResultInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'MessageResult' }>);
  export type LodgingHeadingInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'LodgingHeading' }>);
  export type StaticLodgingMultiItemCrossSellInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>);
  export type FallbackListing = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['fallbackListing']>);
  export type _MessageResultInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['propertySearchListings']>)[number]>, { __typename: 'StaticLodgingMultiItemCrossSell' }>)['fallbackListing']>), { __typename: 'MessageResult' }>);
  export type Summary = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>);
  export type ResultsSummary = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultsSummary']>)[number]>;
  export type LodgingLinkMessageInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultsSummary']>)[number]>, { __typename: 'LodgingLinkMessage' }>);
  export type LodgingDialogTriggerMessageInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultsSummary']>)[number]>, { __typename: 'LodgingDialogTriggerMessage' }>);
  export type Region = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['region']>);
  export type ResultSectionHeadings = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['resultSectionHeadings']>)[number]>;
  export type LoyaltyEducation = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['loyaltyEducation']>);
  export type Action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['loyaltyEducation']>)['action']>);
  export type Content = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['loyaltyEducation']>)['content']>);
  export type LoyaltyInfo = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['summary']>)['loyaltyInfo']>);
  export type NavigationTabs = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['navigationTabs']>);
  export type Tabs = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['navigationTabs']>)['tabs']>)[number]>;
  export type TabLink = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['navigationTabs']>)['tabs']>)[number]>['tabLink']>);
  export type Link = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['navigationTabs']>)['tabs']>)[number]>['tabLink']>)['link']>);
  export type Uri = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['navigationTabs']>)['tabs']>)[number]>['tabLink']>)['link']>)['uri']>);
  export type Map = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>);
  export type Bounds = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['bounds']>);
  export type Northeast = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['bounds']>)['northeast']>);
  export type Southwest = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['bounds']>)['southwest']>);
  export type Center = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['center']>);
  export type Markers = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['markers']>)[number]>;
  export type MapMarker = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['markers']>)[number]>['mapMarker']>);
  export type LatLong = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['markers']>)[number]>['mapMarker']>)['latLong']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['markers']>)[number]>['mapMarker']>)['clientSideAnalytics']>);
  export type _PropertyInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['markers']>)[number]>, { __typename: 'Property' }>);
  export type PointOfInterestInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['markers']>)[number]>, { __typename: 'PointOfInterest' }>);
  export type MessagingModel = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['messagingModel']>);
  export type Title = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['messagingModel']>)['title']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['messagingModel']>)['title']>)['icon']>);
  export type Subtitle = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['messagingModel']>)['subtitle']>);
  export type _Icon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['map']>)['messagingModel']>)['subtitle']>)['icon']>);
  export type ExitIntent = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['exitIntent']>);
  export type Message = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['exitIntent']>)['message']>);
  export type LegalDisclaimer = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['legalDisclaimer']>);
  export type _Content = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['legalDisclaimer']>)['content']>)[number]>;
  export type ShoppingContext = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContext = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>);
  export type Cars = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>;
  export type Primary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>);
  export type PickUpDateTime = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['pickUpDateTime']>);
  export type DropOffDateTime = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['dropOffDateTime']>);
  export type PickUpLocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['pickUpLocation']>);
  export type DropOffLocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['cars']>)[number]>['primary']>)['dropOffLocation']>);
  export type Flights = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>;
  export type _Primary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>);
  export type Travelers = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['travelers']>)[number]>;
  export type JourneyCriterias = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>;
  export type DepartureDate = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['journeyCriterias']>)[number]>['departureDate']>);
  export type SearchPreferences = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['multiItemSearchContext']>)['flights']>)[number]>['primary']>)['searchPreferences']>);
  export type ErrorResponse = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>);
  export type __Icon = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['icon']>);
  export type Button = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>);
  export type _Action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>);
  export type UiLinkActionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>);
  export type Analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['analytics']>);
  export type Resource = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>);
  export type HttpUriInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type ErrorRecoveryButtons = NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>;
  export type __Action = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>);
  export type _UiLinkActionInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>);
  export type _Analytics = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>)['analytics']>);
  export type _Resource = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>)['resource']>);
  export type _HttpUriInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['errorResponse']>)['errorRecoveryButtons']>)[number]>['action']>), { __typename: 'UILinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
  export type DialogErrorResponse = (NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>);
  export type _Button = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>);
  export type ___Action = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>);
  export type __UiLinkActionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>);
  export type __Analytics = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['analytics']>);
  export type __Resource = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>);
  export type __HttpUriInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchQuery['propertySearch']>)['dialogErrorResponse']>)['button']>)['action']>), { __typename: 'UILinkAction' }>)['resource']>), { __typename: 'HttpURI' }>);
}

export namespace MultiItemPropertySearchContextFields {
  export type Fragment = MultiItemPropertySearchContextFieldsFragment;
  export type Properties = NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>;
  export type Primary = (NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>);
  export type Rooms = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['rooms']>)[number]>;
  export type Destination = (NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['destination']>);
  export type DateRange = (NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['dateRange']>);
  export type CheckInDate = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['dateRange']>)['checkInDate']>);
  export type CheckOutDate = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MultiItemPropertySearchContextFieldsFragment['properties']>)[number]>['primary']>)['dateRange']>)['checkOutDate']>);
}

export namespace MessageFields {
  export type Fragment = MessageFieldsFragment;
  export type Title = (NonNullable<MessageFieldsFragment['title']>);
  export type Subtitle = (NonNullable<MessageFieldsFragment['subtitle']>);
  export type Action = (NonNullable<MessageFieldsFragment['action']>);
  export type Primary = (NonNullable<(NonNullable<MessageFieldsFragment['action']>)['primary']>);
  export type Secondary = (NonNullable<(NonNullable<MessageFieldsFragment['action']>)['secondary']>);
}

export namespace MessageTitleFields {
  export type Fragment = MessageTitleFieldsFragment;
  export type Icon = (NonNullable<MessageTitleFieldsFragment['icon']>);
  export type Mark = (NonNullable<MessageTitleFieldsFragment['mark']>);
  export type Illustration = (NonNullable<MessageTitleFieldsFragment['illustration']>);
  export type AssetUri = (NonNullable<(NonNullable<MessageTitleFieldsFragment['illustration']>)['assetUri']>);
}

export namespace MessagingActionFields {
  export type Fragment = MessagingActionFieldsFragment;
  export type ActionDetails = (NonNullable<MessagingActionFieldsFragment['actionDetails']>);
}

export namespace PropertyFields {
  export type Fragment = PropertyFieldsFragment;
  export type Amenities = NonNullable<(NonNullable<PropertyFieldsFragment['amenities']>)[number]>;
  export type Availability = (NonNullable<PropertyFieldsFragment['availability']>);
  export type OfferSummary = (NonNullable<PropertyFieldsFragment['offerSummary']>);
  export type Messages = NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['offerSummary']>)['messages']>)[number]>;
  export type Mark = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['offerSummary']>)['messages']>)[number]>['mark']>);
  export type Url = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['offerSummary']>)['messages']>)[number]>['mark']>)['url']>);
  export type LegalDisclaimer = (NonNullable<PropertyFieldsFragment['legalDisclaimer']>);
  export type ImageGallery = (NonNullable<PropertyFieldsFragment['imageGallery']>);
  export type Images = NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['imageGallery']>)['images']>)[number]>;
  export type Image = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['imageGallery']>)['images']>)[number]>['image']>);
  export type FallbackImage = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['imageGallery']>)['images']>)[number]>['fallbackImage']>);
  export type MapMarker = (NonNullable<PropertyFieldsFragment['mapMarker']>);
  export type LatLong = (NonNullable<(NonNullable<PropertyFieldsFragment['mapMarker']>)['latLong']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<PropertyFieldsFragment['mapMarker']>)['clientSideAnalytics']>);
  export type Neighborhood = (NonNullable<PropertyFieldsFragment['neighborhood']>);
  export type OfferBadge = (NonNullable<PropertyFieldsFragment['offerBadge']>);
  export type Primary = (NonNullable<(NonNullable<PropertyFieldsFragment['offerBadge']>)['primary']>);
  export type Icon_Temp = (NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['offerBadge']>)['primary']>)['icon_temp']>);
  export type _Mark = (NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['offerBadge']>)['primary']>)['mark']>);
  export type Secondary = (NonNullable<(NonNullable<PropertyFieldsFragment['offerBadge']>)['secondary']>);
  export type _Icon_Temp = (NonNullable<(NonNullable<(NonNullable<PropertyFieldsFragment['offerBadge']>)['secondary']>)['icon_temp']>);
  export type PinnedDetails = (NonNullable<PropertyFieldsFragment['pinnedDetails']>);
  export type RecentlyViewed = (NonNullable<PropertyFieldsFragment['recentlyViewed']>);
  export type FeaturedMessages = NonNullable<(NonNullable<PropertyFieldsFragment['featuredMessages']>)[number]>;
  export type ShortList = (NonNullable<PropertyFieldsFragment['shortList']>);
  export type MetaData = (NonNullable<(NonNullable<PropertyFieldsFragment['shortList']>)['metaData']>);
  export type PropertySource = (NonNullable<PropertyFieldsFragment['propertySource']>);
  export type Graphic = (NonNullable<(NonNullable<PropertyFieldsFragment['propertySource']>)['graphic']>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<PropertyFieldsFragment['propertySource']>)['graphic']>), { __typename: 'Mark' }>);
  export type _Url = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<PropertyFieldsFragment['propertySource']>)['graphic']>), { __typename: 'Mark' }>)['url']>);
  export type Text = (NonNullable<(NonNullable<PropertyFieldsFragment['propertySource']>)['text']>);
  export type DataAttributes = (NonNullable<PropertyFieldsFragment['dataAttributes']>);
  export type ListingFooter = (NonNullable<PropertyFieldsFragment['listingFooter']>);
  export type ActionDetails = (NonNullable<(NonNullable<PropertyFieldsFragment['listingFooter']>)['actionDetails']>);
  export type Icon = (NonNullable<(NonNullable<PropertyFieldsFragment['listingFooter']>)['icon']>);
}

export namespace SearchLinkMessage {
  export type Fragment = SearchLinkMessageFragment;
  export type Link = (NonNullable<SearchLinkMessageFragment['link']>);
  export type Icon = (NonNullable<SearchLinkMessageFragment['icon']>);
}

export namespace SearchDialogMessage {
  export type Fragment = SearchDialogMessageFragment;
  export type DialogTrigger = (NonNullable<SearchDialogMessageFragment['dialogTrigger']>);
  export type ActionDetails = (NonNullable<(NonNullable<SearchDialogMessageFragment['dialogTrigger']>)['actionDetails']>);
  export type Icon = (NonNullable<SearchDialogMessageFragment['icon']>);
}

export namespace SearchLink {
  export type Fragment = SearchLinkFragment;
}

export namespace DisplayPriceFragment {
  export type Fragment = DisplayPriceFragmentFragment;
  export type Price = (NonNullable<DisplayPriceFragmentFragment['price']>);
  export type Disclaimer = (NonNullable<DisplayPriceFragmentFragment['disclaimer']>);
  export type PrimaryUiButton = (NonNullable<(NonNullable<DisplayPriceFragmentFragment['disclaimer']>)['primaryUIButton']>);
}

export namespace EnrichedMessageFragment {
  export type Fragment = EnrichedMessageFragmentFragment;
}

export namespace CommonPropertyCardFields {
  export type Fragment = CommonPropertyCardFieldsFragment;
  export type PropertyImage = (NonNullable<CommonPropertyCardFieldsFragment['propertyImage']>);
  export type Image = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyImage']>)['image']>);
  export type FallbackImage = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyImage']>)['fallbackImage']>);
  export type OfferBadge = (NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>);
  export type Primary = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['primary']>);
  export type Icon_Temp = (NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['primary']>)['icon_temp']>);
  export type Mark = (NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['primary']>)['mark']>);
  export type Secondary = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['secondary']>);
  export type _Icon_Temp = (NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['offerBadge']>)['secondary']>)['icon_temp']>);
  export type Price = (NonNullable<CommonPropertyCardFieldsFragment['price']>);
  export type DisplayMessages = NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['displayMessages']>)[number]>;
  export type LineItems = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>;
  export type Lead = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['lead']>);
  export type StrikeOut = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['strikeOut']>);
  export type Disclaimer = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['disclaimer']>);
  export type PriceMessages = NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['priceMessages']>)[number]>;
  export type MarketingFeeDetails = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['marketingFeeDetails']>);
  export type MarketingFeeMessage = (NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['marketingFeeDetails']>)['marketingFeeMessage']>);
  export type Options = NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>;
  export type DisplayPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['displayPrice']>);
  export type _StrikeOut = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['strikeOut']>);
  export type LoyaltyPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['loyaltyPrice']>);
  export type Amount = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['loyaltyPrice']>)['amount']>);
  export type TotalStrikeOutPoints = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['loyaltyPrice']>)['totalStrikeOutPoints']>);
  export type _Disclaimer = (NonNullable<NonNullable<(NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['price']>)['options']>)[number]>['disclaimer']>);
  export type Reviews = (NonNullable<CommonPropertyCardFieldsFragment['reviews']>);
  export type LocalizedSubtitleA11y = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['reviews']>)['localizedSubtitleA11y']>);
  export type _Mark = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['reviews']>)['mark']>);
  export type DestinationInfo = (NonNullable<CommonPropertyCardFieldsFragment['destinationInfo']>);
  export type PropertyDetailsLink = (NonNullable<CommonPropertyCardFieldsFragment['propertyDetailsLink']>);
  export type Uri = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyDetailsLink']>)['uri']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<CommonPropertyCardFieldsFragment['propertyDetailsLink']>)['clientSideAnalytics']>);
  export type SponsoredListing = (NonNullable<CommonPropertyCardFieldsFragment['sponsoredListing']>);
}

export namespace CommonDateFields {
  export type Fragment = CommonDateFieldsFragment;
}

export namespace CommonDateTimeFields {
  export type Fragment = CommonDateTimeFieldsFragment;
}

export namespace PointsEducationFragment {
  export type Fragment = PointsEducationFragmentFragment;
  export type ProgramFeatures = NonNullable<(NonNullable<PointsEducationFragmentFragment['programFeatures']>)[number]>;
  export type Perks = (NonNullable<NonNullable<(NonNullable<PointsEducationFragmentFragment['programFeatures']>)[number]>['perks']>);
  export type HeroImage = (NonNullable<PointsEducationFragmentFragment['heroImage']>);
}

export namespace ProgramEducationFragment {
  export type Fragment = ProgramEducationFragmentFragment;
  export type Perks = (NonNullable<ProgramEducationFragmentFragment['perks']>);
}

export namespace PerksFragment {
  export type Fragment = PerksFragmentFragment;
}

export namespace FeaturedMessage {
  export type Fragment = FeaturedMessageFragment;
  export type Icon = (NonNullable<FeaturedMessageFragment['icon']>);
}

export namespace LodgingPwaPropertySearchSortAndFilter {
  export type Variables = LodgingPwaPropertySearchSortAndFilterQueryVariables;
  export type Query = LodgingPwaPropertySearchSortAndFilterQuery;
  export type PropertySearch = (NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>);
  export type SortAndFilter = (NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>);
  export type Defaults = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['defaults']>);
  export type Selected = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['selected']>);
  export type PriceFilterPills = (NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['selected']>)['priceFilterPills']>);
  export type Aggregate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['selected']>)['priceFilterPills']>)['aggregate']>);
  export type Options = (NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['options']>);
  export type _SortAndFilter = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>;
  export type ShowListOptions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['showListOptions']>);
  export type DropdownOptions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['dropdownOptions']>);
  export type _Options = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['options']>)[number]>;
  export type Range = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<LodgingPwaPropertySearchSortAndFilterQuery['propertySearch']>)['sortAndFilter']>)['options']>)['sortAndFilter']>)[number]>['options']>)[number]>['range']>);
}

export namespace PrepareCheckoutByCartId {
  export type Variables = PrepareCheckoutByCartIdMutationVariables;
  export type Mutation = PrepareCheckoutByCartIdMutation;
  export type PrepareCheckoutByCartId = (NonNullable<PrepareCheckoutByCartIdMutation['prepareCheckoutByCartId']>);
  export type FailureReason = (NonNullable<(NonNullable<PrepareCheckoutByCartIdMutation['prepareCheckoutByCartId']>)['failureReason']>);
  export type MaxRoomsFailureInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<PrepareCheckoutByCartIdMutation['prepareCheckoutByCartId']>)['failureReason']>), { __typename: 'MaxRoomsFailure' }>);
}

export namespace PrepareCheckout {
  export type Variables = PrepareCheckoutMutationVariables;
  export type Mutation = PrepareCheckoutMutation;
  export type PrepareCheckout = (NonNullable<PrepareCheckoutMutation['prepareCheckout']>);
}

export namespace PropertyAvailabilityCheck {
  export type Variables = PropertyAvailabilityCheckQueryVariables;
  export type Query = PropertyAvailabilityCheckQuery;
  export type PropertyOffers = (NonNullable<PropertyAvailabilityCheckQuery['propertyOffers']>);
  export type ErrorMessage = (NonNullable<(NonNullable<PropertyAvailabilityCheckQuery['propertyOffers']>)['errorMessage']>);
  export type Title = (NonNullable<(NonNullable<(NonNullable<PropertyAvailabilityCheckQuery['propertyOffers']>)['errorMessage']>)['title']>);
  export type Listings = NonNullable<(NonNullable<(NonNullable<PropertyAvailabilityCheckQuery['propertyOffers']>)['listings']>)[number]>;
  export type PropertyUnitInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<PropertyAvailabilityCheckQuery['propertyOffers']>)['listings']>)[number]>, { __typename: 'PropertyUnit' }>);
}

export namespace PropertyInfoPageLayout {
  export type Variables = PropertyInfoPageLayoutQueryVariables;
  export type Query = PropertyInfoPageLayoutQuery;
  export type PropertyInfo = (NonNullable<PropertyInfoPageLayoutQuery['propertyInfo']>);
  export type Experimental = (NonNullable<(NonNullable<PropertyInfoPageLayoutQuery['propertyInfo']>)['experimental']>);
  export type PageLayoutExperimentalFeature = (NonNullable<(NonNullable<(NonNullable<PropertyInfoPageLayoutQuery['propertyInfo']>)['experimental']>)['pageLayoutExperimentalFeature']>);
}

export namespace PropertyRoomScoreInfo {
  export type Variables = PropertyRoomScoreInfoQueryVariables;
  export type Query = PropertyRoomScoreInfoQuery;
  export type PropertyReviewAggregates = (NonNullable<PropertyRoomScoreInfoQuery['propertyReviewAggregates']>);
  export type PropertySummaries = NonNullable<(NonNullable<(NonNullable<PropertyRoomScoreInfoQuery['propertyReviewAggregates']>)['propertySummaries']>)[number]>;
  export type RoomsScore = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyRoomScoreInfoQuery['propertyReviewAggregates']>)['propertySummaries']>)[number]>['roomsScore']>)[number]>;
  export type Tags = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertyRoomScoreInfoQuery['propertyReviewAggregates']>)['propertySummaries']>)[number]>['roomsScore']>)[number]>['tags']>)[number]>;
}

export namespace PropertyOffers {
  export type Variables = PropertyOffersQueryVariables;
  export type Query = PropertyOffersQuery;
  export type PropertyOffers = (NonNullable<PropertyOffersQuery['propertyOffers']>);
  export type PropertyHighlightSection = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['header']>);
  export type Badge = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['header']>)['badge']>);
  export type Icon_Temp = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['header']>)['badge']>)['icon_temp']>);
  export type Mark = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['header']>)['mark']>);
  export type SubSections = NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['subSections']>)[number]>;
  export type Contents = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['subSections']>)[number]>['contents']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['subSections']>)[number]>['contents']>)[number]>['icon']>);
  export type FooterLink = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['footerLink']>);
  export type _Icon = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['footerLink']>)['icon']>);
  export type Link = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['footerLink']>)['link']>);
  export type Uri = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyHighlightSection']>)['footerLink']>)['link']>)['uri']>);
  export type PropertySearchLink = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertySearchLink']>);
  export type __Icon = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertySearchLink']>)['icon']>);
  export type _Link = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertySearchLink']>)['link']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertySearchLink']>)['link']>)['clientSideAnalytics']>);
  export type _Uri = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertySearchLink']>)['link']>)['uri']>);
  export type PartnerPropertySearchLink = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['partnerPropertySearchLink']>);
  export type ___Icon = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['partnerPropertySearchLink']>)['icon']>);
  export type __Link = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['partnerPropertySearchLink']>)['link']>);
  export type __Uri = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['partnerPropertySearchLink']>)['link']>)['uri']>);
  export type FilterPills = NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['filterPills']>)[number]>;
  export type Loading = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['loading']>);
  export type ListingsHeader = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['listingsHeader']>);
  export type SearchCriteria = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>);
  export type Primary = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>);
  export type DateRange = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>)['dateRange']>);
  export type CheckInDate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>)['dateRange']>)['checkInDate']>);
  export type CheckOutDate = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>)['dateRange']>)['checkOutDate']>);
  export type Destination = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>)['destination']>);
  export type Rooms = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>)['rooms']>)[number]>;
  export type Children = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['primary']>)['rooms']>)[number]>['children']>)[number]>;
  export type Secondary = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>);
  export type Booleans = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>)['booleans']>)[number]>;
  export type Counts = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>)['counts']>)[number]>;
  export type Dates = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>)['dates']>)[number]>;
  export type Value = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>)['dates']>)[number]>['value']>);
  export type Ranges = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>)['ranges']>)[number]>;
  export type Selections = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['searchCriteria']>)['secondary']>)['selections']>)[number]>;
  export type TripSummary = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['tripSummary']>);
  export type Listings = NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['listings']>)[number]>;
  export type CategorizedListings = NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['categorizedListings']>)[number]>;
  export type ErrorMessage = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['errorMessage']>);
  export type Title = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['errorMessage']>)['title']>);
  export type Action = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['errorMessage']>)['action']>);
  export type _Primary = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['errorMessage']>)['action']>)['primary']>);
  export type PaymentPolicy = NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['paymentPolicy']>)[number]>;
  export type SerpMetadata = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['serpMetadata']>);
  export type PriceRange = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['serpMetadata']>)['priceRange']>);
  export type PriceRating = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['serpMetadata']>)['priceRating']>);
  export type StickyBar = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['stickyBar']>);
  export type StickyButton = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['stickyBar']>)['stickyButton']>);
  export type Price = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['stickyBar']>)['price']>);
  export type DisplayPrice = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['stickyBar']>)['price']>)['displayPrice']>);
  export type Disclaimer = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['stickyBar']>)['price']>)['disclaimer']>);
  export type ToastMessage = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['toastMessage']>);
  export type LoyaltyDiscount = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['loyaltyDiscount']>);
  export type LegalDisclaimer = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['legalDisclaimer']>);
  export type Content = NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['legalDisclaimer']>)['content']>)[number]>;
  export type PropertyLevelOffersMessage = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['propertyLevelOffersMessage']>);
  export type OfferLevelMessages = NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['offerLevelMessages']>)[number]>;
  export type AlternateDates = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['alternateDates']>);
  export type AlternateAvailabilityMsg = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['alternateAvailabilityMsg']>);
  export type ShoppingContext = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['shoppingContext']>)['multiItem']>);
  export type SingleUnitOffer = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['singleUnitOffer']>);
  export type SingleUnitOfferDialog = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['singleUnitOfferDialog']>);
  export type _Content = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['singleUnitOfferDialog']>)['content']>);
  export type Toolbar = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['singleUnitOfferDialog']>)['toolbar']>);
  export type Trigger = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['singleUnitOfferDialog']>)['trigger']>);
  export type SpaceDetails = (NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>);
  export type _Header = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['header']>);
  export type FloorPlan = (NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['floorPlan']>);
  export type Images = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['floorPlan']>)['images']>)[number]>;
  export type Image = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['floorPlan']>)['images']>)[number]>['image']>);
  export type _Toolbar = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['floorPlan']>)['toolbar']>);
  export type _Trigger = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['floorPlan']>)['trigger']>);
  export type Spaces = NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['spaces']>)[number]>;
  export type Icons = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyOffersQuery['propertyOffers']>)['spaceDetails']>)['spaces']>)[number]>['icons']>)[number]>;
}

export namespace AlternateDatesFragment {
  export type Fragment = AlternateDatesFragmentFragment;
  export type Header = (NonNullable<AlternateDatesFragmentFragment['header']>);
  export type Options = NonNullable<(NonNullable<AlternateDatesFragmentFragment['options']>)[number]>;
}

export namespace AlternateAvailabilityMsgFragment {
  export type Fragment = AlternateAvailabilityMsgFragmentFragment;
  export type Text = (NonNullable<AlternateAvailabilityMsgFragmentFragment['text']>);
  export type ActionLink = (NonNullable<AlternateAvailabilityMsgFragmentFragment['actionLink']>);
  export type Link = (NonNullable<(NonNullable<AlternateAvailabilityMsgFragmentFragment['actionLink']>)['link']>);
  export type Uri = (NonNullable<(NonNullable<(NonNullable<AlternateAvailabilityMsgFragmentFragment['actionLink']>)['link']>)['uri']>);
}

export namespace PropertyUnitDetailsDialog {
  export type Fragment = PropertyUnitDetailsDialogFragment;
  export type Content = (NonNullable<PropertyUnitDetailsDialogFragment['content']>);
  export type RatePlanTitle = (NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['content']>)['ratePlanTitle']>);
  export type Details = (NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['content']>)['details']>);
  export type Header = (NonNullable<(NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['content']>)['details']>)['header']>);
  export type Contents = NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['content']>)['details']>)['contents']>)[number]>;
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['content']>)['details']>)['contents']>)[number]>['items']>)[number]>;
  export type Trigger = (NonNullable<PropertyUnitDetailsDialogFragment['trigger']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['trigger']>)['clientSideAnalytics']>);
  export type DialogTrigger = (NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['trigger']>)['dialogTrigger']>);
  export type _ClientSideAnalytics = (NonNullable<(NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['trigger']>)['dialogTrigger']>)['clientSideAnalytics']>);
  export type Toolbar = (NonNullable<PropertyUnitDetailsDialogFragment['toolbar']>);
  export type Icon = (NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['toolbar']>)['icon']>);
  export type __ClientSideAnalytics = (NonNullable<(NonNullable<PropertyUnitDetailsDialogFragment['toolbar']>)['clientSideAnalytics']>);
}

export namespace MessageFragment {
  export type Fragment = MessageFragmentFragment;
  export type Title = (NonNullable<MessageFragmentFragment['title']>);
  export type Subtitle = (NonNullable<MessageFragmentFragment['subtitle']>);
  export type Action = (NonNullable<MessageFragmentFragment['action']>);
  export type Primary = (NonNullable<(NonNullable<MessageFragmentFragment['action']>)['primary']>);
  export type Secondary = (NonNullable<(NonNullable<MessageFragmentFragment['action']>)['secondary']>);
  export type FeaturedImage = (NonNullable<MessageFragmentFragment['featuredImage']>);
}

export namespace TitleFragment {
  export type Fragment = TitleFragmentFragment;
  export type Icon = (NonNullable<TitleFragmentFragment['icon']>);
  export type Mark = (NonNullable<TitleFragmentFragment['mark']>);
  export type Illustration = (NonNullable<TitleFragmentFragment['illustration']>);
  export type AssetUri = (NonNullable<(NonNullable<TitleFragmentFragment['illustration']>)['assetUri']>);
}

export namespace ActionFragment {
  export type Fragment = ActionFragmentFragment;
  export type ActionDetails = (NonNullable<ActionFragmentFragment['actionDetails']>);
  export type Icon = (NonNullable<ActionFragmentFragment['icon']>);
}

export namespace LodgingNotificationsCardFragment {
  export type Fragment = LodgingNotificationsCardFragmentFragment;
  export type Header = (NonNullable<LodgingNotificationsCardFragmentFragment['header']>);
  export type Messages = NonNullable<(NonNullable<LodgingNotificationsCardFragmentFragment['messages']>)[number]>;
}

export namespace UnitCategorizationSelectionFragment {
  export type Fragment = UnitCategorizationSelectionFragmentFragment;
  export type ClientSideAnalytics = (NonNullable<UnitCategorizationSelectionFragmentFragment['clientSideAnalytics']>);
  export type Dialog = (NonNullable<UnitCategorizationSelectionFragmentFragment['dialog']>);
}

export namespace UnitCategorizationHeaderFragment {
  export type Fragment = UnitCategorizationHeaderFragmentFragment;
  export type Dialog = (NonNullable<UnitCategorizationHeaderFragmentFragment['dialog']>);
  export type Content = NonNullable<(NonNullable<(NonNullable<UnitCategorizationHeaderFragmentFragment['dialog']>)['content']>)[number]>;
  export type Title = (NonNullable<NonNullable<(NonNullable<(NonNullable<UnitCategorizationHeaderFragmentFragment['dialog']>)['content']>)[number]>['title']>);
  export type PrimaryUiButton = (NonNullable<(NonNullable<UnitCategorizationHeaderFragmentFragment['dialog']>)['primaryUIButton']>);
  export type Toolbar = (NonNullable<(NonNullable<UnitCategorizationHeaderFragmentFragment['dialog']>)['toolbar']>);
  export type Trigger = (NonNullable<(NonNullable<UnitCategorizationHeaderFragmentFragment['dialog']>)['trigger']>);
  export type _Title = (NonNullable<UnitCategorizationHeaderFragmentFragment['title']>);
}

export namespace CategorizedUnitFragment {
  export type Fragment = CategorizedUnitFragmentFragment;
  export type Header = (NonNullable<CategorizedUnitFragmentFragment['header']>);
  export type HighlightedMessages = NonNullable<(NonNullable<CategorizedUnitFragmentFragment['highlightedMessages']>)[number]>;
  export type Features = NonNullable<(NonNullable<CategorizedUnitFragmentFragment['features']>)[number]>;
  export type Graphic = (NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['features']>)[number]>['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['features']>)[number]>['graphic']>), { __typename: 'Icon' }>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['features']>)[number]>['graphic']>), { __typename: 'Mark' }>);
  export type _Graphic = (NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['features']>)[number]>['graphic']>);
  export type MoreInfoDialog = (NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['features']>)[number]>['moreInfoDialog']>);
  export type PrimaryHeader = (NonNullable<CategorizedUnitFragmentFragment['primaryHeader']>);
  export type SecondaryHeader = (NonNullable<CategorizedUnitFragmentFragment['secondaryHeader']>);
  export type TertiaryHeader = (NonNullable<CategorizedUnitFragmentFragment['tertiaryHeader']>);
  export type PrimarySelections = NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>;
  export type PrimarySelection = (NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['primarySelection']>);
  export type SecondarySelections = NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['secondarySelections']>)[number]>;
  export type SecondarySelection = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['secondarySelections']>)[number]>['secondarySelection']>);
  export type TertiarySelections = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['secondarySelections']>)[number]>['tertiarySelections']>)[number]>;
  export type PropertyUnit = (NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>);
  export type UnitGallery = (NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['unitGallery']>);
  export type Images = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['unitGallery']>)['images']>)[number]>;
  export type Image = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['unitGallery']>)['images']>)[number]>['image']>);
  export type AvailabilityCallToAction = (NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['availabilityCallToAction']>);
  export type LodgingPlainMessageInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['availabilityCallToAction']>), { __typename: 'LodgingPlainMessage' }>);
  export type LodgingButtonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['availabilityCallToAction']>), { __typename: 'LodgingButton' }>);
  export type DetailsDialog = (NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['detailsDialog']>);
  export type RoomAmenities = (NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>);
  export type _Header = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['header']>);
  export type BodySubSections = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>;
  export type Contents = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>;
  export type __Header = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['header']>);
  export type Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['header']>)['icon']>);
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['items']>)[number]>;
  export type PropertyContentItemMarkupInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['items']>)[number]>, { __typename: 'PropertyContentItemMarkup' }>);
  export type Content = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['items']>)[number]>, { __typename: 'PropertyContentItemMarkup' }>)['content']>);
  export type RatePlans = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CategorizedUnitFragmentFragment['primarySelections']>)[number]>['propertyUnit']>)['ratePlans']>)[number]>;
}

export namespace UnitFragment {
  export type Fragment = UnitFragmentFragment;
  export type BedOptions = NonNullable<(NonNullable<UnitFragmentFragment['bedOptions']>)[number]>;
  export type Header = (NonNullable<UnitFragmentFragment['header']>);
  export type Icon = (NonNullable<(NonNullable<UnitFragmentFragment['header']>)['icon']>);
  export type DetailsDialog = (NonNullable<UnitFragmentFragment['detailsDialog']>);
  export type RatePlans = NonNullable<(NonNullable<UnitFragmentFragment['ratePlans']>)[number]>;
  export type UnavailableRatePlans = NonNullable<(NonNullable<UnitFragmentFragment['unavailableRatePlans']>)[number]>;
  export type RatePlansExpando = (NonNullable<UnitFragmentFragment['ratePlansExpando']>);
  export type ExpandButton = (NonNullable<(NonNullable<UnitFragmentFragment['ratePlansExpando']>)['expandButton']>);
  export type Features = NonNullable<(NonNullable<UnitFragmentFragment['features']>)[number]>;
  export type Graphic = (NonNullable<NonNullable<(NonNullable<UnitFragmentFragment['features']>)[number]>['graphic']>);
  export type IconInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<UnitFragmentFragment['features']>)[number]>['graphic']>), { __typename: 'Icon' }>);
  export type MarkInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<UnitFragmentFragment['features']>)[number]>['graphic']>), { __typename: 'Mark' }>);
  export type _Graphic = (NonNullable<NonNullable<(NonNullable<UnitFragmentFragment['features']>)[number]>['graphic']>);
  export type MoreInfoDialog = (NonNullable<NonNullable<(NonNullable<UnitFragmentFragment['features']>)[number]>['moreInfoDialog']>);
  export type SpaceDetails = (NonNullable<UnitFragmentFragment['spaceDetails']>);
  export type _Header = (NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['header']>);
  export type FloorPlan = (NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['floorPlan']>);
  export type Images = NonNullable<(NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['floorPlan']>)['images']>)[number]>;
  export type Image = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['floorPlan']>)['images']>)[number]>['image']>);
  export type Toolbar = (NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['floorPlan']>)['toolbar']>);
  export type Trigger = (NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['floorPlan']>)['trigger']>);
  export type Spaces = NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['spaces']>)[number]>;
  export type Icons = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['spaceDetails']>)['spaces']>)[number]>['icons']>)[number]>;
  export type RoomAmenities = (NonNullable<UnitFragmentFragment['roomAmenities']>);
  export type __Header = (NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['header']>);
  export type BodySubSections = NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>;
  export type Contents = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>;
  export type ___Header = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['header']>);
  export type _Icon = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['header']>)['icon']>);
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['items']>)[number]>;
  export type PropertyContentItemMarkupInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['items']>)[number]>, { __typename: 'PropertyContentItemMarkup' }>);
  export type Content = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['roomAmenities']>)['bodySubSections']>)[number]>['contents']>)[number]>['items']>)[number]>, { __typename: 'PropertyContentItemMarkup' }>)['content']>);
  export type UnitGallery = (NonNullable<UnitFragmentFragment['unitGallery']>);
  export type _Images = NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['unitGallery']>)['images']>)[number]>;
  export type _Image = (NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['unitGallery']>)['images']>)[number]>['image']>);
  export type Thumbnail = (NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['unitGallery']>)['images']>)[number]>['thumbnail']>);
  export type FallbackImage = (NonNullable<NonNullable<(NonNullable<(NonNullable<UnitFragmentFragment['unitGallery']>)['images']>)[number]>['fallbackImage']>);
  export type AvailabilityCallToAction = (NonNullable<UnitFragmentFragment['availabilityCallToAction']>);
  export type LodgingPlainMessageInlineFragment = (DiscriminateUnion<(NonNullable<UnitFragmentFragment['availabilityCallToAction']>), { __typename: 'LodgingPlainMessage' }>);
  export type LodgingButtonInlineFragment = (DiscriminateUnion<(NonNullable<UnitFragmentFragment['availabilityCallToAction']>), { __typename: 'LodgingButton' }>);
}

export namespace CancellationPolicyFragment {
  export type Fragment = CancellationPolicyFragmentFragment;
}

export namespace DateFragment {
  export type Fragment = DateFragmentFragment;
}

export namespace RatePlanFragment {
  export type Fragment = RatePlanFragmentFragment;
  export type LoyaltyMessage = (NonNullable<RatePlanFragmentFragment['loyaltyMessage']>);
  export type Mark = (NonNullable<(NonNullable<RatePlanFragmentFragment['loyaltyMessage']>)['mark']>);
  export type EgdsMark = (NonNullable<(NonNullable<RatePlanFragmentFragment['loyaltyMessage']>)['egdsMark']>);
  export type Url = (NonNullable<(NonNullable<(NonNullable<RatePlanFragmentFragment['loyaltyMessage']>)['egdsMark']>)['url']>);
  export type HeaderMessage = (NonNullable<RatePlanFragmentFragment['headerMessage']>);
  export type PriceDetails = NonNullable<(NonNullable<RatePlanFragmentFragment['priceDetails']>)[number]>;
  export type Amenities = NonNullable<(NonNullable<RatePlanFragmentFragment['amenities']>)[number]>;
  export type Icon = (NonNullable<NonNullable<(NonNullable<RatePlanFragmentFragment['amenities']>)[number]>['icon']>);
  export type MarketingSection = (NonNullable<RatePlanFragmentFragment['marketingSection']>);
  export type OfferNotifications = (NonNullable<RatePlanFragmentFragment['offerNotifications']>);
  export type HighlightedMessages = NonNullable<(NonNullable<RatePlanFragmentFragment['highlightedMessages']>)[number]>;
  export type MarketingChannelMessage = (NonNullable<RatePlanFragmentFragment['marketingChannelMessage']>);
  export type _Mark = (NonNullable<(NonNullable<RatePlanFragmentFragment['marketingChannelMessage']>)['mark']>);
  export type Badge = (NonNullable<RatePlanFragmentFragment['badge']>);
  export type Icon_Temp = (NonNullable<(NonNullable<RatePlanFragmentFragment['badge']>)['icon_temp']>);
  export type EtpDialogTopMessage = (NonNullable<RatePlanFragmentFragment['etpDialogTopMessage']>);
  export type PaymentPolicy = NonNullable<(NonNullable<RatePlanFragmentFragment['paymentPolicy']>)[number]>;
  export type ReserveCallToAction = (NonNullable<RatePlanFragmentFragment['reserveCallToAction']>);
  export type EtpDialogInlineFragment = (DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'EtpDialog' }>);
  export type Trigger = (NonNullable<(DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'EtpDialog' }>)['trigger']>);
  export type Toolbar = (NonNullable<(DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'EtpDialog' }>)['toolbar']>);
  export type _Icon = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'EtpDialog' }>)['toolbar']>)['icon']>);
  export type LodgingFormInlineFragment = (DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'LodgingForm' }>);
  export type Inputs = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'LodgingForm' }>)['inputs']>)[number]>;
  export type LodgingTextInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'LodgingForm' }>)['inputs']>)[number]>, { __typename: 'LodgingTextInput' }>);
  export type Submit = (NonNullable<(DiscriminateUnion<(NonNullable<RatePlanFragmentFragment['reserveCallToAction']>), { __typename: 'LodgingForm' }>)['submit']>);
  export type ShareUrl = (NonNullable<RatePlanFragmentFragment['shareUrl']>);
  export type Link = (NonNullable<(NonNullable<RatePlanFragmentFragment['shareUrl']>)['link']>);
  export type Uri = (NonNullable<(NonNullable<(NonNullable<RatePlanFragmentFragment['shareUrl']>)['link']>)['uri']>);
}

export namespace PriceDetailsFragment {
  export type Fragment = PriceDetailsFragmentFragment;
  export type OptionTitle = (NonNullable<PriceDetailsFragmentFragment['optionTitle']>);
  export type Availability = (NonNullable<PriceDetailsFragmentFragment['availability']>);
  export type Price = (NonNullable<PriceDetailsFragmentFragment['price']>);
  export type Options = NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['options']>)[number]>;
  export type PriceMessaging = NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['priceMessaging']>)[number]>;
  export type Lead = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['lead']>);
  export type Disclaimer = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['disclaimer']>);
  export type StrikeOut = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['strikeOut']>);
  export type MarketingFeeDetails = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['marketingFeeDetails']>);
  export type MarketingFeeMessage = (NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['price']>)['marketingFeeDetails']>)['marketingFeeMessage']>);
  export type CancellationPolicy = (NonNullable<PriceDetailsFragmentFragment['cancellationPolicy']>);
  export type CancellationWindow = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['cancellationPolicy']>)['cancellationWindow']>);
  export type PriceBreakDownSummary = (NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>);
  export type PriceSummaryHeading = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['priceSummaryHeading']>);
  export type Sections = NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>;
  export type SectionHeading = (NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['sectionHeading']>);
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>;
  export type Name = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>['name']>);
  export type PrimaryMessage = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>['name']>)['primaryMessage']>);
  export type SecondaryMessages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>['name']>)['secondaryMessages']>)[number]>;
  export type Value = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>['value']>);
  export type _PrimaryMessage = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>['value']>)['primaryMessage']>);
  export type _SecondaryMessages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['items']>)[number]>['value']>)['secondaryMessages']>)[number]>;
  export type SectionFooter = (NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['sectionFooter']>);
  export type FooterHeading = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['sectionFooter']>)['footerHeading']>);
  export type FooterMessages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['sections']>)[number]>['sectionFooter']>)['footerMessages']>)[number]>;
  export type Disclaimers = NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['priceBreakDownSummary']>)['disclaimers']>)[number]>;
  export type DataAttributes = (NonNullable<PriceDetailsFragmentFragment['dataAttributes']>);
  export type FeeMessages = NonNullable<(NonNullable<PriceDetailsFragmentFragment['feeMessages']>)[number]>;
  export type LoyaltyMessage = (NonNullable<PriceDetailsFragmentFragment['loyaltyMessage']>);
  export type OfferBookButton = (NonNullable<PriceDetailsFragmentFragment['offerBookButton']>);
  export type Inputs = NonNullable<(NonNullable<(NonNullable<PriceDetailsFragmentFragment['offerBookButton']>)['inputs']>)[number]>;
  export type Submit = (NonNullable<(NonNullable<PriceDetailsFragmentFragment['offerBookButton']>)['submit']>);
  export type Deposit = (NonNullable<PriceDetailsFragmentFragment['deposit']>);
  export type PropertyNaturalKeys = NonNullable<(NonNullable<PriceDetailsFragmentFragment['propertyNaturalKeys']>)[number]>;
}

export namespace PropertyNaturalKeyFragment {
  export type Fragment = PropertyNaturalKeyFragmentFragment;
  export type CheckIn = (NonNullable<PropertyNaturalKeyFragmentFragment['checkIn']>);
  export type CheckOut = (NonNullable<PropertyNaturalKeyFragmentFragment['checkOut']>);
  export type Rooms = NonNullable<(NonNullable<PropertyNaturalKeyFragmentFragment['rooms']>)[number]>;
}

export namespace ButtonFragment {
  export type Fragment = ButtonFragmentFragment;
  export type Analytics = (NonNullable<ButtonFragmentFragment['analytics']>);
}

export namespace IconFragment {
  export type Fragment = IconFragmentFragment;
}

export namespace MarkFragment {
  export type Fragment = MarkFragmentFragment;
}

export namespace MarketingSectionFragment {
  export type Fragment = MarketingSectionFragmentFragment;
  export type Title = (NonNullable<MarketingSectionFragmentFragment['title']>);
  export type FeeDetails = (NonNullable<MarketingSectionFragmentFragment['feeDetails']>);
  export type MarketingFeeMessage = (NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDetails']>)['marketingFeeMessage']>);
  export type Mark = (NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDetails']>)['mark']>);
  export type TierMessage = (NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDetails']>)['tierMessage']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDetails']>)['tierMessage']>)['icon']>);
  export type _Mark = (NonNullable<(NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDetails']>)['tierMessage']>)['mark']>);
  export type FeeDialog = (NonNullable<MarketingSectionFragmentFragment['feeDialog']>);
  export type TertiaryUiButton = (NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDialog']>)['tertiaryUIButton']>);
  export type Trigger = (NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDialog']>)['trigger']>);
  export type __Mark = (NonNullable<(NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDialog']>)['trigger']>)['mark']>);
  export type _Icon = (NonNullable<(NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDialog']>)['trigger']>)['icon']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<(NonNullable<MarketingSectionFragmentFragment['feeDialog']>)['trigger']>)['clientSideAnalytics']>);
  export type PaymentDetails = (NonNullable<MarketingSectionFragmentFragment['paymentDetails']>);
  export type __Icon = (NonNullable<(NonNullable<MarketingSectionFragmentFragment['paymentDetails']>)['icon']>);
}

export namespace LodgingTextInput {
  export type Fragment = LodgingTextInputFragment;
}

export namespace PaymentPolicyFragment {
  export type Fragment = PaymentPolicyFragmentFragment;
  export type Descriptions = NonNullable<(NonNullable<PaymentPolicyFragmentFragment['descriptions']>)[number]>;
  export type Items = NonNullable<(NonNullable<NonNullable<(NonNullable<PaymentPolicyFragmentFragment['descriptions']>)[number]>['items']>)[number]>;
}

export namespace OptionFragment {
  export type Fragment = OptionFragmentFragment;
  export type Disclaimer = (NonNullable<OptionFragmentFragment['disclaimer']>);
  export type PriceDisclaimer = (NonNullable<OptionFragmentFragment['priceDisclaimer']>);
  export type DisplayPrice = (NonNullable<OptionFragmentFragment['displayPrice']>);
  export type LoyaltyPrice = (NonNullable<OptionFragmentFragment['loyaltyPrice']>);
  export type Amount = (NonNullable<(NonNullable<OptionFragmentFragment['loyaltyPrice']>)['amount']>);
  export type TotalStrikeOutPoints = (NonNullable<(NonNullable<OptionFragmentFragment['loyaltyPrice']>)['totalStrikeOutPoints']>);
  export type StrikeOut = (NonNullable<OptionFragmentFragment['strikeOut']>);
}

export namespace LodgingEnrichedMessageFragment {
  export type Fragment = LodgingEnrichedMessageFragmentFragment;
  export type Icon = (NonNullable<LodgingEnrichedMessageFragmentFragment['icon']>);
  export type Mark = (NonNullable<LodgingEnrichedMessageFragmentFragment['mark']>);
}

export namespace LodgingPlainMessageFragment {
  export type Fragment = LodgingPlainMessageFragmentFragment;
}

export namespace LodgingPlainDialogFragment {
  export type Fragment = LodgingPlainDialogFragmentFragment;
  export type PrimaryButton = (NonNullable<LodgingPlainDialogFragmentFragment['primaryButton']>);
  export type SecondaryButton = (NonNullable<LodgingPlainDialogFragmentFragment['secondaryButton']>);
  export type TertiaryButton = (NonNullable<LodgingPlainDialogFragmentFragment['tertiaryButton']>);
  export type PrimaryUiButton = (NonNullable<LodgingPlainDialogFragmentFragment['primaryUIButton']>);
  export type SecondaryUiButton = (NonNullable<LodgingPlainDialogFragmentFragment['secondaryUIButton']>);
  export type Toolbar = (NonNullable<LodgingPlainDialogFragmentFragment['toolbar']>);
  export type Trigger = (NonNullable<LodgingPlainDialogFragmentFragment['trigger']>);
}

export namespace UiPrimaryButtonFragment {
  export type Fragment = UiPrimaryButtonFragmentFragment;
  export type Action = (NonNullable<UiPrimaryButtonFragmentFragment['action']>);
  export type Analytics = (NonNullable<(NonNullable<UiPrimaryButtonFragmentFragment['action']>)['analytics']>);
  export type UiLinkActionInlineFragment = (DiscriminateUnion<(NonNullable<UiPrimaryButtonFragmentFragment['action']>), { __typename: 'UILinkAction' }>);
  export type Resource = (NonNullable<(DiscriminateUnion<(NonNullable<UiPrimaryButtonFragmentFragment['action']>), { __typename: 'UILinkAction' }>)['resource']>);
}

export namespace LodgingPlainFullscreenDialogFragment {
  export type Fragment = LodgingPlainFullscreenDialogFragmentFragment;
  export type Trigger = (NonNullable<LodgingPlainFullscreenDialogFragmentFragment['trigger']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<LodgingPlainFullscreenDialogFragmentFragment['trigger']>)['clientSideAnalytics']>);
  export type Icon = (NonNullable<(NonNullable<LodgingPlainFullscreenDialogFragmentFragment['trigger']>)['icon']>);
  export type Toolbar = (NonNullable<LodgingPlainFullscreenDialogFragmentFragment['toolbar']>);
  export type _Icon = (NonNullable<(NonNullable<LodgingPlainFullscreenDialogFragmentFragment['toolbar']>)['icon']>);
  export type _ClientSideAnalytics = (NonNullable<(NonNullable<LodgingPlainFullscreenDialogFragmentFragment['toolbar']>)['clientSideAnalytics']>);
}

export namespace LodgingDialogToolbarFragment {
  export type Fragment = LodgingDialogToolbarFragmentFragment;
  export type Icon = (NonNullable<LodgingDialogToolbarFragmentFragment['icon']>);
  export type ClientSideAnalytics = (NonNullable<LodgingDialogToolbarFragmentFragment['clientSideAnalytics']>);
}

export namespace LodgingDialogTriggerMessageFragment {
  export type Fragment = LodgingDialogTriggerMessageFragmentFragment;
  export type ClientSideAnalytics = (NonNullable<LodgingDialogTriggerMessageFragmentFragment['clientSideAnalytics']>);
  export type Icon = (NonNullable<LodgingDialogTriggerMessageFragmentFragment['icon']>);
}

export namespace ClientSideAnalyticsFragment {
  export type Fragment = ClientSideAnalyticsFragmentFragment;
}

export namespace MoneyFragment {
  export type Fragment = MoneyFragmentFragment;
  export type CurrencyInfo = (NonNullable<MoneyFragmentFragment['currencyInfo']>);
}

export namespace CurrencyFragment {
  export type Fragment = CurrencyFragmentFragment;
}

export namespace AlternateDateOptionFragment {
  export type Fragment = AlternateDateOptionFragmentFragment;
  export type Dates = (NonNullable<AlternateDateOptionFragmentFragment['dates']>);
  export type Link = (NonNullable<(NonNullable<AlternateDateOptionFragmentFragment['dates']>)['link']>);
  export type Uri = (NonNullable<(NonNullable<(NonNullable<AlternateDateOptionFragmentFragment['dates']>)['link']>)['uri']>);
  export type Price = (NonNullable<AlternateDateOptionFragmentFragment['price']>);
  export type DisplayPrice = (NonNullable<(NonNullable<AlternateDateOptionFragmentFragment['price']>)['displayPrice']>);
}

export namespace TripSummaryFragment {
  export type Fragment = TripSummaryFragmentFragment;
  export type Header = (NonNullable<TripSummaryFragmentFragment['header']>);
  export type Summary = NonNullable<(NonNullable<TripSummaryFragmentFragment['summary']>)[number]>;
  export type Price = (NonNullable<TripSummaryFragmentFragment['price']>);
  export type Options = NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>;
  export type DisplayPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['displayPrice']>);
  export type StrikeOut = (NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['strikeOut']>);
  export type PriceDisclaimer = (NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['priceDisclaimer']>);
  export type TertiaryUiButton = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['priceDisclaimer']>)['tertiaryUIButton']>);
  export type Action = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['priceDisclaimer']>)['tertiaryUIButton']>)['action']>);
  export type Analytics = (NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['priceDisclaimer']>)['tertiaryUIButton']>)['action']>)['analytics']>);
  export type Trigger = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['priceDisclaimer']>)['trigger']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['options']>)[number]>['priceDisclaimer']>)['trigger']>)['clientSideAnalytics']>);
  export type PriceMessaging = NonNullable<(NonNullable<(NonNullable<TripSummaryFragmentFragment['price']>)['priceMessaging']>)[number]>;
}

export namespace SingleOfferFragment {
  export type Fragment = SingleOfferFragmentFragment;
  export type AvailabilityCallToAction = (NonNullable<SingleOfferFragmentFragment['availabilityCallToAction']>);
  export type LodgingPlainMessageInlineFragment = (DiscriminateUnion<(NonNullable<SingleOfferFragmentFragment['availabilityCallToAction']>), { __typename: 'LodgingPlainMessage' }>);
  export type LodgingButtonInlineFragment = (DiscriminateUnion<(NonNullable<SingleOfferFragmentFragment['availabilityCallToAction']>), { __typename: 'LodgingButton' }>);
  export type DisplayPrice = (NonNullable<SingleOfferFragmentFragment['displayPrice']>);
  export type LeadPrice = (NonNullable<(NonNullable<SingleOfferFragmentFragment['displayPrice']>)['leadPrice']>);
  export type PriceLabel = (NonNullable<(NonNullable<SingleOfferFragmentFragment['displayPrice']>)['priceLabel']>);
  export type PriceMessages = NonNullable<(NonNullable<(NonNullable<SingleOfferFragmentFragment['displayPrice']>)['priceMessages']>)[number]>;
  export type RatePlans = NonNullable<(NonNullable<SingleOfferFragmentFragment['ratePlans']>)[number]>;
  export type TotalPrice = (NonNullable<SingleOfferFragmentFragment['totalPrice']>);
  export type Amount = (NonNullable<(NonNullable<SingleOfferFragmentFragment['totalPrice']>)['amount']>);
  export type Label = (NonNullable<(NonNullable<SingleOfferFragmentFragment['totalPrice']>)['label']>);
}

export namespace PriceDisplayFragment {
  export type Fragment = PriceDisplayFragmentFragment;
  export type DisplayMessages = NonNullable<(NonNullable<PriceDisplayFragmentFragment['displayMessages']>)[number]>;
  export type LineItems = NonNullable<(NonNullable<NonNullable<(NonNullable<PriceDisplayFragmentFragment['displayMessages']>)[number]>['lineItems']>)[number]>;
  export type LodgingEnrichedMessageInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<PriceDisplayFragmentFragment['displayMessages']>)[number]>['lineItems']>)[number]>, { __typename: 'LodgingEnrichedMessage' }>);
}

export namespace PriceMessageFragment {
  export type Fragment = PriceMessageFragmentFragment;
  export type Price = (NonNullable<PriceMessageFragmentFragment['price']>);
  export type Disclaimer = (NonNullable<PriceMessageFragmentFragment['disclaimer']>);
  export type PrimaryUiButton = (NonNullable<(NonNullable<PriceMessageFragmentFragment['disclaimer']>)['primaryUIButton']>);
}

export namespace PricePresentationDialogFragment {
  export type Fragment = PricePresentationDialogFragmentFragment;
  export type PricePresentationDialog = (NonNullable<PricePresentationDialogFragmentFragment['pricePresentationDialog']>);
  export type Toolbar = (NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentationDialog']>)['toolbar']>);
  export type Icon = (NonNullable<(NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentationDialog']>)['toolbar']>)['icon']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentationDialog']>)['toolbar']>)['clientSideAnalytics']>);
  export type Trigger = (NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentationDialog']>)['trigger']>);
  export type _ClientSideAnalytics = (NonNullable<(NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentationDialog']>)['trigger']>)['clientSideAnalytics']>);
  export type PricePresentation = (NonNullable<PricePresentationDialogFragmentFragment['pricePresentation']>);
  export type Title = (NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentation']>)['title']>);
  export type Sections = NonNullable<(NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentation']>)['sections']>)[number]>;
  export type Footer = (NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentation']>)['footer']>);
  export type Messages = NonNullable<(NonNullable<(NonNullable<(NonNullable<PricePresentationDialogFragmentFragment['pricePresentation']>)['footer']>)['messages']>)[number]>;
}

export namespace PricePresentationSectionFragment {
  export type Fragment = PricePresentationSectionFragmentFragment;
  export type Header = (NonNullable<PricePresentationSectionFragmentFragment['header']>);
  export type Name = (NonNullable<(NonNullable<PricePresentationSectionFragmentFragment['header']>)['name']>);
  export type EnrichedValue = (NonNullable<(NonNullable<PricePresentationSectionFragmentFragment['header']>)['enrichedValue']>);
  export type SubSections = NonNullable<(NonNullable<PricePresentationSectionFragmentFragment['subSections']>)[number]>;
}

export namespace PriceLineTextFragment {
  export type Fragment = PriceLineTextFragmentFragment;
  export type AdditionalInfo = (NonNullable<PriceLineTextFragmentFragment['additionalInfo']>);
  export type Icon = (NonNullable<PriceLineTextFragmentFragment['icon']>);
}

export namespace PriceLineHeadingFragment {
  export type Fragment = PriceLineHeadingFragmentFragment;
  export type AdditionalInfo = (NonNullable<PriceLineHeadingFragmentFragment['additionalInfo']>);
  export type Icon = (NonNullable<PriceLineHeadingFragmentFragment['icon']>);
}

export namespace PricePresentationLineItemEntryFragment {
  export type Fragment = PricePresentationLineItemEntryFragmentFragment;
  export type PrimaryMessage = (NonNullable<PricePresentationLineItemEntryFragmentFragment['primaryMessage']>);
  export type SecondaryMessages = NonNullable<(NonNullable<PricePresentationLineItemEntryFragmentFragment['secondaryMessages']>)[number]>;
}

export namespace PricePresentationSubSectionFragment {
  export type Fragment = PricePresentationSubSectionFragmentFragment;
  export type Header = (NonNullable<PricePresentationSubSectionFragmentFragment['header']>);
  export type Name = (NonNullable<(NonNullable<PricePresentationSubSectionFragmentFragment['header']>)['name']>);
  export type PrimaryMessage = (NonNullable<(NonNullable<(NonNullable<PricePresentationSubSectionFragmentFragment['header']>)['name']>)['primaryMessage']>);
  export type PriceLineTextInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<PricePresentationSubSectionFragmentFragment['header']>)['name']>)['primaryMessage']>), { __typename: 'PriceLineText' }>);
  export type PriceLineHeadingInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<PricePresentationSubSectionFragmentFragment['header']>)['name']>)['primaryMessage']>), { __typename: 'PriceLineHeading' }>);
  export type EnrichedValue = (NonNullable<(NonNullable<PricePresentationSubSectionFragmentFragment['header']>)['enrichedValue']>);
  export type Items = NonNullable<(NonNullable<PricePresentationSubSectionFragmentFragment['items']>)[number]>;
}

export namespace PricePresentationLineItemFragment {
  export type Fragment = PricePresentationLineItemFragmentFragment;
  export type EnrichedValue = (NonNullable<PricePresentationLineItemFragmentFragment['enrichedValue']>);
  export type Name = (NonNullable<PricePresentationLineItemFragmentFragment['name']>);
}

export namespace AdditionalInformationPopoverFragment {
  export type Fragment = AdditionalInformationPopoverFragmentFragment;
  export type Icon = (NonNullable<AdditionalInformationPopoverFragmentFragment['icon']>);
  export type Analytics = (NonNullable<AdditionalInformationPopoverFragmentFragment['analytics']>);
  export type EnrichedSecondaries = NonNullable<(NonNullable<AdditionalInformationPopoverFragmentFragment['enrichedSecondaries']>)[number]>;
}

export namespace AdditionalInformationPopoverSectionFragment {
  export type Fragment = AdditionalInformationPopoverSectionFragmentFragment;
  export type AdditionalInformationPopoverTextSectionInlineFragment = (DiscriminateUnion<AdditionalInformationPopoverSectionFragmentFragment, { __typename: 'AdditionalInformationPopoverTextSection' }>);
  export type AdditionalInformationPopoverListSectionInlineFragment = (DiscriminateUnion<AdditionalInformationPopoverSectionFragmentFragment, { __typename: 'AdditionalInformationPopoverListSection' }>);
}

export namespace AdditionalInformationPopoverTextSectionFragment {
  export type Fragment = AdditionalInformationPopoverTextSectionFragmentFragment;
  export type Text = (NonNullable<AdditionalInformationPopoverTextSectionFragmentFragment['text']>);
}

export namespace AdditionalInformationPopoverListSectionFragment {
  export type Fragment = AdditionalInformationPopoverListSectionFragmentFragment;
  export type Content = (NonNullable<AdditionalInformationPopoverListSectionFragmentFragment['content']>);
  export type Items = NonNullable<(NonNullable<(NonNullable<AdditionalInformationPopoverListSectionFragmentFragment['content']>)['items']>)[number]>;
}

export namespace PropertyRateCalendar {
  export type Variables = PropertyRateCalendarQueryVariables;
  export type Query = PropertyRateCalendarQuery;
  export type PropertySearch = (NonNullable<PropertyRateCalendarQuery['propertySearch']>);
  export type RateCalendar = (NonNullable<(NonNullable<PropertyRateCalendarQuery['propertySearch']>)['rateCalendar']>);
  export type Disclaimer = (NonNullable<(NonNullable<(NonNullable<PropertyRateCalendarQuery['propertySearch']>)['rateCalendar']>)['disclaimer']>);
  export type Legend = NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyRateCalendarQuery['propertySearch']>)['rateCalendar']>)['legend']>)[number]>;
  export type PropertyCalendarPriceTrendLegendInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyRateCalendarQuery['propertySearch']>)['rateCalendar']>)['legend']>)[number]>, { __typename: 'PropertyCalendarPriceTrendLegend' }>);
  export type PropertyCalendarRates = NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyRateCalendarQuery['propertySearch']>)['rateCalendar']>)['propertyCalendarRates']>)[number]>;
  export type Date = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PropertyRateCalendarQuery['propertySearch']>)['rateCalendar']>)['propertyCalendarRates']>)[number]>['date']>);
}

export namespace PropertySearchTravelAds {
  export type Variables = PropertySearchTravelAdsQueryVariables;
  export type Query = PropertySearchTravelAdsQuery;
  export type PropertySearch = (NonNullable<PropertySearchTravelAdsQuery['propertySearch']>);
  export type Properties = NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>;
  export type Amenities = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['amenities']>)[number]>;
  export type PropertyImage = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['propertyImage']>);
  export type Image = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['propertyImage']>)['image']>);
  export type FallbackImage = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['propertyImage']>)['fallbackImage']>);
  export type OfferBadge = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerBadge']>);
  export type Primary = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerBadge']>)['primary']>);
  export type Icon_Temp = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerBadge']>)['primary']>)['icon_temp']>);
  export type Mark = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerBadge']>)['primary']>)['mark']>);
  export type Secondary = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerBadge']>)['secondary']>);
  export type _Icon_Temp = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerBadge']>)['secondary']>)['icon_temp']>);
  export type Price = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>);
  export type DisplayMessages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>;
  export type LineItems = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>;
  export type DisplayPriceInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>, { __typename: 'DisplayPrice' }>);
  export type _Price = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>, { __typename: 'DisplayPrice' }>)['price']>);
  export type Disclaimer = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>, { __typename: 'DisplayPrice' }>)['disclaimer']>);
  export type PrimaryUiButton = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>, { __typename: 'DisplayPrice' }>)['disclaimer']>)['primaryUIButton']>);
  export type LodgingEnrichedMessageInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['displayMessages']>)[number]>['lineItems']>)[number]>, { __typename: 'LodgingEnrichedMessage' }>);
  export type Lead = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['lead']>);
  export type StrikeOut = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['strikeOut']>);
  export type _Disclaimer = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['disclaimer']>);
  export type PriceMessages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['priceMessages']>)[number]>;
  export type MarketingFeeDetails = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['marketingFeeDetails']>);
  export type MarketingFeeMessage = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['marketingFeeDetails']>)['marketingFeeMessage']>);
  export type Options = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>;
  export type DisplayPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>['displayPrice']>);
  export type _StrikeOut = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>['strikeOut']>);
  export type LoyaltyPrice = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>['loyaltyPrice']>);
  export type Amount = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>['loyaltyPrice']>)['amount']>);
  export type TotalStrikeOutPoints = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>['loyaltyPrice']>)['totalStrikeOutPoints']>);
  export type __Disclaimer = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['price']>)['options']>)[number]>['disclaimer']>);
  export type Reviews = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['reviews']>);
  export type LocalizedSubtitleA11y = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['reviews']>)['localizedSubtitleA11y']>);
  export type DestinationInfo = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['destinationInfo']>);
  export type PropertyDetailsLink = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['propertyDetailsLink']>);
  export type Uri = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['propertyDetailsLink']>)['uri']>);
  export type ClientSideAnalytics = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['propertyDetailsLink']>)['clientSideAnalytics']>);
  export type Availability = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['availability']>);
  export type OfferSummary = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerSummary']>);
  export type Messages = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerSummary']>)['messages']>)[number]>;
  export type _Mark = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['offerSummary']>)['messages']>)[number]>['mark']>);
  export type LegalDisclaimer = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['legalDisclaimer']>);
  export type Neighborhood = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['neighborhood']>);
  export type RecentlyViewed = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['recentlyViewed']>);
  export type ShortList = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['shortList']>);
  export type MetaData = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['shortList']>)['metaData']>);
  export type SponsoredListing = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['sponsoredListing']>);
  export type DataAttributes = (NonNullable<NonNullable<(NonNullable<(NonNullable<PropertySearchTravelAdsQuery['propertySearch']>)['properties']>)[number]>['dataAttributes']>);
}

export namespace RemoveItemFromCart {
  export type Variables = RemoveItemFromCartMutationVariables;
  export type Mutation = RemoveItemFromCartMutation;
  export type CartItems = (NonNullable<RemoveItemFromCartMutation['cartItems']>);
  export type Remove = (NonNullable<(NonNullable<RemoveItemFromCartMutation['cartItems']>)['remove']>);
}

export namespace SelectProducts {
  export type Variables = SelectProductsMutationVariables;
  export type Mutation = SelectProductsMutation;
  export type MultiItemShopping = (NonNullable<SelectProductsMutation['multiItemShopping']>);
  export type SelectProducts = (NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>);
  export type MultiItemSearchContextCreatedResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>);
  export type ShoppingContext = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>);
  export type MultiItem = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextCreatedResponse' }>)['shoppingContext']>)['multiItem']>);
  export type MultiItemSearchContextErrorResponseInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SelectProductsMutation['multiItemShopping']>)['selectProducts']>), { __typename: 'MultiItemSearchContextErrorResponse' }>);
}
